export const localUiClientJs = `
const app = document.getElementById('vr-app');
const stateEl = document.getElementById('vr-state');
const currentState = JSON.parse(stateEl.textContent || '{}');
let missionCards = currentState.missionCards || null;

const demo = {
  activeNavId: 'flow',
  selectedProviderId: 'supabase',
  selectedReleaseId: 'v1.3.0',
  activeStepId: 'agent',
  agentFixing: false,
  verified: false,
  notice: '',
  providerPickerOpen: false,
  activeModal: null,
  activeStudioTab: 'chat',
  selectedCliId: 'codex',
  cliConnected: false,
  cliSetupComplete: false,
  cliConnectTargetId: null,
  cliLastConnectTargetId: null,
  cliProbeStatus: 'idle',
  cliProbeMessage: '',
  simulateFresh: false,
  cliAgentsHydrated: false,
  cliTerminalLines: [],
  cliTerminalTitle: '',
  cliTerminalDraft: '',
  cliConnectCompleteAgentId: null,
  cliSessionReady: {},
  studioExpanded: false,
  activeChatCount: 1,
  selectedModelId: 'gpt-5.5',
  selectedReasoning: 'High',
  selectedContext: 'Production',
  selectedAccessMode: 'approve',
  modelMenuOpen: false,
  reasoningMenuOpen: false,
  contextMenuOpen: false,
  scopeMenuOpen: false,
  contextTrayOpen: false,
  accessMenuOpen: false,
  inspectorExpanded: false,
  pickerChatIndex: 0,
  handCollapsed: false,
  addProviderOpen: false,
  connectCardId: null,
  mcpConnecting: null,
  mcpConnectMessage: '',
  pileCollapsed: false,
  pileOffset: 0,
  flippedCards: {},
  tablePlacements: readTablePlacements(),
  chatsFlyoutOpen: false,
  chatContexts: [{ providerId: null, releaseId: null, cliId: 'codex', modelId: 'gpt-5.5', reasoning: 'High', context: 'Production', accessMode: 'approve', messages: [], activeTask: null }],
  activeRecentChatId: null,
  droppedProviderId: null,
  dragKind: null,
  dragProviderId: null,
  dragReleaseId: null,
  dragChatId: null,
  dropActive: false,
  droppedReleaseId: null,
  fixPlanExpandedChatIndex: null,
  releaseDiff: { text: '', from: '', to: '', fromLabel: '', toLabel: '', stats: null, loading: false, error: '' },
  releaseChangelog: { entries: [], from: '', to: '', fromLabel: '', toLabel: '', loading: false, error: '' },
};

function readTablePlacements() {
  try {
    const raw = window.localStorage.getItem('vrTablePlacements');
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch { return {}; }
}

function saveTablePlacements() {
  try { window.localStorage.setItem('vrTablePlacements', JSON.stringify(demo.tablePlacements || {})); } catch { /* ignore */ }
}

function readCliSessionReady() {
  try {
    let raw = localStorage.getItem('viberaven-cli-ready');
    if (!raw) {
      raw = sessionStorage.getItem('viberaven-cli-ready');
      if (raw) localStorage.setItem('viberaven-cli-ready', raw);
    }
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function writeCliSessionReady(value) {
  try {
    localStorage.setItem('viberaven-cli-ready', JSON.stringify(value || {}));
  } catch {
    // Ignore storage failures in preview shells.
  }
}

demo.cliSessionReady = readCliSessionReady();

function cliAgentInstalled(agent) {
  if (!agent) return false;
  if (agent.id === 'terminal') return true;
  if (agent.installed === true) return true;
  return agent.connected !== false;
}

function cliAgentReady(agentId) {
  return demo.cliSessionReady[agentId] === true;
}

function markCliSessionReady(agentId) {
  if (!agentId || agentId === 'terminal') return;
  demo.cliSessionReady[agentId] = true;
  writeCliSessionReady(demo.cliSessionReady);
}

function setConnectTarget(agentId) {
  if (!agentId || agentId === 'terminal') return;
  demo.cliConnectTargetId = agentId;
  demo.cliLastConnectTargetId = agentId;
}

function terminalTargetId() {
  const target = demo.cliConnectTargetId || demo.cliLastConnectTargetId;
  if (target && target !== 'terminal') return target;
  const coding = cliAgents.find((agent) => agent.id !== 'terminal');
  return coding?.id || demo.selectedCliId || 'codex';
}

function shouldShowConnectToolbar() {
  const targetId = terminalTargetId();
  if (!targetId || targetId === 'terminal') return !demo.cliSetupComplete;
  if (!demo.cliSetupComplete) return true;
  return !cliAgentReady(targetId);
}

function terminalStatusLabel(targetId) {
  const agent = cliAgents.find((item) => item.id === targetId);
  if (demo.cliProbeStatus === 'probing') return 'verifying…';
  if (demo.cliProbeStatus === 'failed') return 'verify failed — sign in and test again';
  if (cliAgentReady(targetId)) return 'ready for chat';
  if (agent && cliAgentInstalled(agent)) return 'installed — sign in required';
  return 'not installed';
}

function terminalConnectTitle(agent) {
  const targetId = agent?.id || terminalTargetId();
  if (!demo.cliSetupComplete || !cliAgentReady(targetId)) {
    return 'Connect ' + (agent?.label || targetId);
  }
  return demo.cliTerminalTitle || agent?.label || targetId;
}

const providerAssets = {
  supabase: '/report/assets/provider-supabase.png',
  vercel: '/report/assets/provider-vercel.png',
  stripe: '/report/assets/provider-stripe.png',
  github: '/report/assets/provider-github.png',
  sentry: '/report/assets/provider-sentry.png',
  posthog: '/report/assets/provider-posthog.png',
  clerk: '/report/assets/provider-clerk.png',
  authjs: '/report/assets/provider-clerk.png',
  resend: '/report/assets/provider-resend.png',
  upstash: '/report/assets/provider-upstash.png',
};

const providerMarkAssets = {
  supabase: '/report/assets/provider-supabase-mark.svg',
  vercel: '/report/assets/provider-vercel-mark.svg',
  stripe: '/report/assets/provider-stripe-mark.svg',
  github: '/report/assets/provider-github-mark.svg',
  sentry: '/report/assets/provider-sentry-mark.svg',
  posthog: '/report/assets/provider-posthog-mark.svg',
  clerk: '/report/assets/provider-clerk-mark.svg',
  authjs: '/report/assets/provider-clerk-mark.svg',
  resend: '/report/assets/provider-resend-mark.svg',
  upstash: '/report/assets/provider-upstash-mark.svg',
};

const mascotAssets = {
  idle: '/manga/raven-mark.png?v=manga1',
  fixing: '/manga/raven-mark.png?v=manga1',
  verified: '/manga/raven-mark.png?v=manga1',
  alert: '/manga/raven-mark.png?v=manga1',
};

const providerDashboardUrls = {
  supabase: 'https://supabase.com/dashboard/projects',
  vercel: 'https://vercel.com/dashboard',
  stripe: 'https://dashboard.stripe.com',
  github: 'https://github.com/new',
  sentry: 'https://sentry.io',
  posthog: 'https://app.posthog.com',
  clerk: 'https://dashboard.clerk.com',
  authjs: 'https://authjs.dev',
  resend: 'https://resend.com/emails',
  upstash: 'https://console.upstash.com',
};

const publicGithubUrl = 'https://github.com/ohad6k/VibeRaven';
const publicGithubApiUrl = 'https://api.github.com/repos/ohad6k/VibeRaven';
const docsUrl = 'https://viberaven.dev';
const communityUrl = 'https://github.com/ohad6k/VibeRaven/discussions/7';
const goLiveUrls = {
  githubLogin: 'https://github.com/login',
  githubNew: 'https://github.com/new',
  githubCliAuth: 'https://cli.github.com/manual/gh_auth_login',
  vercelLogin: 'https://vercel.com/login',
  vercelNew: 'https://vercel.com/new',
  vercelDashboard: 'https://vercel.com/dashboard',
};

const githubStats = {
  loading: false,
  loaded: false,
  error: false,
  stars: 0,
  forks: 0,
  issues: 0,
};

let lastRenderedModal = demo.activeModal;
let stableModalRender = false;
const chatScrollCache = {};
let chatTaskTimer = null;

function providerTone(state, status) {
  const text = String(status || '').toLowerCase();
  if (state === 'live_verified' || text.includes('connected') || text.includes('verified')) return 'green';
  if (state === 'needs_repo_fix' || state === 'blocked' || text.includes('fix') || text.includes('blocked')) return 'red';
  if (state === 'repo_evidence_found' || text.includes('detected')) return 'green';
  if (state === 'requires_user_action' || state === 'connect_live') return 'orange';
  return 'neutral';
}

function providerChecks(provider) {
  const items = Array.isArray(provider.launchPath) ? provider.launchPath : [];
  if (!items.length) return provider.state === 'not_detected' ? '0/0' : '1/1';
  const ready = items.filter((item) => item.state === 'ready').length;
  return ready + '/' + items.length;
}

const providerScopeHints = {
  supabase: ['supabase'],
  vercel: ['vercel'],
  stripe: ['stripe'],
  github: ['github'],
  sentry: ['sentry'],
  posthog: ['posthog'],
  clerk: ['clerk'],
  authjs: ['auth.js', 'authjs', 'next-auth', 'nextauth'],
  resend: ['resend'],
  upstash: ['upstash'],
};

function providerTextMentionsOthers(text, providerId) {
  const lower = String(text || '').toLowerCase();
  if (!lower.trim()) return false;
  return Object.keys(providerScopeHints).some((id) => {
    if (id === providerId) return false;
    return (providerScopeHints[id] || [id]).some((hint) => lower.includes(hint));
  });
}

function providerScopedDetail(provider) {
  const name = provider.name || 'Provider';
  const area = provider.area || 'Production';
  if (provider.state === 'not_detected') {
    return name + ' is not linked in this project yet. Drag it into chat or ask the agent to connect.';
  }
  const launchPath = Array.isArray(provider.launchPath) ? provider.launchPath : [];
  const blocked = launchPath.find((item) => item.state === 'blocked' || item.state === 'needs_fix');
  if (blocked) {
    return name + ': ' + blocked.title + '. ' + (blocked.shortReason || 'Complete this step before launch.');
  }
  if (provider.nextFix?.whatToChange && !providerTextMentionsOthers(provider.nextFix.whatToChange, provider.id)) {
    return provider.nextFix.whatToChange;
  }
  if (provider.cockpit?.action?.whyThisMatters && !providerTextMentionsOthers(provider.cockpit.action.whyThisMatters, provider.id)) {
    return provider.cockpit.action.whyThisMatters;
  }
  if (provider.nextFix?.title && !providerTextMentionsOthers(provider.nextFix.title, provider.id)) {
    return provider.nextFix.title + ' for ' + name + '.';
  }
  const ready = launchPath.filter((item) => item.state === 'ready').length;
  const total = launchPath.length || 1;
  if (ready >= total && provider.state === 'live_verified') {
    return name + ' live proof is verified. Review the launch path before shipping.';
  }
  if (ready >= total) {
    return name + ' repo evidence looks complete. Finish dashboard proof and verify before launch.';
  }
  if (ready > 0) {
    return name + ' has partial repo evidence (' + ready + '/' + total + ' checks). Ask the agent for the next ' + name + ' step.';
  }
  return area + ' slot for ' + name + '. Drag into chat for a scoped production check.';
}

function providerDetail(provider) {
  return providerScopedDetail(provider);
}

function launchPathCheckState(item) {
  if (item.state === 'ready') return 'done';
  if (item.state === 'blocked' || item.state === 'needs_fix') return 'active';
  return 'pending';
}

function launchPathStatusText(item) {
  if (item.state === 'ready') return 'OK';
  if (item.state === 'blocked') return 'Blocked';
  if (item.state === 'needs_fix') return 'Needs fix';
  if (item.state === 'not_checked') return 'Not checked';
  return 'Pending';
}

function providerModalCheckRows(raw) {
  const launchPath = Array.isArray(raw?.launchPath) ? raw.launchPath : [];
  const proofChecks = raw?.cockpit?.proof?.checks || [];
  const rows = [];
  if (launchPath.length) {
    launchPath.forEach((item) => {
      rows.push({
        label: item.title,
        caption: item.shortReason || item.detail || 'Launch path check for ' + (raw?.name || 'provider') + '.',
        state: launchPathCheckState(item),
        status: launchPathStatusText(item),
      });
    });
  } else {
    const detected = raw?.state !== 'not_detected';
    rows.push({
      label: 'Repo evidence',
      caption: detected ? 'Code evidence found for ' + raw.name + '.' : raw.name + ' not detected in this project.',
      state: detected ? 'done' : 'pending',
      status: detected ? 'Found' : 'Missing',
    });
  }
  const liveCheck = proofChecks.find((item) => String(item.label || '').toLowerCase().includes('live'));
  const needsDashboard = raw?.state === 'requires_user_action' || raw?.state === 'connect_live' || liveCheck?.status === 'no' || liveCheck?.status === 'unknown';
  if (liveCheck || needsDashboard) {
    const liveOk = liveCheck?.status === 'yes';
    rows.push({
      label: 'Dashboard proof',
      caption: liveOk ? raw.name + ' live verification recorded.' : 'Open the ' + raw.name + ' dashboard for live setup steps.',
      state: liveOk ? 'done' : 'active',
      status: liveOk ? 'Verified' : 'Needed',
    });
  }
  const checks = providerChecks(raw || {});
  const parts = checks.split('/');
  const ready = Number(parts[0]) || 0;
  const total = Number(parts[1]) || 0;
  const allReady = total > 0 && ready === total;
  rows.push({
    label: 'Verification',
    caption: checks + ' launch checks ready for ' + (raw?.name || 'provider') + '.',
    state: allReady ? 'done' : ready > 0 ? 'active' : 'pending',
    status: checks,
  });
  return rows;
}

function providerHealth(raw, normalized) {
  const state = raw?.state || normalized?.state || 'not_detected';
  const checks = providerChecks(raw || normalized || {});
  const parts = checks.split('/');
  const ready = Number(parts[0]) || 0;
  const total = Number(parts[1]) || 0;
  const allReady = total > 0 && ready === total;
  const summary = providerScopedDetail(raw || normalized || {});
  if (state === 'not_detected') {
    return { label: 'Not detected', tone: 'orange', summary, meta: 'Not in this project' };
  }
  if (state === 'live_verified') {
    return { label: 'Ready', tone: 'green', summary, meta: checks + ' checks' };
  }
  if (state === 'needs_repo_fix' || state === 'blocked' || state === 'error') {
    return { label: 'Needs work', tone: 'orange', summary, meta: checks + ' checks' };
  }
  if (!allReady && total > 0) {
    return { label: 'Incomplete', tone: 'orange', summary, meta: checks + ' checks' };
  }
  if (state === 'requires_user_action' || state === 'connect_live') {
    return { label: 'Action needed', tone: 'orange', summary, meta: 'Dashboard' };
  }
  return { label: 'Detected', tone: 'green', summary, meta: checks + ' checks' };
}

function providerHealthIcon(health) {
  if (health.tone === 'green' && (health.label === 'Ready' || health.label === 'Detected')) return Icon('heart');
  if (health.label === 'Not detected') return Icon('flag');
  return Icon('refresh');
}

function providerMcp(provider) {
  return provider && provider.mcp ? provider.mcp : {
    status: 'disconnected',
    label: 'Connect MCP',
    connectCommand: 'Add this provider to your local MCP config, then drag it into chat.',
    capabilities: [],
    available: false,
  };
}

function providerMcpChip(provider) {
  const mcp = providerMcp(provider);
  const connected = mcp.status === 'connected';
  const label = connected ? 'MCP connected' : 'MCP not connected';
  return '<span class="vr-provider-mcp-chip ' + (connected ? 'is-connected' : 'is-disconnected') + '" title="' + escapeHtml(label) + '" aria-label="' + escapeHtml(label) + '">' +
    '<i></i><span>' + escapeHtml(label) + '</span>' +
    '</span>';
}

function providerAssetSrc(provider) {
  if (!provider) return providerAssets.supabase;
  return providerMarkAssets[provider.id] || providerAssets[provider.id] || providerAssets.supabase;
}

function providerIconMarkup(provider) {
  const iconHtml = provider && provider.iconHtml ? String(provider.iconHtml) : '';
  if (iconHtml.trim()) return iconHtml;
  // Fallback must still be the PROVIDER icon, never the raven card-art. Build the real logo
  // from the provider id so a cold/offline boot shows Supabase/Vercel/etc, not a generic raven.
  const id = provider && provider.id ? String(provider.id).toLowerCase().replace(/[^a-z0-9]/g, '') : '';
  if (id) {
    const color = String(areaEnergy(provider.area) || '#e8c15a').replace('#', '');
    return '<img class="provider-logo__img" src="https://cdn.simpleicons.org/' + id + '/' + color + '" alt="" decoding="async" data-provider-logo-key="' + id + '" />';
  }
  return '<img src="' + providerAssetSrc(provider) + '" alt="" />';
}

function ProviderToken(provider, extraClass) {
  const className = 'vr-provider-token' + (extraClass ? ' ' + extraClass : '');
  return '<span class="' + className + '">' + providerIconMarkup(provider) + '</span>';
}

function areaEnergy(area) {
  const key = String(area || '').toLowerCase();
  if (key.includes('database') || key.includes('data')) return '#3ecf8e';
  if (key.includes('auth')) return '#7dd3fc';
  if (key.includes('pay') || key.includes('billing')) return '#a78bfa';
  if (key.includes('deploy') || key.includes('cloud') || key.includes('hosting')) return '#f4f4f5';
  if (key.includes('monitor') || key.includes('error')) return '#fb923c';
  if (key.includes('email')) return '#e2e8f0';
  if (key.includes('analytic')) return '#fbbf24';
  if (key.includes('cache') || key.includes('queue')) return '#2dd4bf';
  if (key.includes('version') || key.includes('repo') || key.includes('code')) return '#c084fc';
  return '#e8c15a';
}

function gradeMark(tier) {
  if (tier === 'flawless') return '&#9733;';
  if (tier === 'clear') return '&#9670;';
  return '&#9679;';
}

// Full manga card art (shipped in assets/manga/cards). Providers with baked
// art render the image as the whole face + a holographic foil overlay; the
// rest fall back to the CSS-built card anatomy below.
const MANGA_CARD_ARTS = { supabase: 1, vercel: 1, github: 1, posthog: 1, stripe: 1, resend: 1, sentry: 1, upstash: 1, clerk: 1, authjs: 1 };
function cardArtSrc(provider) {
  const id = provider && provider.id ? String(provider.id).toLowerCase().replace(/[^a-z0-9]/g, '') : '';
  // ?v bump busts stale browser cache when a card art is redrawn
  return MANGA_CARD_ARTS[id] ? '/manga/cards/' + id + '.webp?v=5' : '';
}

function TradingCard(provider, variant, options) {
  const opts = options || {};
  const size = variant === 'dealt' ? 'is-dealt' : variant === 'map' ? 'is-map' : 'is-hand';
  const grade = provider.grade || { value: null, tier: 'facedown', label: 'FACE DOWN' };
  const foil = escapeHtml(provider.id);
  const placedClass = opts.placed ? ' is-placed' : '';
  const tagOpen = opts.asDiv ? 'div' : 'button type="button"';
  const tagClose = opts.asDiv ? 'div' : 'button';
  if (provider.state === 'not_detected') {
    // Locked card: the provider isn't in this project. Keep the logo (dimmed)
    // behind a lock seal so you can see which provider it is and that it's
    // there to unlock by adding it — never a fake grade or a blank back.
    return '<' + tagOpen + ' class="vr-tcard is-locked ' + size + placedClass + '" data-foil="' + foil + '"' +
      (opts.asDiv ? '' : ' data-action="deal-provider" data-provider="' + foil + '" aria-label="' + escapeHtml(provider.name) + ' is not in this project — add it to unlock this card" title="' + escapeHtml(provider.name) + ' · not in this project — add to unlock"') +
      (opts.style ? ' style="' + opts.style + '"' : '') + '>' +
      (opts.placed ? '<span class="vr-tcard-unplace" data-action="unplace-card" data-unplace="' + foil + '" title="Remove from the table" role="button" aria-label="Remove from the table">&#10005;</span>' : '') +
      '<span class="vr-tcard-lockart">' + ProviderToken(provider, 'is-locked') + '<span class="vr-tcard-lockbadge">' + Icon('lock') + '</span></span>' +
      '<span class="vr-tcard-backname">' + escapeHtml(provider.name) + '</span>' +
      '<span class="vr-tcard-lockhint">Not in this project</span>' +
      '</' + tagClose + '>';
  }
  if (grade.tier === 'facedown' && !opts.forceFace) {
    return '<' + tagOpen + ' class="vr-tcard is-back ' + size + placedClass + '"' +
      (opts.asDiv ? '' : ' data-action="deal-provider" data-provider="' + foil + '" aria-label="Flip ' + escapeHtml(provider.name) + ' — run its first checks" title="' + escapeHtml(provider.name) + ' · face down — click to flip"') +
      (opts.style ? ' style="' + opts.style + '"' : '') + '>' +
      '<span class="vr-tcard-backart"><img src="' + mascotAssets.idle + '" alt="" /></span>' +
      '<span class="vr-tcard-backname">' + escapeHtml(provider.name) + '</span>' +
      '</' + tagClose + '>';
  }
  const flawless = grade.tier === 'flawless';
  const artSrc = cardArtSrc(provider);
  if (artSrc) {
    // full-art face: the image IS the card; holo foil + glare ride on top,
    // grade chip and RAVEN GRADE strip overlay the corners.
    return '<' + tagOpen + ' class="vr-tcard has-art ' + size + placedClass + (flawless ? ' is-flawless' : '') + '" data-foil="' + foil + '"' +
      (opts.asDiv ? '' : ' data-action="deal-provider" data-provider="' + foil + '" aria-label="Deal ' + escapeHtml(provider.name) + ' — checks run instantly in chat" title="' + escapeHtml(provider.name) + ' · ' + escapeHtml(grade.label) + '"') +
      (opts.style ? ' style="' + opts.style + '"' : '') + '>' +
      '<img class="vr-tcard-artfull" src="' + artSrc + '" alt="' + escapeHtml(provider.name) + '" draggable="false" />' +
      '<span class="vr-tcard-holofoil" aria-hidden="true"></span>' +
      '<span class="vr-tcard-glare" aria-hidden="true"></span>' +
      (opts.placed ? '<span class="vr-tcard-unplace" data-action="unplace-card" data-unplace="' + foil + '" title="Remove from the table" role="button" aria-label="Remove from the table">&#10005;</span>' : '') +
      '<span class="vr-tcard-hp is-onart"><span class="vr-tcard-energy" style="--vr-energy:' + areaEnergy(provider.area) + '"></span><i>' + (grade.value == null ? '?' : grade.value) + '</i></span>' +
      '<span class="vr-tcard-gradebar">' + (flawless ? '&#10038; ' : '') + 'RAVEN GRADE &middot; ' + escapeHtml(grade.label) + '</span>' +
      '</' + tagClose + '>';
  }
  return '<' + tagOpen + ' class="vr-tcard ' + size + placedClass + (flawless ? ' is-flawless' : '') + '" data-foil="' + foil + '"' +
    (opts.asDiv ? '' : ' data-action="deal-provider" data-provider="' + foil + '" aria-label="Deal ' + escapeHtml(provider.name) + ' — checks run instantly in chat" title="' + escapeHtml(provider.name) + ' · ' + escapeHtml(grade.label) + '"') +
    (opts.style ? ' style="' + opts.style + '"' : '') + '>' +
    '<span class="vr-tcard-sheen" aria-hidden="true"></span>' +
    (opts.placed ? '<span class="vr-tcard-unplace" data-action="unplace-card" data-unplace="' + foil + '" title="Remove from the table" role="button" aria-label="Remove from the table">&#10005;</span>' : '') +
    '<span class="vr-tcard-inner">' +
      '<span class="vr-tcard-head"><b>' + escapeHtml(provider.name) + '</b><span class="vr-tcard-hp"><span class="vr-tcard-energy" style="--vr-energy:' + areaEnergy(provider.area) + '" title="' + escapeHtml(String(provider.area || '')) + '"></span><i>' + (grade.value == null ? '?' : grade.value) + '</i></span></span>' +
      '<span class="vr-tcard-artwin"><span class="vr-tcard-holo" aria-hidden="true"></span>' + ProviderToken(provider, 'is-tcard') + '</span>' +
      '<span class="vr-tcard-type">' + escapeHtml(String(provider.area || '').toUpperCase()) + '</span>' +
      '<span class="vr-tcard-grade">' + (flawless ? '&#10038; ' : '') + 'RAVEN GRADE &middot; ' + escapeHtml(grade.label) + (flawless ? ' &#10038;' : '') + '</span>' +
      '<span class="vr-tcard-mark" aria-hidden="true">' + gradeMark(grade.tier) + '</span>' +
    '</span>' +
    '</' + (opts.asDiv ? 'div' : 'button') + '>';
}

function ProviderLogo(provider, className) {
  const iconHtml = provider && provider.iconHtml ? String(provider.iconHtml) : '';
  return iconHtml.trim()
    ? '<span class="' + className + ' is-logo-html">' + iconHtml + '</span>'
    : '<img class="' + className + '" src="' + providerAssetSrc(provider) + '" alt="" />';
}

function ProviderMcpPanel(provider) {
  const mcp = providerMcp(provider);
  const connected = mcp.status === 'connected';
  const capabilities = Array.isArray(mcp.capabilities) && mcp.capabilities.length ? mcp.capabilities : ['provider context', 'repo-aware chat'];
  const connectButton = connected
    ? ''
    : '<button type="button" class="vr-mcp-connect-btn" data-action="connect-mcp" data-provider-id="' + escapeHtml(provider.id || '') + '">Connect</button>';
  return '<section class="vr-provider-mcp-panel ' + (connected ? 'is-connected' : 'is-disconnected') + '">' +
    '<header><span>' + Icon('code') + '</span><div><strong>' + escapeHtml(connected ? 'Connected' : 'Not connected') + '</strong></div>' + connectButton + '</header>' +
    '<div>' + capabilities.map((item) => '<small>' + escapeHtml(item) + '</small>').join('') + '</div>' +
    '</section>';
}

async function connectProviderMcp(providerId) {
  demo.mcpConnecting = providerId;
  demo.mcpConnectMessage = '';
  demo.notice = 'Writing ' + providerId + ' MCP server into .mcp.json…';
  render();
  try {
    const response = await fetch('/api/mcp/connect', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ providerId })
    });
    const data = await response.json();
    demo.mcpConnectMessage = data.message || '';
    demo.notice = data.message || (data.ok ? 'MCP server configured.' : 'Could not configure MCP server.');
    if (data.ok && data.state && Array.isArray(data.state.providers)) {
      data.state.providers.forEach((fresh) => {
        const existing = providers.find((item) => item.id === fresh.id);
        if (existing) existing.mcp = fresh.mcp || existing.mcp;
      });
    }
    if (data.ok) {
      const connectedProvider = providers.find((item) => item.id === providerId);
      const chat = chatContext(0);
      if (connectedProvider && !String(chat.draft || '').trim()) {
        chat.providerId = providerId;
        chat.draft = 'Use the ' + connectedProvider.name + ' MCP to verify live provider state: list what is configured, what is missing for production, and apply the safe setup it can do for me. Report anything that still needs the dashboard.';
        demo.notice = connectedProvider.name + ' MCP connected. A verification mission is ready in chat — review and send.';
      }
    }
  } catch (error) {
    demo.mcpConnectMessage = 'Connect failed: ' + (error instanceof Error ? error.message : String(error));
    demo.notice = 'MCP connect failed: ' + (error instanceof Error ? error.message : String(error));
  }
  demo.mcpConnecting = null;
  render();
}

function normalizeProvider(provider) {
  const missing = provider.state === 'not_detected';
  return {
    id: provider.id,
    name: provider.name,
    area: provider.area,
    status: missing ? 'Missing' : (provider.statusText || 'Detected in repo'),
    tone: providerTone(provider.state, missing ? 'Missing' : provider.statusText),
    detail: missing ? 'Not linked — drag into chat or ask agent to connect' : providerDetail(provider),
    region: missing ? 'not linked' : 'local repo',
    lastSync: currentState.project && currentState.project.scannedAt ? 'scan artifact' : 'startup',
    checks: providerChecks(provider),
    state: provider.state || 'not_detected',
    mcp: provider.mcp || null,
    iconHtml: provider.iconHtml || '',
    grade: provider.grade || { value: null, tier: 'facedown', label: 'FACE DOWN' },
    launchPath: Array.isArray(provider.launchPath) ? provider.launchPath : [],
  };
}

const providers = Array.isArray(currentState.providers) && currentState.providers.length
  ? currentState.providers.map(normalizeProvider)
  : [];

function dealProviderCard(providerId) {
  const provider = providers.find((item) => item.id === providerId);
  if (!provider) return;
  const chatIndex = Math.max(0, Math.min(demo.pickerChatIndex || 0, demo.activeChatCount - 1));
  const chat = chatContext(chatIndex);
  demo.selectedProviderId = providerId;
  demo.activeStudioTab = 'chat';
  demo.activeModal = null;
  const message = {
    role: 'agent',
    kind: 'provider-card',
    providerId: providerId,
    rows: null,
    grade: null,
    done: false,
    error: null,
    ts: Date.now(),
  };
  chat.messages.push(message);
  demo.notice = provider.name + ' dealt into chat — checks running.';
  render({ scrollToBottom: chatIndex });
  const dealtAt = Date.now();
  window.requestAnimationFrame(animateDealtCardIntoChat);
  // The local check returns almost instantly; hold the results render until the
  // deal animation has played, so it is actually visible (otherwise the full
  // re-render replaces the animating card before you see it).
  const renderAfterDeal = () => {
    const wait = Math.max(0, 720 - (Date.now() - dealtAt));
    window.setTimeout(() => render(), wait);
  };
  fetch('/api/provider-check', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ providerId: providerId }),
  })
    .then((response) => {
      if (!response.ok) throw new Error('check failed');
      return response.json();
    })
    .then((payload) => {
      message.rows = Array.isArray(payload.rows) ? payload.rows : [];
      message.grade = payload.grade || null;
      message.done = true;
      const idx = providers.findIndex((item) => item.id === providerId);
      if (idx >= 0 && payload.provider) providers[idx] = normalizeProvider(payload.provider);
      renderAfterDeal();
    })
    .catch(() => {
      message.error = 'Could not reach the local server — is the Studio still running?';
      message.done = true;
      renderAfterDeal();
    });
}

let releases = Array.isArray(currentState.releases) && currentState.releases.length
  ? currentState.releases.map((release, index) => ({
      id: release.id || release.label || 'workspace',
      label: release.label || release.id || 'Workspace',
      meta: release.meta || (index === 0 ? 'current workspace' : 'local history'),
      branch: release.branch || 'local',
      tone: release.tone || (index === 0 ? 'current' : 'prod'),
      summary: release.summary || '',
    }))
  : [{ id: 'workspace', label: 'Workspace', meta: 'not released', branch: 'local', tone: 'current', summary: 'No release detected yet.' }];

function syncReleasesFromState(state) {
  if (!state || !Array.isArray(state.releases) || !state.releases.length) return;
  releases = state.releases.map((release, index) => ({
    id: release.id || release.label || 'workspace',
    label: release.label || release.id || 'Workspace',
    meta: release.meta || (index === 0 ? 'current workspace' : 'local history'),
    branch: release.branch || 'local',
    tone: release.tone || (index === 0 ? 'current' : 'prod'),
    summary: release.summary || '',
  }));
  if (releases.length > 0 && !releases.some((item) => item.id === demo.selectedReleaseId)) {
    demo.selectedReleaseId = releases[0].id;
  }
}

function releaseComparePair() {
  const selectedIndex = releases.findIndex((item) => item.id === demo.selectedReleaseId);
  const toIndex = selectedIndex >= 0 ? selectedIndex : 0;
  const fromIndex = toIndex + 1;
  if (fromIndex < releases.length) {
    return {
      from: releases[fromIndex].id,
      to: releases[toIndex].id,
      fromLabel: releases[fromIndex].label,
      toLabel: releases[toIndex].label,
    };
  }
  return { from: 'HEAD~1', to: 'HEAD', fromLabel: 'Previous commit', toLabel: 'HEAD' };
}

function rollbackTargetRef() {
  return releaseComparePair().from;
}

function formatDiffPreHtml(diffText) {
  const lines = String(diffText || '').split('\\n');
  return lines.map(function(line) {
    if (line.startsWith('+++') || line.startsWith('---') || line.startsWith('diff ')) {
      return '<b>' + escapeHtml(line) + '</b>';
    }
    if (line.startsWith('+') && !line.startsWith('+++')) {
      return '<span class="add">' + escapeHtml(line) + '</span>';
    }
    if (line.startsWith('-') && !line.startsWith('---')) {
      return '<span class="del">' + escapeHtml(line) + '</span>';
    }
    return escapeHtml(line);
  }).join('\\n');
}

function releaseChangelogHtml() {
  const log = demo.releaseChangelog || {};
  if (log.loading) return '<p class="vr-changelog-empty">Loading changelog...</p>';
  if (log.error) return '<p class="vr-release-error">' + escapeHtml(log.error) + '</p>';
  const entries = Array.isArray(log.entries) ? log.entries : [];
  if (entries.length) {
    const visible = entries.slice(0, 6);
    const hidden = entries.slice(6);
    const rangeLabel = (log.fromLabel || 'previous') + ' to ' + (log.toLabel || 'selected');
    const entryHtml = function(entry, compact) {
      const meta = (entry.author || 'unknown') + (entry.when ? ' - ' + entry.when : '');
      return '<li class="' + (compact ? 'is-compact' : '') + '"><strong>' + escapeHtml(entry.short || entry.sha || '') + '</strong><span>' + escapeHtml(entry.subject || '') + '</span><em>' + escapeHtml(meta) + '</em></li>';
    };
    return '<div class="vr-changelog-summary"><span>Release changes</span><strong>' + String(entries.length) + ' commit' + (entries.length === 1 ? '' : 's') + '</strong><em>' + escapeHtml(rangeLabel) + '</em></div>' +
      '<ul class="vr-changelog-list is-preview">' + visible.map(function(entry) { return entryHtml(entry, false); }).join('') + '</ul>' +
      (hidden.length
        ? '<details class="vr-changelog-more"><summary>Show ' + String(hidden.length) + ' older commit' + (hidden.length === 1 ? '' : 's') + '</summary><ul class="vr-changelog-list is-condensed">' + hidden.map(function(entry) { return entryHtml(entry, true); }).join('') + '</ul></details>'
        : '');
  }
  return '<p class="vr-changelog-empty">No commits between ' + escapeHtml(log.fromLabel || 'previous') + ' and ' + escapeHtml(log.toLabel || 'selected') + '.</p>';
}

async function runReleaseCompare() {
  const pair = releaseComparePair();
  demo.releaseDiff = {
    text: '',
    from: pair.from,
    to: pair.to,
    fromLabel: pair.fromLabel,
    toLabel: pair.toLabel,
    stats: null,
    loading: true,
    error: '',
  };
  demo.activeStudioTab = 'diff';
  demo.activeModal = null;
  render();
  try {
    const url = '/api/releases/compare?from=' + encodeURIComponent(pair.from) + '&to=' + encodeURIComponent(pair.to);
    const response = await fetch(url);
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Compare failed');
    demo.releaseDiff = {
      text: data.diff || '',
      from: data.from || pair.from,
      to: data.to || pair.to,
      fromLabel: data.fromLabel || pair.fromLabel,
      toLabel: data.toLabel || pair.toLabel,
      stats: data.stats || null,
      loading: false,
      error: '',
    };
    demo.notice = 'Compared ' + demo.releaseDiff.fromLabel + ' → ' + demo.releaseDiff.toLabel + '.';
  } catch (error) {
    demo.releaseDiff.loading = false;
    demo.releaseDiff.error = error instanceof Error ? error.message : String(error);
    demo.notice = demo.releaseDiff.error;
  }
  render();
}

async function runReleaseChangelog(openModal) {
  const pair = releaseComparePair();
  demo.releaseChangelog = {
    entries: [],
    from: pair.from,
    to: pair.to,
    fromLabel: pair.fromLabel,
    toLabel: pair.toLabel,
    loading: true,
    error: '',
  };
  if (openModal) demo.activeStudioTab = 'versions';
  render();
  try {
    const url = '/api/releases/changelog?from=' + encodeURIComponent(pair.from) + '&to=' + encodeURIComponent(pair.to);
    const response = await fetch(url);
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Changelog failed');
    demo.releaseChangelog = {
      entries: Array.isArray(data.entries) ? data.entries : [],
      from: data.from || pair.from,
      to: data.to || pair.to,
      fromLabel: data.fromLabel || pair.fromLabel,
      toLabel: data.toLabel || pair.toLabel,
      loading: false,
      error: '',
    };
    demo.notice = demo.releaseChangelog.entries.length
      ? demo.releaseChangelog.entries.length + ' commits between ' + demo.releaseChangelog.fromLabel + ' and ' + demo.releaseChangelog.toLabel + '.'
      : 'No commits between ' + demo.releaseChangelog.fromLabel + ' and ' + demo.releaseChangelog.toLabel + '.';
  } catch (error) {
    demo.releaseChangelog.loading = false;
    demo.releaseChangelog.error = error instanceof Error ? error.message : String(error);
    demo.notice = demo.releaseChangelog.error;
  }
  render();
}

function dealReleaseCard(releaseId) {
  const release = releases.find((item) => item.id === releaseId);
  if (!release) return;
  demo.selectedReleaseId = releaseId;
  demo.activeStudioTab = 'chat';
  demo.activeModal = null;
  const pair = releaseComparePair();
  const chatIndex = Math.max(0, Math.min(demo.pickerChatIndex || 0, demo.activeChatCount - 1));
  const chat = chatContext(chatIndex);
  const message = {
    role: 'agent',
    kind: 'release-card',
    releaseId: releaseId,
    pair: pair,
    compare: null,
    changelog: null,
    done: false,
    error: null,
    ts: Date.now(),
  };
  chat.messages.push(message);
  demo.notice = release.label + ' dealt into chat — reading what changed.';
  render({ scrollToBottom: chatIndex });
  const compareUrl = '/api/releases/compare?from=' + encodeURIComponent(pair.from) + '&to=' + encodeURIComponent(pair.to);
  const changelogUrl = '/api/releases/changelog?from=' + encodeURIComponent(pair.from) + '&to=' + encodeURIComponent(pair.to);
  Promise.all([
    fetch(compareUrl).then((response) => response.ok ? response.json() : null).catch(() => null),
    fetch(changelogUrl).then((response) => response.ok ? response.json() : null).catch(() => null),
  ]).then(([compare, changelog]) => {
    message.compare = compare;
    message.changelog = changelog && Array.isArray(changelog.entries) ? changelog.entries : [];
    message.done = true;
    if (!compare && !changelog) message.error = 'Could not read git history for this version.';
    render();
  });
}

async function runReleaseRollback() {
  const target = rollbackTargetRef();
  const targetLabel = releases.find((item) => item.id === target)?.label || target;
  const confirmed = window.confirm('Check out ' + targetLabel + ' locally? Git will move to a detached HEAD at that release.');
  if (!confirmed) {
    demo.notice = 'Rollback cancelled.';
    render();
    return;
  }
  demo.notice = 'Rolling back to ' + targetLabel + '…';
  render();
  try {
    const response = await fetch('/api/releases/rollback', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ target }),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Rollback failed');
    syncReleasesFromState(data);
    demo.selectedReleaseId = target;
    demo.activeModal = null;
    demo.notice = (data.rollback && data.rollback.message) || ('Checked out ' + targetLabel + '.');
  } catch (error) {
    demo.notice = error instanceof Error ? error.message : String(error);
  }
  render();
}

demo.selectedProviderId = currentState.selectedProviderId || (providers[0] && providers[0].id) || 'supabase';
demo.selectedReleaseId = (releases[0] && releases[0].id) || 'workspace';

let cliAgents = [
  { id: 'codex', label: 'Codex CLI', caption: 'Connect OpenAI agent', tone: 'green', connected: false, setup: { installCommand: 'npm install -g @openai/codex', signInCommand: 'codex login', verifyCommand: 'codex --version', docsUrl: 'https://github.com/openai/codex' } },
  { id: 'claude', label: 'Claude Code', caption: 'Connect Anthropic agent', tone: 'purple', connected: false, setup: { installCommand: 'npm install -g @anthropic-ai/claude-code', signInCommand: 'claude', verifyCommand: 'claude --version', docsUrl: 'https://docs.anthropic.com/en/docs/claude-code/overview' } },
  { id: 'gemini', label: 'Gemini CLI', caption: 'Connect Google agent', tone: 'blue', connected: false, setup: { installCommand: 'npm install -g @google/gemini-cli', signInCommand: 'gemini', verifyCommand: 'gemini --version', docsUrl: 'https://github.com/google-gemini/gemini-cli' } },
  { id: 'terminal', label: 'Terminal', caption: 'Open local shell', tone: 'orange', connected: true, setup: { installCommand: '', signInCommand: '', verifyCommand: '', docsUrl: 'https://viberaven.dev' } },
];

let cliModels = {
  codex: ['GPT-5.5', 'GPT-5.4', 'GPT-5.4-Mini', 'GPT-5.3-Codex-Spark'],
  claude: ['Claude 3.5 Sonnet', 'Claude Opus', 'Claude Haiku'],
  gemini: ['Gemini 2.5 Pro', 'Gemini 2.5 Flash', 'Gemini CLI Fast'],
  terminal: ['Local shell', 'PowerShell', 'Node task runner'],
};

const reasoningLevels = ['Low', 'Medium', 'High', 'Extra High'];
const contextLevels = ['Production', 'Provider', 'Release', 'Security'];
const accessModes = [
  { id: 'ask', label: 'Ask approval', description: 'Confirm edits and external access' },
  { id: 'approve', label: 'Approve for me', description: 'Run safe repo actions automatically' },
  { id: 'full', label: 'Full access', description: 'Unrestricted local project access' },
];
const topStages = [
  { id: 'provider', number: '1', label: 'Provider Proof', state: 'Waiting' },
  { id: 'agent', number: '2', label: 'Agent Fix', state: 'Ready' },
  { id: 'verify', number: '3', label: 'Verify', state: 'Waiting' },
  { id: 'clear', number: '4', label: 'Clear', state: 'Waiting' },
];

const stackSlots = {
  supabase: 'Database',
  vercel: 'Cloud',
  stripe: 'Payments',
  github: 'Version',
  sentry: 'Monitoring',
  posthog: 'Analytics',
  clerk: 'Auth',
  authjs: 'Auth',
  resend: 'Email',
  upstash: 'Cache',
};

const providerBoardOrder = ['supabase', 'clerk', 'authjs', 'vercel', 'stripe', 'sentry', 'resend', 'posthog', 'upstash', 'github'];

function visibleBoardProviders() {
  const authProviders = providers.filter((provider) => provider.id === 'clerk' || provider.id === 'authjs');
  if (authProviders.length <= 1) return providers;
  const detectedAuth = authProviders.find((provider) => provider.state !== 'not_detected');
  const visibleAuth = detectedAuth || authProviders.find((provider) => provider.id === 'clerk') || authProviders[0];
  return providers.filter((provider) => provider.id !== 'clerk' && provider.id !== 'authjs').concat(visibleAuth);
}

function orderedProviders() {
  const visible = visibleBoardProviders();
  const ordered = providerBoardOrder
    .map((id) => visible.find((provider) => provider.id === id))
    .filter(Boolean);
  return ordered.concat(visible.filter((provider) => !providerBoardOrder.includes(provider.id)));
}

const RECENT_CHATS_KEY_PREFIX = 'viberaven-recent-chats-v1';
const RECENT_CHATS_MAX = 8;
const RECENT_MESSAGES_MAX = 80;
const RECENT_MESSAGE_TEXT_MAX = 6000;

let recentChats = [];

function projectPathHash(path) {
  const normalized = String(path || 'default').toLowerCase();
  let hash = 2166136261;
  for (let i = 0; i < normalized.length; i++) {
    hash ^= normalized.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0).toString(36);
}

function recentChatsStorageKey() {
  const path = currentState && currentState.project && currentState.project.path;
  return RECENT_CHATS_KEY_PREFIX + '-' + projectPathHash(path);
}

function serializeChatMessages(messages) {
  const list = Array.isArray(messages) ? messages : [];
  return list.slice(-RECENT_MESSAGES_MAX).map((item) => ({
    role: item.role,
    text: String(item.text || '').slice(0, RECENT_MESSAGE_TEXT_MAX),
    kind: item.kind || null,
    isError: Boolean(item.isError),
    providerId: item.providerId || null,
    releaseId: item.releaseId || null,
    cards: item.cards || null,
    ts: item.ts || null,
  }));
}

function recentChatTitle(text) {
  const trimmed = String(text || '').trim();
  if (!trimmed) return 'Mission chat';
  return trimmed.length > 38 ? trimmed.slice(0, 35).trim() + '...' : trimmed;
}

function recentChatCaption(provider, release, chat) {
  if (provider) return (stackSlots[provider.id] || provider.area) + ' / ' + provider.name;
  if (release) return 'Release / ' + release.label;
  if (chat && chat.context) return chat.context;
  return 'Production';
}

function buildRecentChatEntry(prompt, provider, release, chat, existing) {
  const lane = chat || chatContext(0);
  const base = existing || {};
  return {
    id: base.id || ('chat-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7)),
    title: base.title || recentChatTitle(prompt),
    caption: base.caption || recentChatCaption(provider, release, lane),
    time: base.time || 'Just now',
    providerId: lane.providerId ?? provider?.id ?? base.providerId ?? null,
    releaseId: lane.releaseId ?? release?.id ?? base.releaseId ?? null,
    cliId: lane.cliId || base.cliId || demo.selectedCliId || 'codex',
    modelId: lane.modelId || base.modelId || demo.selectedModelId || 'gpt-5.5',
    reasoning: lane.reasoning || base.reasoning || demo.selectedReasoning || 'High',
    context: lane.context || base.context || demo.selectedContext || 'Production',
    accessMode: lane.accessMode || base.accessMode || demo.selectedAccessMode || 'approve',
    messages: serializeChatMessages(lane.messages),
  };
}

function loadRecentChats() {
  try {
    const raw = localStorage.getItem(recentChatsStorageKey());
    const parsed = raw ? JSON.parse(raw) : [];
    recentChats = Array.isArray(parsed) ? parsed : [];
  } catch {
    recentChats = [];
  }
}

function saveRecentChats() {
  try {
    localStorage.setItem(recentChatsStorageKey(), JSON.stringify(recentChats));
  } catch {
    // Ignore storage failures in preview shells.
  }
}

function syncDemoFromChatContext(context) {
  demo.selectedCliId = context.cliId;
  demo.selectedModelId = context.modelId;
  demo.selectedReasoning = context.reasoning;
  demo.selectedContext = context.context;
  demo.selectedAccessMode = context.accessMode || 'approve';
  if (context.providerId) demo.selectedProviderId = context.providerId;
  if (context.releaseId) demo.selectedReleaseId = context.releaseId;
  syncPrimaryContext();
}

function restoreRecentChat(recent) {
  if (!recent) return defaultChatContext({});
  return defaultChatContext({
    providerId: recent.providerId || null,
    releaseId: recent.releaseId || null,
    cliId: recent.cliId,
    modelId: recent.modelId,
    reasoning: recent.reasoning,
    context: recent.context,
    accessMode: recent.accessMode,
    messages: recent.messages || [],
    draft: '',
    activeTask: null,
  });
}

function updateActiveRecentChatSnapshot() {
  if (!demo.activeRecentChatId) return;
  const index = recentChats.findIndex((chat) => chat.id === demo.activeRecentChatId);
  if (index < 0) return;
  const lane0 = chatContext(0);
  if (!lane0.messages.length) return;
  const existing = recentChats[index];
  const firstUser = lane0.messages.find((item) => item.role === 'user');
  recentChats[index] = buildRecentChatEntry(
    firstUser?.text || existing.title,
    providers.find((item) => item.id === lane0.providerId),
    releases.find((item) => item.id === lane0.releaseId),
    lane0,
    existing
  );
  saveRecentChats();
}

function persistCurrentChatToRecent() {
  const lane0 = chatContext(0);
  if (!lane0.messages.length) return;
  const firstUser = lane0.messages.find((item) => item.role === 'user');
  const prompt = firstUser?.text || lane0.messages[0]?.text || '';
  const provider = providers.find((item) => item.id === lane0.providerId);
  const release = releases.find((item) => item.id === lane0.releaseId);
  if (demo.activeRecentChatId) {
    const index = recentChats.findIndex((chat) => chat.id === demo.activeRecentChatId);
    if (index >= 0) {
      recentChats[index] = buildRecentChatEntry(prompt, provider, release, lane0, recentChats[index]);
      saveRecentChats();
      return;
    }
  }
  const entry = buildRecentChatEntry(prompt, provider, release, lane0);
  recentChats = [entry].concat(recentChats).slice(0, RECENT_CHATS_MAX);
  saveRecentChats();
}

function rememberRecentChat(prompt, provider, release, chat) {
  const text = String(prompt || '').trim();
  if (!text) return;
  const lane0 = chat || chatContext(0);
  if (demo.activeRecentChatId) {
    const index = recentChats.findIndex((item) => item.id === demo.activeRecentChatId);
    if (index >= 0) {
      recentChats[index] = buildRecentChatEntry(text, provider, release, lane0, recentChats[index]);
      saveRecentChats();
      return;
    }
  }
  const entry = buildRecentChatEntry(text, provider, release, lane0);
  recentChats = [entry].concat(recentChats).slice(0, RECENT_CHATS_MAX);
  demo.activeRecentChatId = entry.id;
  saveRecentChats();
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function projectName() {
  const name = String(currentState.project && currentState.project.name || '').trim();
  return !name || name.toLowerCase() === 'project' ? 'Your project' : name;
}

function StatusBadge(label, tone) {
  return '<span class="vr-status-badge" data-tone="' + escapeHtml(tone) + '">' + escapeHtml(label) + '</span>';
}

function compactNumber(value) {
  return new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 }).format(Number(value) || 0);
}

function GitHubStats() {
  if (githubStats.loaded) {
    return '<a class="vr-github-stat-row" href="' + publicGithubUrl + '" target="_blank" rel="noreferrer" aria-label="Open public GitHub repo stats">' +
      '<span><b>' + compactNumber(githubStats.stars) + '</b><em>stars</em></span>' +
      '<span><b>' + compactNumber(githubStats.forks) + '</b><em>forks</em></span>' +
      '<span><b>' + compactNumber(githubStats.issues) + '</b><em>issues</em></span>' +
      '</a><small>Live from the public GitHub repo</small>';
  }
  if (githubStats.error) {
    return '<a class="vr-github-stat-row" href="' + publicGithubUrl + '" target="_blank" rel="noreferrer" aria-label="Open public GitHub repo">' +
      '<span><b>Public</b><em>repo</em></span>' +
      '<span><b>Open</b><em>source</em></span>' +
      '<span><b>GitHub</b><em>link</em></span>' +
      '</a><small>Stats unavailable; repo link still opens GitHub</small>';
  }
  return '<a class="vr-github-stat-row is-loading" href="' + publicGithubUrl + '" target="_blank" rel="noreferrer" aria-label="Open public GitHub repo while stats load">' +
    '<span><b>...</b><em>stars</em></span>' +
    '<span><b>...</b><em>forks</em></span>' +
    '<span><b>...</b><em>issues</em></span>' +
    '</a><small>Loading public GitHub stats</small>';
}

function agentPromptText() {
  const provider = providers.find((item) => item.id === demo.selectedProviderId) || providers[0];
  return [
    'You are fixing one VibeRaven what-changed gap.',
    '',
    'Project: ' + projectName(),
    'Focus: ' + provider.name + ' ' + provider.area,
    'Stage: ' + (demo.activeStepId || 'agent'),
    '',
    'Goal:',
    '- Find the smallest repo-side fix grounded in what changed.',
    '- Do not claim provider dashboard work from code alone.',
    '- Keep the change scoped and verify through the VibeRaven UI action.',
    '',
    'Return:',
    '- What changed',
    '- What still needs user/provider action',
    '- What to verify next'
  ].join('\\n');
}

async function copyText(value) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(value);
      return true;
    } catch {
      // Fall through to the textarea path for browsers without clipboard permission.
    }
  }
  const textarea = document.createElement('textarea');
  textarea.value = value;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  const copied = document.execCommand('copy');
  textarea.remove();
  return copied;
}

function setDragUi(kind) {
  if (!app) return;
  app.classList.toggle('is-dragging', Boolean(kind));
  app.classList.toggle('is-dragging-provider', kind === 'provider');
  app.classList.toggle('is-dragging-release', kind === 'release');
  app.classList.toggle('is-dragging-chat', kind === 'chat');
  if (kind) app.setAttribute('data-drag-kind', kind);
  else app.removeAttribute('data-drag-kind');
}

function setDragChip(event, label, detail, markHtml) {
  if (!event.dataTransfer || typeof event.dataTransfer.setDragImage !== 'function') return;
  const chip = document.createElement('div');
  chip.className = 'vr-drag-chip';
  chip.innerHTML = '<span class="vr-drag-chip-mark">' + (markHtml || '<i></i>') + '</span><div><strong>' + escapeHtml(label) + '</strong><span>' + escapeHtml(detail) + '</span></div>';
  document.body.appendChild(chip);
  event.dataTransfer.setDragImage(chip, 24, 24);
  window.setTimeout(() => chip.remove(), 0);
}

function GlowButton(label, options) {
  const opts = options || {};
  return '<button class="vr-glow-button" data-tone="' + escapeHtml(opts.tone || 'purple') + '" type="button" ' +
    (opts.id ? 'id="' + escapeHtml(opts.id) + '" ' : '') +
    (opts.action ? 'data-action="' + escapeHtml(opts.action) + '" ' : '') +
    (opts.dataCliAgent ? 'data-cli-agent="' + escapeHtml(opts.dataCliAgent) + '" ' : '') +
    '><span>' + escapeHtml(label) + '</span><i aria-hidden="true"></i></button>';
}

function Icon(name) {
  const paths = {
    plus: '<path d="M12 5v14M5 12h14"/>',
    bolt: '<path d="M13 2 4 14h7l-1 8 10-13h-7l0-7Z"/>',
    cube: '<path d="m12 2 8 4.5v11L12 22l-8-4.5v-11L12 2Z"/><path d="M4 6.5 12 11l8-4.5M12 22V11"/>',
    agent: '<path d="M12 3l2.4 4.8L20 10l-5.6 2.2L12 17l-2.4-4.8L4 10l5.6-2.2L12 3Z"/>',
    doc: '<path d="M7 3h7l4 4v14H7V3Z"/><path d="M14 3v5h5M9 12h6M9 16h6"/>',
    branch: '<path d="M7 7v7a3 3 0 0 0 3 3h7"/><circle cx="7" cy="5" r="3"/><circle cx="17" cy="17" r="3"/><path d="M14 7h3v3"/>',
    gear: '<circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9 7 7M17 17l2.1 2.1M19.1 4.9 17 7M7 17l-2.1 2.1"/>',
    people: '<path d="M16 11a4 4 0 1 0-8 0"/><path d="M4 21a8 8 0 0 1 16 0"/><path d="M19 8a3 3 0 0 1 2 5"/>',
    report: '<path d="M5 4h14v16H5V4Z"/><path d="M8 8h8M8 12h8M8 16h5"/>',
    bell: '<path d="M18 16H6l2-2v-4a4 4 0 1 1 8 0v4l2 2Z"/><path d="M10 19h4"/>',
    help: '<circle cx="12" cy="12" r="9"/><path d="M9.8 9a2.4 2.4 0 0 1 4.5 1.2c0 2-2.3 2.1-2.3 4"/><path d="M12 18h.01"/>',
    repo: '<path d="M4 6h6l2 2h8v10H4V6Z"/><path d="M4 10h16"/>',
    shield: '<path d="M12 3 20 6v6c0 5-3.2 8-8 9-4.8-1-8-4-8-9V6l8-3Z"/>',
    spark: '<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3Z"/><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8L19 15Z"/>',
    check: '<path d="m5 12 4 4 10-10"/>',
    copy: '<rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h10"/>',
    flag: '<path d="M6 21V4h11l-2 4 2 4H6"/>',
    guide: '<path d="M4 6h7a3 3 0 0 1 3 3v11a3 3 0 0 0-3-3H4V6Z"/><path d="M14 9a3 3 0 0 1 3-3h3v11h-3a3 3 0 0 0-3 3V9Z"/>',
    shell: '<rect x="3" y="4" width="18" height="14" rx="2"/><path d="M7 9 10 12 7 15"/><path d="M13 15h4"/>',
    refresh: '<path d="M20 12a8 8 0 0 1-14.5 4.7"/><path d="M4 17h5v-5"/><path d="M4 12A8 8 0 0 1 18.5 7.3"/><path d="M20 7h-5v5"/>',
    prompt: '<path d="M4 5h16v14H4V5Z"/><path d="m8 10 3 2-3 2M13 15h4"/>',
    external: '<path d="M7 7h10v10"/><path d="M7 17 17 7"/><path d="M5 5v14h14"/>',
    expand: '<path d="M8 3H3v5M16 3h5v5M3 16v5h5M21 16v5h-5"/><path d="M3 8l6-6M21 8l-6-6M3 16l6 6M21 16l-6 6"/>',
    collapse: '<path d="M9 3v6H3M15 3v6h6M9 21v-6H3M15 21v-6h6"/><path d="M3 9l6-6M21 9l-6-6M3 15l6 6M21 15l-6 6"/>',
    x: '<path d="M6 6l12 12M18 6 6 18"/>',
    clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
    cloud: '<path d="M17.5 18H8a5 5 0 1 1 1.3-9.8A6 6 0 0 1 20 12.5 3.5 3.5 0 0 1 17.5 18Z"/>',
    heart: '<path d="M20.8 4.6a5.4 5.4 0 0 0-7.6 0L12 5.8l-1.2-1.2a5.4 5.4 0 1 0-7.6 7.6L12 21l8.8-8.8a5.4 5.4 0 0 0 0-7.6Z"/>',
    lock: '<rect x="5" y="10" width="14" height="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/>',
    play: '<path d="M8 5v14l11-7-11-7Z"/>',
    code: '<path d="m8 9-4 3 4 3M16 9l4 3-4 3M14 5l-4 14"/>',
    arrowUp: '<path d="M12 19V5"/><path d="m6 11 6-6 6 6"/>',
    pause: '<path d="M9 6v12M15 6v12"/>',
    stop: '<rect x="6" y="6" width="12" height="12" rx="2.5"/>',
    chevronRight: '<path d="m9 6 6 6-6 6"/>',
  };
  return '<i data-icon="' + escapeHtml(name) + '" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + (paths[name] || paths.spark) + '</svg></i>';
}

function contextIconChip(iconName, size) {
  const cls = size === 'input' ? 'vr-context-icon-chip is-input' : 'vr-context-icon-chip';
  return '<span class="' + cls + '">' + Icon(iconName) + '</span>';
}

function BrandMark(id) {
  if (id === 'github') {
    return '<span class="vr-inline-brand-mark is-github"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 2C6.48 2 2 6.58 2 12.26c0 4.52 2.87 8.35 6.86 9.71.5.1.69-.22.69-.49 0-.24-.01-.87-.01-1.7-2.78.62-3.37-1.36-3.37-1.36-.45-1.17-1.11-1.48-1.11-1.48-.91-.64.07-.63.07-.63 1 .07 1.53 1.05 1.53 1.05.9 1.56 2.36 1.11 2.94.85.09-.67.35-1.11.63-1.37-2.22-.26-4.56-1.14-4.56-5.07 0-1.12.39-2.03 1.03-2.75-.1-.26-.45-1.3.1-2.7 0 0 .84-.28 2.75 1.05A9.2 9.2 0 0 1 12 6.84c.85 0 1.71.12 2.51.34 1.91-1.33 2.75-1.05 2.75-1.05.55 1.4.2 2.44.1 2.7.64.72 1.03 1.63 1.03 2.75 0 3.94-2.34 4.8-4.57 5.06.36.32.68.94.68 1.9 0 1.37-.01 2.47-.01 2.8 0 .27.18.6.7.49A10.03 10.03 0 0 0 22 12.26C22 6.58 17.52 2 12 2Z"/></svg></span>';
  }
  return '<span class="vr-inline-brand-mark"><img src="' + escapeHtml(providerMarkAssets[id] || providerAssets[id]) + '" alt="" /></span>';
}

function mascotUrl() {
  if (demo.verified) return mascotAssets.verified;
  if (demo.agentFixing) return mascotAssets.fixing;
  if (demo.activeStepId === 'repo') return mascotAssets.alert;
  return mascotAssets.idle;
}

function selectedProvider() {
  return providers.find((item) => item.id === demo.selectedProviderId) || providers[0];
}

function defaultChatContext(seed) {
  const source = seed || {};
  const cliId = source.cliId || demo.selectedCliId || 'codex';
  const models = cliModels[cliId] || cliModels.codex;
  return {
    providerId: source.providerId || null,
    releaseId: source.releaseId || null,
    cliId,
    modelId: source.modelId || demo.selectedModelId || normalizeModelId(models[0]),
    reasoning: source.reasoning || demo.selectedReasoning || 'High',
    context: source.context || demo.selectedContext || 'Production',
    accessMode: source.accessMode || demo.selectedAccessMode || 'approve',
    draft: source.draft || '',
    messages: Array.isArray(source.messages) ? source.messages.slice() : [],
    activeTask: source.activeTask || null,
  };
}

function clearChatTaskTimer() {
  if (chatTaskTimer) window.clearTimeout(chatTaskTimer);
  chatTaskTimer = null;
}

function laneHasActiveTask(chat) {
  return Boolean(chat && chat.activeTask && chat.activeTask.phase === 'working');
}

function chatContext(index) {
  const safeIndex = Math.max(0, Number(index) || 0);
  while (!demo.chatContexts[safeIndex]) {
    const parent = demo.chatContexts[demo.chatContexts.length - 1];
    demo.chatContexts.push(defaultChatContext({
      ...parent,
      messages: [],
      activeTask: null,
      draft: '',
    }));
  }
  const context = demo.chatContexts[safeIndex];
  const hydrated = defaultChatContext(context);
  Object.assign(context, hydrated);
  return context;
}

function syncPrimaryContext() {
  const context = chatContext(0);
  demo.droppedProviderId = context.providerId;
  demo.droppedReleaseId = context.releaseId;
}

function truncateMissionLabel(text, max) {
  const trimmed = String(text || '').trim();
  if (!trimmed) return '';
  return trimmed.length <= max ? trimmed : trimmed.slice(0, Math.max(0, max - 1)).trim() + '…';
}

function compactQuickLabel(text, max) {
  return truncateMissionLabel(String(text || '').trim(), max || 14);
}

function compactBlockerLabel(blocker) {
  if (!blocker) return 'Agent fix';
  const category = String(blocker.category || '').trim();
  if (category && category !== 'Quality') return category;
  const title = String(blocker.title || '').trim();
  const keywords = [
    ['monitoring', 'Monitor'],
    ['sentry', 'Sentry'],
    ['webhook', 'Webhook'],
    ['rls', 'RLS'],
    ['supabase', 'Supabase'],
    ['vercel', 'Vercel'],
    ['stripe', 'Billing'],
    ['billing', 'Billing'],
    ['auth', 'Auth'],
    ['secret', 'Secrets'],
    ['env', 'Env vars'],
    ['deploy', 'Deploy'],
    ['error', 'Errors'],
  ];
  const lower = title.toLowerCase();
  for (let i = 0; i < keywords.length; i++) {
    if (lower.includes(keywords[i][0])) return keywords[i][1];
  }
  return compactQuickLabel(title, 14);
}

function compactProviderLabel(provider, missingProvider) {
  if (!provider) return 'Provider';
  if (missingProvider) return 'Connect';
  return compactQuickLabel(provider.name, 12);
}

function rawProviderRecord(providerId) {
  const list = Array.isArray(currentState.providers) ? currentState.providers : [];
  return list.find((item) => item.id === providerId) || null;
}

function formatBlockerLines(blockers, limit) {
  return (Array.isArray(blockers) ? blockers : []).slice(0, limit).map((item, index) =>
    String(index + 1) + '. [' + (item.category || 'Quality') + '] ' + item.title + (item.detail ? ' — ' + item.detail : '')
  ).join('\\n');
}

function formatPlanLines(steps, limit) {
  return (Array.isArray(steps) ? steps : []).slice(0, limit).map((step, index) =>
    String(index + 1) + '. [' + (step.category || 'Quality') + '] ' + step.title + (step.requiresUserAction ? ' (dashboard/user action)' : ' (repo)')
  ).join('\\n');
}

function resolveQuickActionMission(kind, chatIndex, promptOverride) {
  const override = String(promptOverride || '').trim();
  const chat = chatContext(chatIndex);
  const cards = missionCards || { blockers: [], planSteps: [], connectProviders: [], summary: '' };
  const mc = currentState.missionControl || {};
  const gate = currentState.gate || {};
  const providerId = chat.providerId || demo.selectedProviderId;
  const provider = providers.find((item) => item.id === providerId) || selectedProvider();
  const raw = rawProviderRecord(provider.id);
  const slot = stackSlots[provider.id] || provider.area;
  const release = releases.find((item) => item.id === (chat.releaseId || demo.selectedReleaseId));
  const blockers = Array.isArray(cards.blockers) ? cards.blockers : [];
  const planSteps = Array.isArray(cards.planSteps) ? cards.planSteps : [];
  const connectProviders = Array.isArray(cards.connectProviders) ? cards.connectProviders : [];
  const topBlocker = blockers[0];
  const gateClear = gate.status === 'clear';
  const gateLabel = gate.label || 'Waiting for project evidence';
  const mainBlocker = mc.mainBlocker || topBlocker?.title || 'Open context to find what changed';
  const blockerText = formatBlockerLines(blockers, 6);
  const planText = formatPlanLines(planSteps, 8);
  const connectText = connectProviders.slice(0, 5).map((item) => '- ' + item.name + ' (' + item.status + ')').join('\\n');
  const nextFix = raw && raw.nextFix ? raw.nextFix : null;
  const missingProvider = provider.state === 'not_detected';

  const missions = {
    analyze: {
      title: 'Analyzing what changed',
      label: blockers.length ? 'Analyze ' + blockers.length + ' blocker' + (blockers.length === 1 ? '' : 's') : 'Analyze what changed',
      prompt: [
        'Analyze what changed in this project folder.',
        '',
        'Project status: ' + gateLabel + ' (' + (gate.status || 'unknown') + ')',
        'Main blocker: ' + mainBlocker,
        blockers.length ? 'Known blockers from the latest scan:\\n' + blockerText : 'No blockers loaded yet — inspect .viberaven/gate-result.json and agent-tasklist.md if present.',
        connectText ? '\\nProviders needing connect:\\n' + connectText : '',
        '',
        'Instructions:',
        '- Inspect real files in this repo; do not dump CLI install manuals.',
        '- Summarize blockers with evidence paths and severity.',
        '- Recommend the smallest safe next fix and whether to run verify after.',
      ].filter(Boolean).join('\\n'),
      line: 'Reading repo evidence, provider proof, and release context.',
      steps: ['Scan evidence', 'Rank risks', 'Prepare fix plan'],
      notice: blockers.length ? 'Analyzing ' + blockers.length + ' blocker' + (blockers.length === 1 ? '' : 's') + '.' : 'Analyzing what changed.',
    },
    plan: {
      title: 'Building fix plan',
      label: planSteps.length ? 'Fix plan · ' + planSteps.length + ' action' + (planSteps.length === 1 ? '' : 's') : 'Build fix plan',
      prompt: [
        'Build a safe, ordered fix plan from the current what-changed context.',
        '',
        'Project status: ' + gateLabel,
        'Main blocker: ' + mainBlocker,
        blockers.length ? 'Blockers (' + blockers.length + '):\\n' + blockerText : 'No scan blockers loaded — inspect .viberaven artifacts first.',
        planSteps.length ? '\\nSuggested steps from scan:\\n' + planText : '',
        connectText ? '\\nProviders to connect:\\n' + connectText : '',
        '',
        'If the first repo-code step is clear, apply that fix in code before listing the rest.',
        'For each remaining step specify: repo edit vs dashboard/user action, owner (agent vs user), and how to verify.',
        'Keep steps executable in order. Prefer minimal diffs and one gap at a time.',
        'Do not paste generic VibeRaven operator manuals.',
      ].filter(Boolean).join('\\n'),
      line: 'Turning blockers into a short sequence the connected agent can execute.',
      steps: ['Group blockers', 'Scope changes', 'Choose verify'],
      notice: planSteps.length ? 'Fix plan mission started (' + planSteps.length + ' steps from scan).' : 'Fix plan mission started.',
    },
    fix: {
      title: 'Applying scoped fix',
      label: topBlocker ? 'Agent fix · ' + truncateMissionLabel(topBlocker.title, 34) : 'Apply next repo fix',
      prompt: [
        'Apply ONE scoped repo fix for the highest-priority what-changed blocker.',
        '',
        topBlocker ? 'Target blocker: ' + topBlocker.title : 'Target: ' + mainBlocker,
        topBlocker?.detail ? 'Detail: ' + topBlocker.detail : '',
        topBlocker?.id ? 'Gap id: ' + topBlocker.id : '',
        'Provider scope: ' + provider.name + ' / ' + slot,
        nextFix?.whatToChange ? 'Suggested change: ' + nextFix.whatToChange : '',
        nextFix?.prompt ? 'Repair prompt hint: ' + nextFix.prompt : '',
        '',
        'Rules:',
        '- Read existing code, then edit files in this repo. Do not reply with a manual checklist when code changes are possible.',
        '- Change only what this blocker requires.',
        '- Do not claim provider dashboard setup is complete from repo edits alone.',
        '- After edits, list files touched and recommend verify.',
      ].filter(Boolean).join('\\n'),
      line: 'Patching only the selected what-changed gap, then preparing verification.',
      steps: ['Patch code', 'Update proof', 'Prepare verify'],
      notice: topBlocker ? 'Agent fix started for: ' + truncateMissionLabel(topBlocker.title, 48) + '.' : 'Agent fix mission started.',
    },
    verify: {
      title: 'Running verification',
      label: gateClear ? 'Re-verify context' : 'Verify context',
      prompt: [
        'Verify the current what-changed context for this project.',
        '',
        'Project status: ' + gateLabel + ' (' + (gate.status || 'unknown') + ')',
        'Main blocker: ' + mainBlocker,
        blockers.length ? 'Open blockers:\\n' + blockerText : '',
        '',
        'Instructions:',
        '- Prefer running npx -y viberaven --verify when available, or inspect .viberaven/gate-result.json and agent-tasklist.md.',
        '- Report what passed, what still blocks, and any provider dashboard steps remaining.',
        '- Do not mark the gate clear unless evidence supports it.',
      ].filter(Boolean).join('\\n'),
      line: 'Checking evidence, provider state, and release readiness.',
      steps: ['Run checks', 'Read proof', 'Mark status'],
      notice: gateClear ? 'Re-checking release proof.' : 'Checking evidence, provider state, and release context.',
    },
    diff: {
      title: 'Reviewing diff',
      label: 'Review release diff',
      prompt: [
        'Review the current release diff for this project.',
        '',
        'Project status: ' + gateLabel,
        topBlocker ? 'Top blocker context: ' + topBlocker.title : '',
        '',
        'Show grouped changes, flag risky edits, and say what still needs verify before release.',
      ].filter(Boolean).join('\\n'),
      line: 'Opening the scoped launch diff without leaving the mission chat.',
      steps: ['Read diff', 'Group changes', 'Flag risk'],
      notice: 'Diff review mission started.',
    },
    explain: {
      title: 'Explaining changes',
      label: 'Explain changes & next steps',
      prompt: [
        'Explain what changed and what to verify next.',
        '',
        'Project status: ' + gateLabel,
        mainBlocker ? 'Main blocker: ' + mainBlocker : '',
        blockers.length ? 'Active blockers:\\n' + blockerText : '',
        '',
        'Summarize what changed, remaining proof gaps, and the next safe action.',
      ].filter(Boolean).join('\\n'),
      line: 'Summarizing the fix, remaining proof, and next action.',
      steps: ['Summarize fix', 'List proof', 'Next action'],
      notice: 'Explain changes mission started.',
    },
    provider: {
      title: missingProvider ? 'Connecting ' + provider.name : 'Checking ' + provider.name + ' proof',
      label: missingProvider ? 'Connect ' + provider.name : provider.name + ' proof check',
      prompt: missingProvider
        ? [
            'Help connect ' + provider.name + ' for production launch.',
            '',
            'Provider status: Missing (not linked in repo evidence)',
            connectText ? 'Other providers needing connect:\\n' + connectText : '',
            raw?.cockpit?.action?.whereToClick ? 'Dashboard path: ' + raw.cockpit.action.whereToClick : '',
            nextFix?.whatToChange ? 'What to change: ' + nextFix.whatToChange : '',
            '',
            'Return an env checklist, dashboard steps, and repo evidence gaps. Do not claim connected without proof.',
          ].filter(Boolean).join('\\n')
        : [
            'Check ' + provider.name + ' (' + slot + ') production proof.',
            '',
            'Provider status: ' + (provider.status || provider.state || 'unknown'),
            mainBlocker ? 'Launch blocker context: ' + mainBlocker : '',
            nextFix?.whyItMatters ? 'Why it matters: ' + nextFix.whyItMatters : '',
            raw?.cockpit?.proof?.summary ? 'Proof summary: ' + raw.cockpit.proof.summary : '',
            raw?.cockpit?.action?.whereToClick ? 'Dashboard path: ' + raw.cockpit.action.whereToClick : '',
            '',
            'Inspect repo evidence, list missing proof, and give the next safe action (repo vs dashboard).',
          ].filter(Boolean).join('\\n'),
      line: missingProvider
        ? 'Preparing honest connect steps for ' + provider.name + '.'
        : 'Inspecting ' + slot + ' slot status, dashboard action, and verification proof.',
      steps: missingProvider ? ['Check repo', 'List env', 'Dashboard steps'] : ['Read provider', 'Check proof', 'Attach context'],
      notice: missingProvider ? provider.name + ' connect mission started.' : provider.name + ' proof check started.',
    },
    'go-live': {
      title: 'Preparing GitHub and Vercel launch',
      label: 'Go live on GitHub + Vercel',
      prompt: [
        'Take this local project live through GitHub and Vercel with explicit proof.',
        '',
        'Project status: ' + gateLabel + ' (' + (gate.status || 'unknown') + ')',
        'Main blocker: ' + mainBlocker,
        blockers.length ? 'Known blockers from the latest scan:\\n' + blockerText : 'No scan blockers loaded yet - inspect the repo and .viberaven artifacts if present.',
        connectText ? '\\nProviders needing connect:\\n' + connectText : '',
        '',
        'Launch path:',
        '1. Inspect git status, branch, remotes, package scripts, Vercel config, and deploy notes before changing anything.',
        '2. Detect GitHub/Vercel tools with gh --version, gh auth status, vercel --version or npx vercel --version, and vercel whoami or npx vercel whoami.',
        '3. Run the narrowest local build/typecheck/test command that proves the app can ship.',
        '4. If no GitHub remote exists and gh is authenticated, create the repo and push after repo name/visibility are clear. If auth/manual setup is needed, open ' + goLiveUrls.githubLogin + ' or ' + goLiveUrls.githubNew + '.',
        '5. Connect or verify Vercel project linkage, framework/build settings, env var names, and production deploy command. If auth/manual setup is needed, open ' + goLiveUrls.vercelLogin + ', ' + goLiveUrls.vercelNew + ', or ' + goLiveUrls.vercelDashboard + '.',
        '6. Deploy when auth and intent are clear for the selected access mode. Capture deployment URL and verify it if possible.',
        '',
        'Rules:',
        '- Do every safe step directly. Do not stop at a checklist if commands or official pages can move the launch forward.',
        '- Do not include .env files, secrets, build output, or unrelated dirty work in commits.',
        '- Do not ask for passwords, cookies, tokens, API keys, or secret values.',
        '- Do not claim GitHub or Vercel dashboard state is complete without CLI, MCP, dashboard, or live URL proof.',
        '- Avoid destructive git operations and force pushes unless the user explicitly asks and the risk is explained.',
        '',
        'Return a launch receipt with GitHub repo/branch/SHA, Vercel project/deployment URL, local proof command, live proof result, links opened, and remaining dashboard actions.',
      ].filter(Boolean).join('\\n'),
      line: 'Connecting repo evidence to GitHub, Vercel, and live deployment proof.',
      steps: ['Check repo', 'Push GitHub', 'Deploy Vercel', 'Verify live'],
      notice: 'Go Live mission started for GitHub and Vercel.',
    },
  };

  const mission = missions[kind] || missions.analyze;
  if (override) {
    if (kind === 'fix' && override.indexOf('\\n') < 0) {
      return {
        title: mission.title,
        label: 'Agent fix · ' + truncateMissionLabel(override, 34),
        prompt: [
          'Apply ONE scoped repo fix for this launch step.',
          '',
          'Target step: ' + override,
          'Provider scope: ' + provider.name + ' / ' + slot,
          topBlocker?.id ? 'Related gap id: ' + topBlocker.id : '',
          nextFix?.whatToChange ? 'Suggested change: ' + nextFix.whatToChange : '',
          '',
          'Read existing code, edit only what this step requires, then list files touched and recommend verify.',
        ].filter(Boolean).join('\\n'),
        line: mission.line,
        steps: mission.steps,
        notice: 'Agent fix started for: ' + truncateMissionLabel(override, 48) + '.',
      };
    }
    return {
      title: mission.title,
      label: truncateMissionLabel(override, 120),
      prompt: override,
      line: mission.line,
      steps: mission.steps,
      notice: mission.notice,
    };
  }
  return mission;
}

function taskMeta(kind, chatIndex) {
  const index = Number.isFinite(chatIndex) ? chatIndex : (demo.pickerChatIndex || 0);
  const mission = resolveQuickActionMission(kind, index);
  return {
    title: mission.title,
    prompt: mission.prompt,
    line: mission.line,
    steps: mission.steps,
    notice: mission.notice,
  };
}

function quickActionButtonSpec(index) {
  const chat = chatContext(index);
  const cards = missionCards || { blockers: [], planSteps: [] };
  const blockers = Array.isArray(cards.blockers) ? cards.blockers : [];
  const planSteps = Array.isArray(cards.planSteps) ? cards.planSteps : [];
  const topBlocker = blockers[0];
  const provider = chat.providerId
    ? providers.find((item) => item.id === chat.providerId)
    : providers.find((item) => item.id === demo.selectedProviderId) || providers[0];
  const missingProvider = provider && provider.state === 'not_detected';
  const gateClear = currentState.gate && currentState.gate.status === 'clear';
  return [
    {
      action: 'plan',
      icon: 'report',
      label: planSteps.length ? 'Plan · ' + planSteps.length : 'Plan',
      hint: planSteps.length ? 'Build fix plan · ' + planSteps.length + ' actions' : 'Build fix plan',
      primary: true,
    },
    {
      action: 'start-agent-fix',
      icon: 'agent',
      label: compactBlockerLabel(topBlocker),
      hint: topBlocker?.title || 'Apply next repo fix',
      primary: true,
      muted: !topBlocker,
    },
    {
      action: 'verify-now',
      icon: 'shield',
      label: gateClear ? 'Re-verify' : 'Verify',
      hint: gateClear ? 'Re-verify readiness' : 'Verify readiness',
      primary: true,
    },
    {
      action: 'go-live',
      icon: 'cloud',
      label: 'Go live',
      hint: 'Push GitHub + deploy Vercel',
      primary: true,
    },
    {
      action: 'provider-proof',
      icon: 'cube',
      label: compactProviderLabel(provider, missingProvider),
      hint: missingProvider ? 'Connect ' + (provider?.name || 'provider') : 'Check ' + (provider?.name || 'provider') + ' proof',
      primary: false,
    },
    { action: 'show-diff', icon: 'code', label: 'Diff', hint: 'Review code diff', primary: false, muted: true },
    { action: 'explain-changes', icon: 'prompt', label: 'Explain', hint: 'Explain recent changes', primary: false, muted: true },
  ];
}

function runChatTask(kind, promptOverride) {
  clearChatTaskTimer();
  const chatIndex = Math.max(0, Math.min(demo.pickerChatIndex || 0, demo.activeChatCount - 1));
  const chat = chatContext(chatIndex);
  // Product contract: installed is NOT enough — force Test connection before
  // real agent control. If the selected CLI has not passed a connection probe,
  // route to the Terminal setup instead of spawning it.
  if (chat.cliId && chat.cliId !== 'terminal' && !cliAgentReady(chat.cliId)) {
    const agentLabel = (cliAgents.find((item) => item.id === chat.cliId)?.label) || chat.cliId;
    demo.pickerChatIndex = chatIndex;
    demo.notice = 'Connect ' + agentLabel + ' first — run Test connection in the Terminal tab, then send your mission.';
    selectTerminalCli(chat.cliId);
    render();
    return;
  }
  const mission = resolveQuickActionMission(kind, chatIndex, promptOverride);
  const meta = taskMeta(kind, chatIndex);
  const attachedProviderId = chat.providerId || null;
  const attachedReleaseId = chat.releaseId || null;
  const providerId = attachedProviderId || demo.selectedProviderId;
  const releaseId = attachedReleaseId || demo.selectedReleaseId;
  const provider = providers.find((item) => item.id === providerId) || selectedProvider();
  const release = releases.find((item) => item.id === releaseId);
  const label = mission.label || mission.title || 'Mission started';
  const prompt = mission.prompt;
  const taskProviderId = attachedProviderId || (kind === 'provider' ? provider?.id : null);
  const taskReleaseId = attachedReleaseId || null;
  demo.activeStudioTab = 'chat';
  demo.activeChatCount = Math.max(1, demo.activeChatCount);
  demo.activeModal = null;
  chat.messages.push({
    role: 'user',
    text: label,
    providerId: taskProviderId,
    releaseId: taskReleaseId,
    ts: Date.now(),
  });
  chat.activeTask = {
    kind,
    phase: 'working',
    prompt: label,
    response: '',
    error: '',
    providerId: taskProviderId,
    releaseId: taskReleaseId,
    startedAt: Date.now(),
  };
  if (chatIndex === 0) rememberRecentChat(label, provider, release, chat);
  chat.providerId = null;
  chat.releaseId = null;
  if (chatIndex === 0) syncPrimaryContext();
  demo.agentFixing = kind !== 'diff' && kind !== 'explain';
  demo.verified = kind === 'verify' ? false : demo.verified;
  demo.activeStepId = kind === 'verify' ? 'verify' : kind === 'provider' ? 'provider' : 'agent';
  demo.notice = meta.notice;
  render({ scrollToBottom: chatIndex });
  startTaskElapsedTimer();
  const finish = (message, isError, cardsPayload) => {
    const taskContext = chat.activeTask || {};
    const responseText = isError
      ? (message || 'The connected CLI did not return a usable response.')
      : (message || 'Ready for the next safe action.');
    const attachKinds = ['analyze', 'plan', 'provider', 'verify', 'go-live'];
    const cards = attachKinds.includes(kind)
      ? (cardsPayload || missionCards)
      : (cardsPayload && ['diff', 'explain'].includes(kind) ? cardsPayload : null);
    if (cardsPayload) missionCards = cardsPayload;
    chat.messages.push({
      role: 'agent',
      text: responseText,
      kind,
      isError,
      providerId: taskContext.providerId || null,
      releaseId: taskContext.releaseId || null,
      cards: cards || null,
      ts: Date.now(),
    });
    chat.activeTask = null;
    demo.agentFixing = false;
    if (chatIndex === 0) updateActiveRecentChatSnapshot();
    if (kind === 'verify') {
      demo.verified = true;
      demo.activeStepId = 'clear';
      demo.selectedReleaseId = 'v1.3.0';
      demo.notice = 'Verification finished in chat. Launch proof is green.';
    } else if (kind === 'fix') {
      demo.activeStepId = 'verify';
      demo.notice = 'Fix prepared in chat. Run Verify to update release proof.';
    } else {
      demo.notice = taskMeta(kind).title + ' finished in chat.';
    }
    render({ scrollToBottom: chatIndex });
  };
  if (chat.cliId === 'terminal') {
    finish('Terminal chat execution is blocked. Use the Terminal tab for explicit commands.', true);
    return;
  }
  if (typeof fetch !== 'function') {
    chatTaskTimer = window.setTimeout(() => finish('', false), kind === 'verify' ? 1500 : 1250);
    return;
  }
  const providerMcpConnected = Boolean(provider && provider.mcp && provider.mcp.status === 'connected');
  const promptWithMcp = providerMcpConnected
    ? prompt + '\\n\\nThe ' + provider.name + ' MCP server is configured locally (.mcp.json). Use its tools for live provider state instead of guessing from repo code. Steps only possible in the provider dashboard still belong to the user — name them explicitly.'
    : prompt;
  fetch('/api/agent-chat', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({
      cliId: chat.cliId,
      modelId: selectedModelLabel(chatIndex),
      reasoning: chat.reasoning,
      context: chat.context,
      accessMode: chat.accessMode || 'approve',
      prompt: promptWithMcp,
      displayPrompt: label,
      taskKind: kind,
      provider: { id: provider.id, area: provider.area, name: provider.name, mcpConnected: providerMcpConnected },
      release: release ? { id: release.id, label: release.label } : undefined
    })
  })
    .then(async (response) => {
      if (!response.ok) throw new Error(await response.text());
      const payload = await response.json();
      const run = payload && payload.agentRun ? payload.agentRun : {};
      const output = String(run.output || run.stderr || '').trim();
      const failed = Boolean(run.timedOut || run.exitCode === null || Number(run.exitCode) !== 0);
      finish(output || 'The selected local CLI did not return output. Check that it is installed, signed in, and available on PATH.', failed || !output, payload.missionCards || null);
    })
    .catch((error) => {
      finish(error && error.message ? error.message : 'The connected CLI could not be reached.', true);
    });
}

function sendChatInput(chatIndex) {
  const safeIndex = Math.max(0, Math.min(Number(chatIndex) || 0, demo.activeChatCount - 1));
  const input = app.querySelector('[data-chat-input="' + String(safeIndex) + '"]');
  const chat = chatContext(safeIndex);
  const value = String(chat.draft || (input && 'value' in input ? input.value : '') || '').trim();
  demo.pickerChatIndex = safeIndex;
  if (!value) {
    demo.notice = 'Type a mission first, or use a VibeRaven quick action.';
    render();
    return;
  }
  chat.draft = '';
  if (input && 'value' in input) input.value = '';
  runChatTask(chat.releaseId ? 'diff' : chat.providerId ? 'provider' : 'analyze', value);
}

function resetLaunchPreview() {
  demo.activeNavId = 'launch';
  demo.activeStepId = 'repo';
  demo.selectedProviderId = 'supabase';
  demo.selectedReleaseId = 'v1.3.0';
  demo.agentFixing = false;
  demo.verified = false;
  demo.providerPickerOpen = false;
  demo.activeModal = null;
  demo.selectedCliId = 'codex';
  demo.cliConnected = true;
  demo.studioExpanded = false;
  demo.activeChatCount = 1;
  demo.selectedModelId = 'gpt-5.5';
  demo.selectedReasoning = 'High';
  demo.selectedContext = 'Production';
  demo.selectedAccessMode = 'approve';
  demo.modelMenuOpen = false;
  demo.reasoningMenuOpen = false;
  demo.contextMenuOpen = false;
  demo.accessMenuOpen = false;
  demo.pickerChatIndex = 0;
  demo.chatContexts = [defaultChatContext({ cliId: 'codex', modelId: 'gpt-5.5', reasoning: 'High', context: 'Production', accessMode: 'approve' })];
  demo.droppedProviderId = null;
  demo.droppedReleaseId = null;
  clearChatTaskTimer();
}

function SidebarNav() {
  const navItems = [
    ['launch', 'New Launch', 'plus'],
    ['flow', 'Launch Flow', 'bolt'],
    ['providers', 'Providers', 'cube'],
    ['agents', 'Agents', 'agent'],
    ['evidence', 'Evidence', 'doc'],
    ['versions', 'Versions & Releases', 'branch'],
    ['settings', 'Settings', 'gear'],
    ['community', 'Community', 'people'],
  ];
  return '<aside class="vr-sidebar">' +
    '<div class="vr-sidebar-brand"><span class="vr-brand-mascot"><img src="' + mascotAssets.idle + '" alt="" /></span><div><strong>VibeRaven</strong><span>Studio</span></div></div>' +
    '<nav class="vr-sidebar-nav" aria-label="VibeRaven navigation">' +
      navItems.map(([id, label, icon]) => '<button class="' + (id === demo.activeNavId ? 'is-active' : '') + '" type="button" data-nav-target="' + id + '">' + Icon(icon) + '<span>' + label + '</span></button>').join('') +
    '</nav>' +
    '<section class="vr-open-source-card"><strong>Open Source & Community</strong><p>Built for developers taking AI apps to production.</p><a class="vr-github-cta" href="' + publicGithubUrl + '" target="_blank" rel="noreferrer">' + BrandMark('github') + 'GitHub</a>' + GitHubStats() + '</section>' +
    '<div class="vr-workspace-switcher" aria-label="Current workspace"><span></span><div><strong>' + escapeHtml(projectName()) + '</strong><em>Production</em></div></div>' +
    '</aside>';
}

function currentBranchName() {
  const releases = Array.isArray(currentState.releases) ? currentState.releases : [];
  const withBranch = releases.find((release) => release && release.branch && release.branch !== 'local');
  return (withBranch && withBranch.branch) || 'main';
}

function ProjectHeader() {
  return '<header class="vr-project-header">' +
    '<div class="vr-project-id" aria-label="Current project"><span>Project</span><strong>' + escapeHtml(projectName()) + '</strong></div>' +
    StatusBadge('Live', 'green') +
    '<span class="vr-branch-selector" aria-label="Current branch">' + Icon('branch') + '<span>' + escapeHtml(currentBranchName()) + '</span></span>' +
  '</header>';
}

function StudioTopBar() {
  const activeCli = cliAgents.find((item) => item.id === demo.selectedCliId);
  const cliReady = Boolean(demo.cliConnected && activeCli && activeCli.id !== 'terminal');
  const cliLabel = cliReady ? String(activeCli.label || 'CLI').toUpperCase() + ' CONNECTED' : 'NO CLI CONNECTED';
  return '<header class="vr-studio-topbar vr-console" aria-label="VibeRaven Studio header">' +
    '<a class="vr-topbar-brand" href="' + publicGithubUrl + '" target="_blank" rel="noreferrer" aria-label="Open VibeRaven on GitHub"><span><img src="' + mascotAssets.idle + '" alt="" /></span><strong>VibeRaven</strong></a>' +
    '<span class="vr-topbar-spacer"></span>' +
    '<span class="vr-console-cli' + (cliReady ? ' is-on' : '') + '"><i></i>' + escapeHtml(cliLabel) + '</span>' +
  '</header>';
}

function TopStageStrip() {
  return '<nav class="vr-top-stage-strip" aria-label="Launch stage quick navigation">' + topStages.map((stage) => {
    const active = stage.id === demo.activeStepId || (demo.verified && stage.id === 'clear') || (demo.agentFixing && stage.id === 'agent');
    const state = stage.id === 'clear' && demo.verified ? 'Ready' : stage.id === 'verify' && demo.verified ? 'Ready' : stage.id === 'agent' && demo.agentFixing ? 'Fixing' : stage.state;
    return '<button class="' + (active ? 'is-active' : '') + '" type="button" data-stage-step="' + escapeHtml(stage.id) + '">' +
      '<span>' + escapeHtml(stage.number) + '</span><strong>' + escapeHtml(stage.label) + '</strong><em>' + escapeHtml(state) + '</em><b></b>' +
    '</button>';
  }).join('') + '</nav>';
}

function RecentChatRail() {
  return '<aside class="vr-recent-rail" aria-label="Recent production chats">' +
    '<button class="vr-new-chat-button" type="button" data-action="new-chat">' + Icon('plus') + '<span>New Chat</span><kbd>⌘ N</kbd></button>' +
    '<h2>Recent Chats</h2>' +
    '<div class="vr-recent-chat-list">' + recentChats.map((chat) =>
      '<button class="vr-recent-chat ' + (chat.id === demo.activeRecentChatId ? 'is-active' : '') + '" type="button" data-chat-id="' + escapeHtml(chat.id) + '">' +
        Icon('prompt') +
        '<span><strong>' + escapeHtml(chat.title) + '</strong><em>' + escapeHtml(chat.caption) + '</em></span>' +
        '<small>' + escapeHtml(chat.time) + '</small>' +
      '</button>'
    ).join('') + (recentChats.length ? '' : '<p class="vr-recent-empty">No saved chats yet. Split a mission when you need another lane.</p>') + '</div>' +
    '<button class="vr-view-all-chats" type="button" data-action="view-all-chats">View all chats <b></b></button>' +
    '</aside>';
}

function providerVerdictStamp(provider) {
  if (provider.tone === 'green') return '<span class="vr-stamp is-mini is-clear">CLEAR</span>';
  if (provider.tone === 'red' || provider.tone === 'danger') return '<span class="vr-stamp is-mini is-notyet">NOT YET</span>';
  if (provider.state === 'not_detected') return '<span class="vr-stamp is-mini is-idle">EMPTY</span>';
  return '<span class="vr-stamp is-mini is-review">REVIEW</span>';
}

const providerQuickActions = {
  supabase: [
    { label: 'Turn on RLS for open tables', prompt: 'Enable Supabase row-level security: find every table without RLS in my schema or migrations, write a migration enabling RLS with sane owner policies, show me the diff, then run npx -y viberaven --verify.' },
    { label: 'Switch to pooler port 6543', prompt: 'Update my Supabase connection strings to use the transaction pooler port 6543 everywhere in the repo (env samples, config). Show the diff, then verify.' },
  ],
  vercel: [
    { label: 'Sync env vars for production', prompt: 'Compare .env.example against the env vars my code actually reads. List anything missing for Vercel production and add safe placeholders to .env.example. Show the diff.' },
  ],
  stripe: [
    { label: 'Verify webhook signatures', prompt: 'Find my Stripe webhook route and make sure it verifies the stripe-signature header with the webhook secret from env, with test/live separation. Patch it if not, show the diff, then verify.' },
  ],
  sentry: [
    { label: 'Wire the production DSN', prompt: 'Check that Sentry initializes with a DSN from env in production builds so errors actually reach the project. Patch gaps, show the diff, then verify.' },
  ],
  github: [
    { label: 'Add a CI safety net', prompt: 'Add a minimal GitHub Actions workflow that runs install, typecheck, and tests on pull requests. Show me the file before finalizing.' },
  ],
  posthog: [
    { label: 'Guard the analytics key', prompt: 'Make sure the PostHog key comes from env, capture is disabled in dev, and nothing is hardcoded. Patch and show the diff.' },
  ],
};

function ProviderQuickActions(providerId) {
  const actions = providerQuickActions[providerId] || [];
  if (!actions.length) return '';
  return '<section class="vr-quickstrike"><header>Quick actions &middot; one click stages the mission</header>' +
    actions.map((action) =>
      '<div><span>' + escapeHtml(action.label) + '</span><button type="button" data-action="arch-preset" data-prompt="' + escapeHtml(action.prompt) + '">Run</button></div>'
    ).join('') +
  '</section>';
}

function ReleaseCard(release) {
  const selected = release.id === demo.selectedReleaseId;
  return '<button class="vr-release-card ' + (selected ? 'is-selected' : '') + '" draggable="true" data-release="' + escapeHtml(release.id) + '" data-tone="' + escapeHtml(release.tone) + '" type="button">' +
    '<small>' + (release.tone === 'current' ? 'Current Release' : release.tone === 'prod' ? 'Stable' : '&nbsp;') + '</small>' +
    '<strong>' + escapeHtml(release.label) + '</strong>' +
    '<em>' + escapeHtml(release.meta) + ' &middot; ' + escapeHtml(release.branch) + '</em>' +
    '</button>';
}

function VersionTimeline() {
  const selected = releases.find((item) => item.id === demo.selectedReleaseId) || releases[0];
  const currentRelease = releases[0];
  const previousReleases = releases.slice(1, 4);
  return '<section class="vr-releases-panel" aria-label="Versions and releases">' +
    '<div class="vr-panel-head"><div><h2>Versions & Releases</h2><p>Current release, rollback context, and changelog actions.</p></div></div>' +
    '<div class="vr-release-composition">' +
      '<button class="vr-release-card vr-release-current ' + (currentRelease.id === demo.selectedReleaseId ? 'is-selected' : '') + '" draggable="true" data-release="' + escapeHtml(currentRelease.id) + '" data-tone="' + escapeHtml(currentRelease.tone) + '" type="button">' +
        '<small>Current Release</small><strong>' + escapeHtml(currentRelease.label) + '</strong><em>' + escapeHtml(currentRelease.meta) + ' &middot; ' + escapeHtml(currentRelease.branch) + '</em><span>' + escapeHtml(currentRelease.summary || 'Local release context') + '</span>' +
      '</button>' +
      '<section class="vr-release-list"><header><strong>Recent Versions</strong><button type="button" data-action="all-releases">View all</button></header>' +
        (previousReleases.length > 0 ? previousReleases.map((release) => '<button class="vr-release-row ' + (release.id === demo.selectedReleaseId ? 'is-selected' : '') + '" draggable="true" data-release="' + escapeHtml(release.id) + '" data-tone="' + escapeHtml(release.tone) + '" type="button"><span><strong>' + escapeHtml(release.label) + '</strong><em>' + escapeHtml(release.summary || release.branch) + '</em></span><small>' + escapeHtml(release.meta) + '</small></button>').join('') : '<div class="vr-release-empty">No previous releases detected.</div>') +
      '</section>' +
    '</div>' +
    '<div class="vr-release-actions"><button type="button" data-action="compare">' + Icon('branch') + 'Compare Releases</button><button type="button" data-action="changelog">' + Icon('report') + 'View Changelog</button><button type="button" data-action="rollback-release">' + Icon('refresh') + 'Rollback</button></div>' +
    '<div class="vr-release-track" aria-hidden="true">' + releases.map(ReleaseCard).join('') + '</div>' +
    '<div class="vr-timeline-rail">' + releases.map((release) => '<span class="' + (release.id === selected.id ? 'is-selected' : '') + '"></span>').join('') + '</div>' +
    '<p class="vr-release-detail">Selected release: <strong>' + escapeHtml(selected.label) + '</strong> &middot; branch ' + escapeHtml(selected.branch) + '</p>' +
    '</section>';
}

function ModalShell(kind, body) {
  const stableClass = stableModalRender ? ' is-stable-render' : '';
  return '<section class="vr-modal-backdrop' + stableClass + '" data-modal-backdrop="' + escapeHtml(kind) + '" aria-label="Preview detail modal">' +
    '<div class="vr-modal-card vr-modal-' + escapeHtml(kind) + stableClass + '" role="dialog" aria-modal="true">' +
      '<button class="vr-modal-close" type="button" data-action="close-modal" aria-label="Close">' + Icon('x') + '</button>' +
      body +
    '</div>' +
    '</section>';
}

function ModalCheck(label, caption, state, statusText) {
  const status = statusText || (state === 'done' ? 'OK' : state === 'running' ? 'Running' : state === 'active' ? 'Ready' : 'Pending');
  return '<li class="' + escapeHtml(state) + '"><span></span><div><strong>' + escapeHtml(label) + '</strong><em>' + escapeHtml(caption) + '</em></div><b>' + escapeHtml(status) + '</b></li>';
}

function AgentModal() {
  const fixing = demo.agentFixing;
  const verified = demo.verified;
  return ModalShell('agent',
    '<header class="vr-modal-agent-head">' +
      '<img class="vr-modal-agent-avatar" src="' + mascotUrl() + '" alt="" />' +
      '<div><p>Agent Action</p><h2>VibeRaven</h2><em>' + (verified ? 'Everything is verified in preview mode.' : fixing ? 'I am fixing the evidenced change now.' : 'I will fix the issue with release and provider context.') + '</em></div>' +
      '<aside>' + Icon('clock') + '<span>' + (verified ? 'Status' : 'Estimated time') + '</span><strong>' + (verified ? 'Complete' : fixing ? 'Running' : '2 - 4 min') + '</strong></aside>' +
    '</header>' +
    '<section class="vr-modal-tasklist"><h3>Task checklist</h3><ul>' +
      ModalCheck('Diagnose issue', 'Find the highest-impact context gap.', fixing || verified ? 'done' : 'active', fixing || verified ? 'OK' : 'Ready') +
      ModalCheck('Apply focused fix', 'Patch only the evidenced change.', verified ? 'done' : fixing ? 'running' : 'pending', verified ? 'OK' : fixing ? 'Running' : 'Pending') +
      ModalCheck('Run verification tests', 'Confirm the flow is safe after the fix.', verified ? 'done' : fixing ? 'active' : 'pending', verified ? 'OK' : fixing ? 'Queued' : 'Pending') +
      ModalCheck('Confirm systems operational', 'Move the launch flow to clear.', verified ? 'done' : 'pending') +
    '</ul></section>' +
    '<section class="vr-modal-progress ' + (!verified && !fixing ? 'is-ready' : '') + '">' + Icon('shield') + '<div><strong>' + (verified ? 'Verification complete' : fixing ? 'Fix in progress' : 'Ready for focused fix') + '</strong><p>' + (verified ? 'The launch flow is green in preview mode.' : fixing ? 'Running checks to keep the fix grounded.' : 'Start the agent when you are ready to patch the evidenced change.') + '</p></div>' + Icon('spark') + '</section>' +
    '<div class="vr-modal-button-row">' +
      GlowButton(fixing ? 'Fixing...' : verified ? 'Complete' : 'Start Agent Fix', { action: 'start-agent-fix', tone: verified ? 'green' : 'purple' }) +
      '<button type="button" data-action="verify-now">Verify Now</button>' +
    '</div>' +
    '<footer class="vr-modal-safe">' + Icon('lock') + 'Safe. Verified. Automated.</footer>'
  );
}

function GuideModal() {
  const provider = providers.find((item) => item.id === demo.selectedProviderId) || providers[0];
  return ModalShell('guide',
    '<header class="vr-modal-guide-head">' +
      '<img class="vr-modal-agent-avatar" src="' + mascotAssets.idle + '" alt="" />' +
      '<div><p>Launch Guide</p><h2>Next best move</h2><em>Keep the flow simple: inspect proof, hand off the scoped fix, then verify.</em></div>' +
      '<aside>' + Icon('spark') + '<span>Focus</span><strong>' + escapeHtml(provider.name) + '</strong></aside>' +
    '</header>' +
    '<section class="vr-modal-flow-list">' +
      '<button type="button" data-provider="' + escapeHtml(provider.id) + '"><span>1</span><div><strong>Review provider proof</strong><em>Open ' + escapeHtml(provider.name) + ' status and dashboard action.</em></div>' + Icon('external') + '</button>' +
      '<button type="button" data-action="prompt"><span>2</span><div><strong>Open agent mission</strong><em>Give the connected CLI one evidenced change, not the whole app.</em></div>' + Icon('prompt') + '</button>' +
      '<button type="button" data-action="verify-now"><span>3</span><div><strong>Verify the flow</strong><em>Turn the launch path green after the focused fix.</em></div>' + Icon('check') + '</button>' +
    '</section>'
  );
}

function PromptModal() {
  return ModalShell('prompt',
    '<header class="vr-modal-prompt-head">' +
      '<img class="vr-modal-agent-avatar" src="' + mascotAssets.fixing + '" alt="" />' +
      '<div><p>Agent Mission</p><h2>Scoped handoff</h2><em>One clear mission for the connected coding agent.</em></div>' +
      '<aside>' + Icon('lock') + '<span>Scope</span><strong>One gap</strong></aside>' +
    '</header>' +
    '<section class="vr-modal-prompt-card"><pre>' + escapeHtml(agentPromptText()) + '</pre></section>' +
    '<div class="vr-modal-button-row">' +
      GlowButton('Use mission', { action: 'copy-prompt', tone: 'purple' }) +
      '<button type="button" data-action="start-agent-fix">' + Icon('agent') + 'Start Agent Fix</button>' +
      '<button type="button" data-action="guide">' + Icon('guide') + 'Guide me</button>' +
    '</div>'
  );
}

function PlanModal() {
  const provider = providers.find((item) => item.id === demo.selectedProviderId) || providers[0];
  return ModalShell('plan',
    '<header class="vr-modal-guide-head">' +
      '<img class="vr-modal-agent-avatar" src="' + mascotAssets.idle + '" alt="" />' +
      '<div><p>Release Plan</p><h2>Safe fix path</h2><em>One scoped mission: understand what changed, fix it, then prepare release proof.</em></div>' +
      '<aside>' + Icon('shield') + '<span>Context</span><strong>' + escapeHtml(provider.name) + '</strong></aside>' +
    '</header>' +
    '<section class="vr-modal-flow-list">' +
      '<button type="button" data-action="add-context"><span>1</span><div><strong>Add launch context</strong><em>Drag a provider or version into chat so the agent has the exact proof target.</em></div>' + Icon('plus') + '</button>' +
      '<button type="button" data-action="prompt"><span>2</span><div><strong>Open scoped mission</strong><em>Use a context-aware prompt tied to ' + escapeHtml(provider.area) + ' evidence.</em></div>' + Icon('prompt') + '</button>' +
      '<button type="button" data-action="start-agent-fix"><span>3</span><div><strong>Apply one fix</strong><em>Send the connected model to patch the evidenced change only.</em></div>' + Icon('agent') + '</button>' +
      '<button type="button" data-action="show-diff"><span>4</span><div><strong>Review diff</strong><em>Inspect repo changes before accepting verification.</em></div>' + Icon('code') + '</button>' +
      '<button type="button" data-action="verify-now"><span>5</span><div><strong>Run verify</strong><em>Move the mission into a green verified state after review.</em></div>' + Icon('check') + '</button>' +
    '</section>' +
    '<div class="vr-modal-button-row">' +
      GlowButton('Apply Fix', { action: 'start-agent-fix', tone: 'purple' }) +
      '<button type="button" data-action="show-diff">' + Icon('code') + 'Open Diff</button>' +
      '<button type="button" data-action="provider-proof">' + Icon('cube') + 'Provider Proof</button>' +
    '</div>'
  );
}

function ExplainModal() {
  const provider = providers.find((item) => item.id === demo.selectedProviderId) || providers[0];
  const release = releases.find((item) => item.id === demo.selectedReleaseId) || releases[0];
  return ModalShell('explain',
    '<header class="vr-modal-prompt-head">' +
      '<img class="vr-modal-agent-avatar" src="' + (demo.verified ? mascotAssets.verified : mascotAssets.fixing) + '" alt="" />' +
      '<div><p>Change Summary</p><h2>What changed</h2><em>A short launch-safe explanation for the connected chat, release notes, or reviewer.</em></div>' +
      '<aside>' + Icon('repo') + '<span>Release</span><strong>' + escapeHtml(release.label) + '</strong></aside>' +
    '</header>' +
    '<div class="vr-modal-two-col">' +
      '<section><h3>' + Icon('shield') + 'Fix summary</h3><p>VibeRaven scoped the mission to ' + escapeHtml(provider.area) + ' proof. The preview diff adds guarded monitoring capture and keeps provider dashboard work separate from repo evidence.</p></section>' +
      '<section><h3>' + Icon('check') + 'Verify next</h3><dl><dt>Provider</dt><dd>' + escapeHtml(provider.name) + '</dd><dt>Branch</dt><dd>' + escapeHtml(release.branch || 'main') + '</dd><dt>Context</dt><dd>' + escapeHtml(demo.selectedContext) + '</dd></dl></section>' +
    '</div>' +
    '<section class="vr-modal-notes"><h3>' + Icon('prompt') + 'Agent-ready wording</h3><p>Explain the diff in production terms: what blocker was reduced, what evidence changed, what still needs dashboard proof, and which verify action should run next.</p></section>' +
    '<div class="vr-modal-button-row">' +
      GlowButton('Send to Chat', { action: 'prompt', tone: 'purple' }) +
      '<button type="button" data-action="show-diff">' + Icon('code') + 'Open Diff</button>' +
      '<button type="button" data-action="verify-now">' + Icon('shield') + 'Run Verify</button>' +
    '</div>'
  );
}

function NotificationsModal() {
  return ModalShell('notifications',
    '<header class="vr-modal-guide-head">' +
      '<img class="vr-modal-agent-avatar" src="' + (demo.verified ? mascotAssets.verified : mascotAssets.alert) + '" alt="" />' +
      '<div><p>Launch Signals</p><h2>' + (demo.verified ? 'Flow is green' : 'Needs attention') + '</h2><em>Only the actions that matter for this launch are shown.</em></div>' +
      '<aside>' + Icon('bell') + '<span>Status</span><strong>' + (demo.verified ? 'Clear' : '6 checks') + '</strong></aside>' +
    '</header>' +
    '<section class="vr-modal-signal-list">' +
      ModalCheck('Repo evidence', demo.verified ? 'Evidence has been verified in preview mode.' : 'One blocker is still active before launch.', demo.verified ? 'done' : 'active') +
      ModalCheck('Provider proof', 'Connected services are available to inspect.', 'done') +
      ModalCheck('Agent fix', demo.agentFixing ? 'Agent fix is running now.' : 'Ready to start a scoped fix.', demo.agentFixing || demo.verified ? 'done' : 'pending') +
      ModalCheck('Verification', demo.verified ? 'Verification state is green.' : 'Run verification after the scoped fix.', demo.verified ? 'done' : 'pending') +
    '</section>' +
    '<div class="vr-modal-button-row">' +
      GlowButton(demo.verified ? 'Verified' : 'Start Agent Fix', { action: demo.verified ? 'verify-now' : 'start-agent-fix', tone: demo.verified ? 'green' : 'purple' }) +
      '<button type="button" data-action="guide">' + Icon('guide') + 'Guide me</button>' +
      '<button type="button" data-action="prompt">' + Icon('prompt') + 'Open mission</button>' +
    '</div>'
  );
}

function cliSetupFor(agentId) {
  const agent = cliAgents.find((item) => item.id === agentId);
  return agent && agent.setup ? agent.setup : {
    installCommand: 'npm install -g ' + agentId,
    signInCommand: agentId,
    verifyCommand: agentId + ' --version',
    docsUrl: docsUrl,
  };
}

function connectedCodingAgents() {
  return cliAgents.filter((agent) => agent.id !== 'terminal' && cliAgentReady(agent.id));
}

function studioFreshQuery() {
  try {
    return new URLSearchParams(window.location.search).get('fresh') === '1' ? '?fresh=1' : '';
  } catch {
    return '';
  }
}

function markCliSetupComplete(agentId, chatIndex) {
  connectCliAgent(agentId, chatIndex || 0, { completeSetup: true });
}

function connectCliAgent(agentId, chatIndex, options) {
  const opts = options || {};
  if (!agentId || agentId === 'terminal') return;
  markCliSessionReady(agentId);
  demo.cliConnected = true;
  demo.selectedCliId = agentId;
  demo.cliLastConnectTargetId = agentId;
  demo.cliConnectTargetId = null;
  if (!opts.keepProbeState) {
    demo.cliProbeStatus = 'idle';
    demo.cliProbeMessage = '';
  }
  const models = cliModels[agentId] || cliModels.codex;
  const chat = chatContext(chatIndex || 0);
  chat.cliId = agentId;
  if (models && models.length) {
    chat.modelId = normalizeModelId(models[0]);
    demo.selectedModelId = chat.modelId;
  }
  demo.pickerChatIndex = chatIndex || 0;
  if (opts.completeSetup) {
    demo.cliSetupComplete = true;
    demo.chatContexts.forEach((context) => {
      context.cliId = agentId;
      if (models && models.length) context.modelId = normalizeModelId(models[0]);
    });
  }
}

function cliSetupProbeLabel() {
  return demo.cliProbeStatus === 'probing' ? 'Testing...' : demo.cliProbeStatus === 'success' ? 'Connected' : demo.cliProbeStatus === 'failed' ? 'Try again' : 'Test connection';
}

function CliSetupActions(targetId, index) {
  const setup = cliSetupFor(targetId);
  const probeLabel = cliSetupProbeLabel();
  return '<div class="vr-cli-connect-expand-actions">' +
    '<button class="vr-cli-action-button" type="button" data-action="run-cli-install" data-cli-agent="' + escapeHtml(targetId) + '" data-chat-index="' + String(index) + '">' + Icon('shell') + 'Run install</button>' +
    '<button class="vr-cli-action-button" type="button" data-action="run-cli-signin" data-cli-agent="' + escapeHtml(targetId) + '" data-chat-index="' + String(index) + '">' + Icon('shell') + 'Run sign in</button>' +
    '<button class="vr-cli-action-button is-primary" type="button" data-action="test-cli-connection" data-cli-agent="' + escapeHtml(targetId) + '" data-chat-index="' + String(index) + '">' + Icon('refresh') + escapeHtml(probeLabel) + '</button>' +
    '</div>' +
    '<p class="vr-cli-setup-hint">Run install and sign in, then use <strong>Test connection</strong> to unlock chat control. Commands: <code>' + escapeHtml(setup.installCommand) + '</code> then <code>' + escapeHtml(setup.signInCommand) + '</code></p>';
}

function appendTerminalLines(lines) {
  const next = Array.isArray(lines) ? lines : [lines];
  demo.cliTerminalLines = demo.cliTerminalLines.concat(next);
}

function resetCliConnectFlow(options) {
  const opts = options || {};
  if (opts.fullReset) {
    demo.cliConnectTargetId = null;
    demo.cliLastConnectTargetId = null;
  } else {
    const preserved = demo.cliConnectTargetId || demo.cliLastConnectTargetId || terminalTargetId();
    setConnectTarget(preserved);
  }
  if (!opts.keepLog) demo.cliTerminalLines = [];
  demo.cliTerminalTitle = opts.fullReset ? '' : 'Connect coding CLI';
  demo.cliTerminalDraft = '';
  demo.cliProbeStatus = 'idle';
  demo.cliProbeMessage = '';
  demo.cliConnectCompleteAgentId = null;
  demo.activeModal = null;
  if (opts.fullReset) {
    demo.cliSetupComplete = false;
    demo.cliConnected = false;
    demo.cliSessionReady = {};
    writeCliSessionReady({});
  }
}

async function runStudioShellCommand(command, label, cliId) {
  const trimmed = String(command || '').trim();
  if (!trimmed) return;
  appendTerminalLines(['$ ' + trimmed]);
  if (label) demo.cliTerminalTitle = label;
  render();
  try {
    const requestedCliId = typeof cliId === 'string' && (cliId === 'codex' || cliId === 'claude' || cliId === 'gemini') ? cliId : undefined;
    const response = await fetch('/api/cli-agents/run-command', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ command: trimmed, ...(requestedCliId ? { cliId: requestedCliId } : {}) }),
    });
    const payload = await response.json().catch(() => null);
    if (!response.ok) {
      appendTerminalLines([
        String(payload?.message || payload?.error || 'Command could not run from Studio terminal.'),
        ''
      ]);
      render();
      return;
    }
    appendTerminalLines([
      String(payload?.output || payload?.message || 'Command finished.'),
      ''
    ]);
  } catch {
    appendTerminalLines(['Command could not run from Studio terminal.', '']);
  }
  render();
}

function selectTerminalCli(agentId) {
  const agent = cliAgents.find((item) => item.id === agentId);
  if (!agent || agent.id === 'terminal') return;
  setConnectTarget(agent.id);
  demo.cliTerminalTitle = 'Connect ' + (agent.label || agent.id);
  demo.activeStudioTab = 'terminal';
  if (!demo.cliTerminalLines.length) {
    demo.cliTerminalLines = [
      'VibeRaven Studio shell',
      'Run install, run sign in, then use Test connection to continue.',
      ''
    ];
  } else {
    appendTerminalLines(['--- switched to ' + (agent.label || agent.id) + ' ---', '']);
  }
  demo.cliTerminalDraft = cliSetupFor(agent.id).signInCommand;
  demo.cliProbeStatus = 'idle';
  demo.cliProbeMessage = '';
  render();
}

function TerminalCliSwitcher() {
  const targetId = terminalTargetId();
  const codingAgents = cliAgents.filter((agent) => agent.id !== 'terminal');
  return '<div class="vr-terminal-cli-switch">' + codingAgents.map((agent) => {
    const active = agent.id === targetId;
    const ready = cliAgentReady(agent.id);
    const installed = cliAgentInstalled(agent);
    const status = ready ? 'ready' : installed ? 'signin' : 'setup';
    return '<button class="vr-terminal-cli-chip ' + (active ? 'is-active' : '') + ' is-' + status + '" type="button" data-action="terminal-select-cli" data-cli-agent="' + escapeHtml(agent.id) + '" title="' + escapeHtml(ready ? 'Ready for chat' : installed ? 'Installed — sign in required' : 'Not installed') + '"><span></span><strong>' + escapeHtml(agent.label) + '</strong></button>';
  }).join('') + '</div>';
}

function StudioTerminalView() {
  const targetId = terminalTargetId();
  const agent = cliAgents.find((item) => item.id === targetId) || cliAgents[0];
  const showToolbar = shouldShowConnectToolbar();
  const shellDraft = demo.cliTerminalDraft || '';
  const lines = demo.cliTerminalLines.length
    ? demo.cliTerminalLines
    : [
      'VibeRaven Studio shell',
        'Type commands at the $ prompt. Use Test connection after sign-in.',
        ''
      ];
  const title = terminalConnectTitle(agent);
  const statusText = terminalStatusLabel(targetId);
  const toolbarTarget = demo.cliConnectTargetId || demo.cliLastConnectTargetId || targetId;
  return '<section class="vr-studio-terminal" aria-label="Connected agent terminal">' +
    '<header class="vr-terminal-head">' +
      '<div class="vr-terminal-head-copy"><strong>' + escapeHtml(title) + '</strong><span>' + escapeHtml(statusText) + '</span></div>' +
      TerminalCliSwitcher() +
    '</header>' +
    '<div class="vr-terminal-screen" data-terminal-screen>' +
      '<div class="vr-terminal-scroll" data-terminal-scroll>' +
        lines.map((line) => '<div class="vr-terminal-line">' + escapeHtml(line) + '</div>').join('') +
      '</div>' +
      '<div class="vr-terminal-input-row">' +
        '<span class="vr-terminal-prompt">$</span>' +
        '<input type="text" class="vr-terminal-cursor-input" data-terminal-shell-input autocomplete="off" spellcheck="false" value="' + escapeHtml(shellDraft) + '" aria-label="Terminal command input" />' +
      '</div>' +
    '</div>' +
    (showToolbar
      ? '<div class="vr-terminal-toolbar">' + CliSetupActions(toolbarTarget, demo.pickerChatIndex || 0) +
        '<button class="vr-cli-os-fallback" type="button" data-action="open-os-terminal" data-cli-agent="' + escapeHtml(toolbarTarget) + '" data-chat-index="' + String(demo.pickerChatIndex || 0) + '">' + Icon('external') + 'Open OS terminal instead</button></div>'
      : '') +
    '</section>';
}

function CliConnectCompleteModal() {
  const agentId = demo.cliConnectCompleteAgentId || terminalTargetId();
  const agent = cliAgents.find((item) => item.id === agentId) || cliAgents[0];
  return ModalShell('connect-complete',
    '<header class="vr-modal-agent-head">' +
      '<img class="vr-modal-agent-avatar" src="' + mascotAssets.verified + '" alt="" />' +
      '<div><p>CLI ready</p><h2>' + escapeHtml(agent.label) + ' connected</h2><em>Reset only if you switched accounts or want to test first-time setup again.</em></div>' +
    '</header>' +
    '<section class="vr-modal-connect-note">' + Icon('spark') + '<span>Start chatting, or reset the connect flow if login still looks stale.</span></section>' +
    '<div class="vr-modal-button-row">' +
      GlowButton('Start chatting', { action: 'connect-complete-chat', tone: 'green', dataCliAgent: agentId }) +
      '<button type="button" data-action="reset-cli-connect" data-reset-mode="soft">Reset connect flow</button>' +
      '<button type="button" data-action="reset-cli-connect" data-reset-mode="full">Full reset</button>' +
    '</div>'
  );
}

function ChatFirstTimeConnect(index) {
  const codingAgents = cliAgents.filter((agent) => agent.id !== 'terminal');
  const targetAgent = (demo.cliConnectTargetId || demo.cliLastConnectTargetId)
    ? cliAgents.find((item) => item.id === (demo.cliConnectTargetId || demo.cliLastConnectTargetId))
    : null;
  const hintLine = targetAgent
    ? '<p class="vr-chat-first-connect-note">Continuing <strong>' + escapeHtml(targetAgent.label) + '</strong> in the Terminal tab.</p>'
    : '<p class="vr-chat-first-connect-note">Click Connect to open the Terminal tab — install, sign in, then test connection.</p>';
  return '<section class="vr-chat-empty-state vr-chat-first-connect" data-chat-index="' + String(index) + '">' +
    '<strong>First time</strong>' +
    '<span>Connect your repo agent through VibeRaven Studio.</span>' +
    '<div class="vr-cli-strip is-inline">' + codingAgents.map((agent) => CliAgentButton(agent, index)).join('') + '</div>' +
    hintLine +
  '</section>';
}

function QuickstartModal() {
  const agentConnected = cliAgents.some((agent) => agent.id !== 'terminal' && agent.connected);
  const missionRun = recentChats.length > 0 || (demo.chatContexts[0] && demo.chatContexts[0].messages.length > 0);
  const mapVisited = Boolean(demo.archVisited);
  const qsArts = {
    1: '<span class="vr-qs-glyph">' + Icon('repo') + '</span>',
    2: '<span class="vr-qs-clilogos">' +
        '<i data-cli="codex" title="Codex CLI">' + cliGlyphs.codex + '</i>' +
        '<i data-cli="claude" title="Claude Code">' + cliGlyphs.claude + '</i>' +
        '<i data-cli="gemini" title="Gemini CLI">' + cliGlyphs.gemini + '</i>' +
      '</span>',
    3: '<span class="vr-qs-minifan"><i></i><i></i><i></i></span>',
    4: '<span class="vr-qs-glyph">' + Icon('branch') + '</span>',
  };
  const qsTypes = { 1: 'SETUP', 2: 'AGENTS', 3: 'YOUR HAND', 4: 'TERRITORY' };
  const card = (index, done, title, caption, action, label) =>
    '<div class="vr-qs-card is-hero' + (done ? ' is-done' : '') + (done || demo.flippedCards['qs:' + String(index)] ? ' is-flipped' : '') + '" data-flip-card data-flip-id="qs:' + String(index) + '" data-step="' + String(index) + '">' +
      '<span class="vr-flip-inner">' +
        '<span class="vr-flip-back vr-qs-back" data-action="flip-discover" role="button" tabindex="0" aria-label="Flip step ' + String(index) + '">' +
          '<img src="' + mascotAssets.idle + '" alt="" />' +
          '<b>FLIP</b>' +
        '</span>' +
        '<span class="vr-flip-face">' +
          '<span class="vr-tcard-sheen" aria-hidden="true"></span>' +
          '<span class="vr-qs-card-inner">' +
            '<span class="vr-qs-card-top"><strong>' + title + '</strong><b>' + String(index) + '</b></span>' +
            '<span class="vr-qs-art">' + (qsArts[index] || '') + '</span>' +
            '<span class="vr-qs-type">' + (qsTypes[index] || 'STEP') + (done ? ' &middot; <i class="vr-qs-won">' + Icon('check') + '</i> WON' : '') + '</span>' +
            '<em>' + caption + '</em>' +
            (done
              ? '<span class="vr-qs-claimed">IN YOUR HAND</span>'
              : '<button type="button" data-action="quickstart-go" data-step="' + action + '">' + label + '</button>') +
          '</span>' +
        '</span>' +
      '</span>' +
    '</div>';
  return ModalShell('quickstart',
    '<header class="vr-qs-head">' +
      '<img class="vr-qs-raven" src="' + mascotAssets.verified + '" alt="The VibeRaven card collector" />' +
      '<div>' +
        '<h2>Welcome to the table</h2>' +
        '<p>Draw your starting hand — four cards between you and production.</p>' +
        '<span class="vr-qs-local">LOCAL &middot; NO LOGIN &middot; YOUR REPO STAYS YOURS</span>' +
      '</div>' +
    '</header>' +
    '<div class="vr-qs-deal">' +
      card(1, true, 'Scan your repo', 'Dealt automatically — providers, releases, and launch blockers read offline.', '', '') +
      card(2, agentConnected, 'Connect your agent', 'Codex, Claude Code, or Gemini CLI — you control its access.', 'connect', 'Connect') +
      card(3, missionRun, 'Play your first card', 'Click a card in your hand — its checks run right here in chat.', 'fix', 'Fix now') +
      card(4, mapVisited, 'Open the region map', 'Your whole app as territory. Weak spots glow.', 'map', 'Open map') +
    '</div>' +
    '<footer class="vr-qs-foot"><button type="button" data-action="quickstart-dismiss">Don\\'t show this again</button><span>Everything here stays one click away at the table.</span></footer>'
  );
}

function DiscoveryModal() {
  const found = providers.filter((provider) => provider.state !== 'not_detected');
  const hashRank = (id) => { let h = 0; for (let i = 0; i < id.length; i += 1) h = (h * 31 + id.charCodeAt(i)) >>> 0; return h; };
  const rankFor = (provider) => {
    const tier = provider.grade ? provider.grade.tier : 'review';
    if (tier === 'flawless') return ['legendary', 'LEGENDARY'];
    if (tier === 'clear') return ['epic', 'EPIC'];
    // ungraded providers still deal a real pack spread (common..legendary)
    const r = hashRank(provider.id) % 12;
    if (r === 0) return ['legendary', 'LEGENDARY'];
    if (r < 4) return ['epic', 'EPIC'];
    if (r < 10) return ['rare', 'RARE'];
    return ['common', 'COMMON'];
  };
  const cards = found.map((provider, index) => {
    const rank = rankFor(provider);
    return '<div class="vr-discover-card' + (demo.flippedCards['disc:' + provider.id] ? ' is-flipped' : '') + '" data-flip-card data-flip-id="disc:' + escapeHtml(provider.id) + '" data-rank="' + rank[0] + '" style="--vr-i:' + String(index) + '">' +
      '<span class="vr-flip-inner">' +
        '<span class="vr-flip-back vr-tcard is-back is-dealt" data-action="flip-discover" role="button" tabindex="0" aria-label="Flip to reveal ' + escapeHtml(provider.name) + '">' +
          '<span class="vr-tcard-backart"><span class="vr-pack-seal" aria-hidden="true">&#10022;</span></span>' +
          '<span class="vr-tcard-backname">Flip to reveal</span>' +
        '</span>' +
        '<span class="vr-flip-face">' +
          TradingCard(provider, 'dealt', { asDiv: true, forceFace: true }) +
          '<em class="vr-discover-rank">' + rank[1] + '</em>' +
        '</span>' +
      '</span>' +
    '</div>';
  }).join('');
  return ModalShell('discover',
    '<header class="vr-qs-head">' +
      '<img class="vr-qs-raven" src="' + mascotAssets.verified + '" alt="The VibeRaven card collector" />' +
      '<div>' +
        '<h2>Your pack is ready</h2>' +
        '<p>We scanned the repo and pulled ' + String(found.length) + ' provider cards. Flip them over.</p>' +
        '<span class="vr-qs-local">LOCAL &middot; NO LOGIN &middot; YOUR REPO STAYS YOURS</span>' +
      '</div>' +
    '</header>' +
    '<div class="vr-discover-grid">' + cards + '</div>' +
    '<footer class="vr-qs-foot">' +
      '<button type="button" data-action="discover-reveal-all">Reveal all</button>' +
      '<button class="vr-discover-take" type="button" data-action="discover-done">Take them to the table &#9656;</button>' +
    '</footer>'
  );
}

function ActiveModal() {
  if (demo.activeModal === 'connect-complete') return CliConnectCompleteModal();
  if (demo.activeModal === 'discover') return DiscoveryModal();
  if (demo.activeModal === 'quickstart') return QuickstartModal();
  if (demo.activeModal === 'worktree') return WorktreeModal();
  if (demo.activeModal === 'agent') return AgentModal();
  if (demo.activeModal === 'guide') return GuideModal();
  if (demo.activeModal === 'prompt') return PromptModal();
  if (demo.activeModal === 'plan') return PlanModal();
  if (demo.activeModal === 'explain') return ExplainModal();
  if (demo.activeModal === 'notifications') return NotificationsModal();
  return '';
}

function StudioTabButton(id, label) {
  return '<button class="' + (demo.activeStudioTab === id ? 'is-active' : '') + '" type="button" data-studio-tab="' + escapeHtml(id) + '">' + escapeHtml(label) + '</button>';
}

const cliGlyphs = {
  codex: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M22.282 9.821a5.985 5.985 0 0 0-.516-4.911 6.046 6.046 0 0 0-6.51-2.9A6.065 6.065 0 0 0 4.981 4.182a5.985 5.985 0 0 0-3.998 2.9 6.046 6.046 0 0 0 .743 7.097 5.98 5.98 0 0 0 .511 4.911 6.051 6.051 0 0 0 6.515 2.9A5.985 5.985 0 0 0 13.26 24a6.056 6.056 0 0 0 5.772-4.206 5.99 5.99 0 0 0 3.997-2.9 6.056 6.056 0 0 0-.747-7.073zM13.26 22.43a4.476 4.476 0 0 1-2.876-1.04l.141-.081 4.779-2.758a.795.795 0 0 0 .392-.681v-6.737l2.02 1.168a.071.071 0 0 1 .038.052v5.583a4.504 4.504 0 0 1-4.494 4.494zM3.6 18.304a4.47 4.47 0 0 1-.535-3.014l.142.085 4.783 2.759a.771.771 0 0 0 .78 0l5.843-3.369v2.332a.08.08 0 0 1-.033.062L9.74 19.95a4.5 4.5 0 0 1-6.14-1.646zM2.34 7.896a4.485 4.485 0 0 1 2.366-1.973V11.6a.766.766 0 0 0 .388.676l5.815 3.355-2.02 1.168a.076.076 0 0 1-.071 0l-4.83-2.786A4.504 4.504 0 0 1 2.34 7.872zm16.597 3.855-5.833-3.387L15.119 7.2a.076.076 0 0 1 .071 0l4.83 2.791a4.494 4.494 0 0 1-.676 8.105v-5.678a.79.79 0 0 0-.407-.667zm2.01-3.023-.141-.085-4.774-2.782a.776.776 0 0 0-.785 0L9.409 9.23V6.897a.066.066 0 0 1 .028-.061l4.83-2.787a4.5 4.5 0 0 1 6.68 4.66zm-12.64 4.135-2.02-1.164a.08.08 0 0 1-.038-.057V6.075a4.5 4.5 0 0 1 7.375-3.453l-.142.08L8.704 5.46a.795.795 0 0 0-.393.681zm1.097-2.365 2.602-1.5 2.607 1.5v2.999l-2.597 1.5-2.607-1.5z"/></svg>',
  claude: '<svg viewBox="0 0 64 64" aria-hidden="true"><g stroke="currentColor" stroke-width="5" stroke-linecap="round"><line x1="32" y1="8" x2="32" y2="24"/><line x1="32" y1="40" x2="32" y2="56"/><line x1="8" y1="32" x2="24" y2="32"/><line x1="40" y1="32" x2="56" y2="32"/><line x1="15" y1="15" x2="26" y2="26"/><line x1="38" y1="38" x2="49" y2="49"/><line x1="49" y1="15" x2="38" y2="26"/><line x1="26" y1="38" x2="15" y2="49"/></g></svg>',
  gemini: '<svg viewBox="0 0 64 64" aria-hidden="true"><path fill="currentColor" d="M32 4 C34.5 20 44 29.5 60 32 C44 34.5 34.5 44 32 60 C29.5 44 20 34.5 4 32 C20 29.5 29.5 20 32 4 Z"/></svg>',
};

function CliAgentButton(agent, index) {
  const chat = chatContext(index);
  const installed = cliAgentInstalled(agent);
  const ready = cliAgentReady(agent.id);
  const isActive = chat.cliId === agent.id && ready;
  const label = isActive
    ? 'Active'
    : ready
      ? 'Connected'
      : installed
        ? 'Sign in'
        : 'Connect';
  const glyph = cliGlyphs[agent.id] || '';
  return '<button class="' + (isActive ? 'is-selected' : '') + (ready && !isActive ? ' is-connected' : '') + (!ready && installed ? ' is-needs-signin' : '') + '" type="button" data-cli-agent="' + escapeHtml(agent.id) + '" data-chat-index="' + String(index) + '" data-tone="' + escapeHtml(agent.tone) + '" data-connected="' + (ready ? 'true' : 'false') + '" data-installed="' + (installed ? 'true' : 'false') + '">' +
    '<span></span>' + (glyph ? '<i class="vr-cli-glyph" data-cli="' + escapeHtml(agent.id) + '">' + glyph + '</i>' : '') + '<strong>' + escapeHtml(agent.label) + '</strong><b>' + label + '</b>' +
    '</button>';
}

function CliConnectExpand(index) {
  const targetId = demo.cliConnectTargetId;
  if (!targetId) return '';
  const targetAgent = cliAgents.find((item) => item.id === targetId);
  if (!targetAgent || cliAgentReady(targetId)) return '';
  const chat = chatContext(index);
  if (chat.cliId && chat.cliId !== targetId && cliAgentReady(chat.cliId)) return '';
  return '<div class="vr-cli-connect-expand" data-chat-index="' + String(index) + '">' +
    '<p>Finish connecting <strong>' + escapeHtml(targetAgent.label) + '</strong> in the <button type="button" data-studio-tab="terminal">Terminal</button> tab.</p>' +
    (demo.cliProbeMessage ? '<em>' + escapeHtml(demo.cliProbeMessage) + '</em>' : '') +
  '</div>';
}

function CliConnectPanel(index) {
  if (!demo.cliSetupComplete) return '';
  const codingAgents = cliAgents.filter((agent) => agent.id !== 'terminal');
  return '<section class="vr-cli-connect" aria-label="Connected coding CLI">' +
    '<div class="vr-cli-strip">' + codingAgents.map((agent) => CliAgentButton(agent, index)).join('') + '</div>' +
    CliConnectExpand(index) +
    '</section>';
}

function normalizeModelId(label) {
  return String(label).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}

function allModelOptions(index) {
  const chat = chatContext(index);
  const selectedCli = chat.cliId || demo.selectedCliId;
  const connectedAgents = cliAgents.filter((item) => item.id !== 'terminal' && cliAgentReady(item.id));
  const agent = connectedAgents.find((item) => item.id === selectedCli) || connectedAgents[0] || cliAgents[0];
  const modelCliId = agent?.id || selectedCli;
  return (cliModels[modelCliId] || cliModels[selectedCli] || cliModels.codex).map((label) => ({
    cliId: modelCliId,
    label,
    id: normalizeModelId(label),
  }));
}

function selectedModelLabel(index) {
  const chat = chatContext(index || 0);
  const option = allModelOptions(index || 0).find((item) => item.id === chat.modelId);
  if (option) return option.label;
  const models = cliModels[chat.cliId] || cliModels.codex;
  return models[0];
}

async function silentProbeCliConnection(agentId, chatIndex) {
  if (!agentId || agentId === 'terminal') return false;
  try {
    const response = await fetch('/api/cli-agents/probe', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ cliId: agentId }),
    });
    if (!response.ok) return cliAgentReady(agentId);
    const payload = await response.json();
    const ready = Boolean(payload && (payload.ready === true || (payload.ready === undefined && payload.connected === true)));
    if (ready) {
      connectCliAgent(agentId, chatIndex || 0, { completeSetup: true });
      return true;
    }
    return false;
  } catch {
    return cliAgentReady(agentId);
  }
}

async function restoreCliConnections() {
  const readyIds = Object.keys(demo.cliSessionReady).filter((id) => demo.cliSessionReady[id] === true && id !== 'terminal');
  if (!readyIds.length) return;
  demo.cliSetupComplete = true;
  demo.cliConnected = true;
  if (!readyIds.includes(demo.selectedCliId)) demo.selectedCliId = readyIds[0];
  demo.chatContexts.forEach((context, index) => {
    const chat = chatContext(index);
    if (!readyIds.includes(chat.cliId)) chat.cliId = readyIds[0];
  });
  demo.cliConnectTargetId = null;
  demo.cliLastConnectTargetId = null;
  for (const agentId of readyIds) {
    await silentProbeCliConnection(agentId, 0);
  }
}

async function hydrateCliAgents(options) {
  if (typeof fetch !== 'function') return;
  const forceFresh = options && options.forceFresh === true;
  try {
    demo.simulateFresh = forceFresh || studioFreshQuery() === '?fresh=1';
    const response = await fetch('/api/cli-agents' + (demo.simulateFresh ? '?fresh=1' : ''));
    if (!response.ok) return;
    const payload = await response.json();
    if (!payload || !Array.isArray(payload.agents)) return;
    const nextAgents = payload.agents.filter((agent) => agent && typeof agent.id === 'string' && typeof agent.label === 'string');
    if (nextAgents.length === 0) return;
    cliAgents = nextAgents.map((agent) => {
      const installed = agent.installed !== false || agent.connected !== false;
      return {
      id: agent.id,
      label: agent.label,
      caption: installed ? (cliAgentReady(agent.id) ? agent.caption : 'Sign in to use ' + agent.label) : 'Install or sign in with ' + agent.label,
      tone: agent.tone || 'green',
      connected: agent.connected !== false,
      installed,
      source: agent.source || 'fallback',
      setup: agent.setup || cliSetupFor(agent.id),
    };
    });
    demo.simulateFresh = payload.simulateFresh === true || demo.simulateFresh;
    cliModels = nextAgents.reduce((acc, agent) => {
      acc[agent.id] = Array.isArray(agent.models) && agent.models.length > 0 ? agent.models : (cliModels[agent.id] || cliModels.codex);
      return acc;
    }, { ...cliModels });
    const readyAgents = cliAgents.filter((agent) => agent.id !== 'terminal' && cliAgentReady(agent.id));
    const installedAgents = cliAgents.filter((agent) => agent.id !== 'terminal' && cliAgentInstalled(agent));
    const selected = payload.selectedCliId && readyAgents.some((agent) => agent.id === payload.selectedCliId) && cliModels[payload.selectedCliId]
      ? payload.selectedCliId
      : (readyAgents.find((agent) => agent.id === demo.selectedCliId)?.id || readyAgents[0]?.id || installedAgents[0]?.id || demo.selectedCliId);
    demo.selectedCliId = selected;
    const models = cliModels[selected] || cliModels.codex;
    if (!models.map(normalizeModelId).includes(demo.selectedModelId)) {
      demo.selectedModelId = normalizeModelId(models[0]);
    }
    demo.chatContexts.forEach((context, index) => {
      const chat = chatContext(index);
      const ready = readyAgents.some((agent) => agent.id === chat.cliId);
      if (!ready || !cliModels[chat.cliId]) chat.cliId = selected;
      const chatModels = cliModels[chat.cliId] || models;
      if (!chatModels.map(normalizeModelId).includes(chat.modelId)) chat.modelId = normalizeModelId(chatModels[0]);
    });
    demo.cliConnected = cliAgentReady(demo.selectedCliId);
    demo.cliAgentsHydrated = true;
    if (!demo.simulateFresh && readyAgents.length > 0) {
      demo.cliSetupComplete = true;
    }
    if (!demo.simulateFresh) {
      await restoreCliConnections();
    }
    render();
  } catch {
    // Keep the static preview state when local CLI detection is unavailable.
  }
}

async function probeCliConnection(agentId, chatIndex, finishSetup) {
  if (!agentId || agentId === 'terminal') return;
  const laneIndex = Math.max(0, Number(chatIndex) || 0);
  setConnectTarget(agentId);
  demo.cliProbeStatus = 'probing';
  demo.cliProbeMessage = 'Verifying install and sign-in for ' + agentId + '...';
  demo.activeStudioTab = 'terminal';
  render();
  try {
    const response = await fetch('/api/cli-agents/probe', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ cliId: agentId }),
    });
    const payload = response.ok ? await response.json() : null;
    const ready = Boolean(payload && (payload.ready === true || (payload.ready === undefined && payload.connected === true)));
    const installed = Boolean(payload && (payload.installed === true || payload.connected === true || ready));
    demo.cliProbeStatus = ready ? 'success' : 'failed';
    demo.cliProbeMessage = payload && payload.message ? payload.message : ready
      ? agentId + ' is ready for chat.'
      : installed
        ? agentId + ' is installed but not signed in. Run sign in, then test again.'
        : agentId + ' was not detected. Run install, then test again.';
    if (payload && payload.output) {
      appendTerminalLines(['--- test connection ---', String(payload.output), '']);
    }
    if (ready) {
      connectCliAgent(agentId, laneIndex, { completeSetup: !demo.cliSetupComplete, keepProbeState: true });
      if (finishSetup !== false) {
        demo.cliConnectCompleteAgentId = agentId;
        demo.activeModal = 'connect-complete';
        demo.notice = (cliAgents.find((item) => item.id === agentId)?.label || agentId) + ' verified. Start chatting or reset if something looks wrong.';
      }
    } else {
      setConnectTarget(agentId);
    }
  } catch {
    demo.cliProbeStatus = 'failed';
    demo.cliProbeMessage = 'Could not reach the local CLI probe. Restart VibeRaven Studio and try again.';
    setConnectTarget(agentId);
  }
  render();
}

async function runCliInstall(agentId, chatIndex) {
  const laneIndex = Math.max(0, Number(chatIndex) || 0);
  const agent = cliAgents.find((item) => item.id === agentId);
  setConnectTarget(agentId);
  demo.pickerChatIndex = laneIndex;
  demo.activeStudioTab = 'terminal';
  demo.cliTerminalTitle = 'Install ' + (agent?.label || agentId);
  demo.cliTerminalLines = ['Running install for ' + (agent?.label || agentId) + '...', ''];
  render();
  try {
    const response = await fetch('/api/cli-agents/run-setup', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ cliId: agentId, step: 'install' }),
    });
    const payload = response.ok ? await response.json() : null;
    demo.cliTerminalLines = [
      '$ ' + (payload?.command || setupCommandFallback(agentId, 'install')),
      '',
      String(payload?.output || payload?.message || 'Install finished.'),
      '',
      'Next: click Run sign in, complete login, then Test connection.'
    ];
    demo.cliTerminalDraft = setupCommandFallback(agentId, 'sign-in');
    demo.notice = payload?.exitCode === 0 ? 'Install finished in Studio terminal. Run sign in next.' : 'Install finished with warnings. Check Studio terminal output.';
  } catch {
    demo.cliTerminalLines = ['Install could not run from Studio.', 'Type the install command manually in the terminal below, then sign in.'];
    demo.notice = 'Studio could not run the install command.';
  }
  render();
}

function setupCommandFallback(agentId, step) {
  const setup = cliSetupFor(agentId);
  return step === 'install' ? setup.installCommand : setup.signInCommand;
}

async function runCliSignInInStudio(agentId, chatIndex) {
  const laneIndex = Math.max(0, Number(chatIndex) || 0);
  const agent = cliAgents.find((item) => item.id === agentId);
  setConnectTarget(agentId);
  demo.pickerChatIndex = laneIndex;
  demo.activeStudioTab = 'terminal';
  demo.cliTerminalTitle = 'Sign in to ' + (agent?.label || agentId);
  appendTerminalLines(['Running sign-in for ' + (agent?.label || agentId) + '...', '']);
  render();
  try {
    const response = await fetch('/api/cli-agents/run-setup', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ cliId: agentId, step: 'sign-in' }),
    });
    const payload = response.ok ? await response.json() : null;
    appendTerminalLines([
      '$ ' + (payload?.command || setupCommandFallback(agentId, 'sign-in')),
      '',
      String(payload?.output || payload?.message || 'Sign-in command finished.'),
      payload?.interactiveNote ? String(payload.interactiveNote) : '',
      '',
      'Complete any browser login, then click Test connection.'
    ]);
    demo.cliTerminalDraft = setupCommandFallback(agentId, 'sign-in');
    demo.notice = 'Sign-in ran in Studio terminal. Finish login if prompted, then test the connection.';
  } catch {
    appendTerminalLines(['Sign-in could not run from Studio.', 'Type the sign-in command below manually.']);
    demo.notice = 'Studio could not run the sign-in command.';
  }
  render();
}

async function openCliOsTerminal(agentId, chatIndex) {
  const laneIndex = Math.max(0, Number(chatIndex) || 0);
  const agent = cliAgents.find((item) => item.id === agentId);
  setConnectTarget(agentId);
  demo.pickerChatIndex = laneIndex;
  demo.activeStudioTab = 'terminal';
  demo.cliTerminalTitle = 'Sign in to ' + (agent?.label || agentId);
  appendTerminalLines(['Opening OS terminal for interactive sign-in fallback...', '']);
  render();
  try {
    const response = await fetch('/api/cli-agents/open-terminal', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ cliId: agentId, step: 'sign-in' }),
    });
    const payload = response.ok ? await response.json() : null;
    appendTerminalLines([
      '$ ' + (payload?.command || setupCommandFallback(agentId, 'sign-in')),
      '',
      String(payload?.message || 'Complete sign-in in the OS terminal window that opened.'),
      '',
      'When login finishes, return here and click Test connection.'
    ]);
    demo.notice = payload?.ok ? 'OS terminal opened for sign-in fallback.' : 'Could not open an OS terminal window.';
  } catch {
    appendTerminalLines(['Could not open an OS terminal window.', 'Type the sign-in command in the Studio terminal below.']);
    demo.notice = 'Could not open an OS terminal window.';
  }
  render();
}

function ModelPicker(index) {
  const chat = chatContext(index);
  const models = allModelOptions(index);
  const selectedModel = selectedModelLabel(index);
  const scoped = demo.pickerChatIndex === index;
  const access = accessModes.find((mode) => mode.id === chat.accessMode) || accessModes[1];
  const accessButtonLabel = access.id === 'approve' ? 'Approve for me' : access.id === 'ask' ? 'Ask approval' : 'Full access';
  return '<div class="vr-model-picker">' +
    '<button type="button" data-action="toggle-reasoning" data-chat-index="' + String(index) + '"><span>Reasoning</span><strong>' + escapeHtml(chat.reasoning) + '</strong><i></i></button>' +
    '<button type="button" data-action="toggle-models" data-chat-index="' + String(index) + '"><span>Model</span><strong>' + escapeHtml(selectedModel) + '</strong><i></i></button>' +
    '<button type="button" data-action="toggle-context" data-chat-index="' + String(index) + '"><span>Context</span><strong>' + escapeHtml(chat.context) + '</strong><i></i></button>' +
    '<button type="button" data-action="toggle-access" data-chat-index="' + String(index) + '"><span>Access</span><strong>' + escapeHtml(accessButtonLabel) + '</strong><i></i></button>' +
    (scoped && demo.reasoningMenuOpen ? '<div class="vr-model-menu is-reasoning" role="menu"><p>Reasoning</p>' + reasoningLevels.map((level) =>
      '<button type="button" data-reasoning="' + escapeHtml(level) + '" data-chat-index="' + String(index) + '">' + escapeHtml(level) + (chat.reasoning === level ? '<b></b>' : '') + '</button>'
    ).join('') + '</div>' : '') +
    (scoped && demo.modelMenuOpen ? '<div class="vr-model-menu is-models" role="menu"><p>Model</p>' + models.map((model) =>
      '<button type="button" data-model="' + escapeHtml(model.id) + '" data-chat-index="' + String(index) + '"><span><strong>' + escapeHtml(model.label) + '</strong></span>' + (selectedModel === model.label ? '<b></b>' : '') + '</button>'
    ).join('') + '</div>' : '') +
    (scoped && demo.contextMenuOpen ? '<div class="vr-model-menu is-context" role="menu"><p>Context</p>' + contextLevels.map((level) =>
      '<button type="button" data-context="' + escapeHtml(level) + '" data-chat-index="' + String(index) + '">' + escapeHtml(level) + (chat.context === level ? '<b></b>' : '') + '</button>'
    ).join('') + '</div>' : '') +
    (scoped && demo.accessMenuOpen ? '<div class="vr-model-menu is-access" role="menu"><p>Access</p>' + accessModes.map((mode) =>
      '<button type="button" data-access-mode="' + escapeHtml(mode.id) + '" data-chat-index="' + String(index) + '"><span><strong>' + escapeHtml(mode.label) + '</strong><em>' + escapeHtml(mode.description) + '</em></span>' + (chat.accessMode === mode.id ? '<b></b>' : '') + '</button>'
    ).join('') + '</div>' : '') +
    '</div>';
}

function hudCategoryTag(category) {
  const value = String(category || 'Quality').trim();
  if (/^security$/i.test(value)) return 'SEC';
  if (/^provider$/i.test(value)) return 'PROVIDER';
  return value.toUpperCase().slice(0, 8);
}

function hudSeverityGlyph(severity) {
  if (severity === 'critical') return '<i class="vr-hud-sev is-critical" aria-hidden="true">&#9646;&#9646;</i>';
  if (severity === 'warning') return '<i class="vr-hud-sev is-warning" aria-hidden="true">&#9646;</i>';
  return '<i class="vr-hud-sev is-info" aria-hidden="true">&#9647;</i>';
}

function ChatBlockersSummary(cards, chatIndex) {
  const blockers = Array.isArray(cards.blockers) ? cards.blockers : [];
  const count = typeof cards.blockerCount === 'number' ? cards.blockerCount : blockers.length;
  if (!blockers.length) return '';
  const planSteps = Array.isArray(cards.planSteps) ? cards.planSteps : [];
  const rows = blockers.map((blocker) =>
    '<div class="vr-hud-gate-row">' + hudSeverityGlyph(blocker.severity) +
      '<em>' + escapeHtml(blocker.title || 'Launch blocker') +
      (blocker.detail ? '<small>' + escapeHtml(blocker.detail) + '</small>' : '') +
      '</em><b>' + escapeHtml(hudCategoryTag(blocker.category)) + '</b>' +
    '</div>'
  ).join('');
  const footer = planSteps.length
    ? '<button class="vr-hud-gate-foot" type="button" data-action="view-fix-plan" data-chat-index="' + String(chatIndex) + '"><span>View fix plan</span><b>' + String(planSteps.length) + ' actions &#8594;</b></button>'
    : '';
  return '<section class="vr-hud-gate"><header><strong>BEFORE YOU SHIP</strong><b>' + String(count) + ' BLOCKING</b></header>' + rows + footer + '</section>';
}

function ChatPlanCard(steps, chatIndex) {
  const rows = Array.isArray(steps) ? steps : [];
  if (!rows.length) return '';
  const repoSteps = rows.filter((step) => !step.requiresUserAction);
  const approveLabel = repoSteps.length > 1
    ? 'Approve - fix all ' + String(repoSteps.length)
    : 'Approve - fix it';
  const approveFooter = repoSteps.length
    ? '<footer class="vr-approve-foot">' +
        '<button class="vr-approve-all" type="button" data-action="start-agent-fix" data-chat-index="' + String(chatIndex) + '">' + approveLabel + '</button>' +
        '<button class="vr-approve-review" type="button" data-action="show-diff" data-chat-index="' + String(chatIndex) + '">Review first</button>' +
      '</footer>'
    : '';
  return '<section class="vr-chat-card vr-chat-plan-card vr-approve-card"><header><strong>The raven proposes</strong><b>' + String(rows.length) + (rows.length === 1 ? ' step' : ' steps') + '</b></header><ol class="vr-chat-plan-list">' +
    rows.map((step, index) =>
      '<li><button class="vr-plan-step" type="button" data-action="mission-step" data-step-id="' + escapeHtml(step.id || ('step-' + String(index))) + '" data-chat-index="' + String(chatIndex) + '">' +
        '<span class="vr-approve-cbx" aria-hidden="true"></span>' +
        '<span class="vr-plan-step-body">' +
          '<span class="vr-plan-step-title">' + escapeHtml(step.title || 'Fix step') + '</span>' +
          '<span class="vr-plan-step-tag">' + escapeHtml(hudCategoryTag(step.category)) + (step.requiresUserAction ? ' &middot; NEEDS YOU' : '') + '</span>' +
        '</span>' +
        '<span class="vr-plan-step-go">' + Icon('chevronRight') + '</span>' +
      '</button></li>'
    ).join('') +
    '</ol>' + approveFooter + '</section>';
}

function ChatProviderConnectCard(connectProviders, chatIndex) {
  const rows = Array.isArray(connectProviders) ? connectProviders : [];
  if (!rows.length) return '';
  return '<section class="vr-chat-card vr-chat-connect-card"><header><strong>Connect Providers</strong><b>' + String(rows.length) + ' needed</b></header><div class="vr-chat-card-list">' +
    rows.map((provider) =>
      '<span data-tone="warn"><i></i><em>' + escapeHtml(provider.name || provider.id || 'Provider') + '<small>' + escapeHtml(provider.status || 'missing') + '</small></em><b>Provider</b>' +
      '<button type="button" data-action="connect-provider" data-provider-id="' + escapeHtml(provider.id || '') + '" data-chat-index="' + String(chatIndex) + '">Connect</button>' +
      (provider.dashboardUrl ? '<a class="vr-chat-connect-dashboard" href="' + escapeHtml(provider.dashboardUrl) + '" target="_blank" rel="noreferrer">Dashboard</a>' : '') +
      '</span>'
    ).join('') +
    '</div></section>';
}

function ChatMissionCards(cards, chatIndex, options, usedActions) {
  if (!cards) return '';
  const opts = options || {};
  const blockers = Array.isArray(cards.blockers) ? cards.blockers : [];
  const planSteps = Array.isArray(cards.planSteps) ? cards.planSteps : [];
  const connectProviders = Array.isArray(cards.connectProviders) ? cards.connectProviders : [];
  const showPlan = Boolean(opts.showPlan || demo.fixPlanExpandedChatIndex === chatIndex);
  if (!blockers.length && !connectProviders.length && !planSteps.length) return '';
  let html = '<div class="vr-chat-mission-summary">';
  if (blockers.length) {
    html += ChatBlockersSummary(cards, chatIndex);
    if (planSteps.length && usedActions) usedActions.add('view-fix-plan');
  }
  if (showPlan && planSteps.length) html += ChatPlanCard(planSteps, chatIndex);
  if (connectProviders.length) html += ChatProviderConnectCard(connectProviders, chatIndex);
  if (planSteps.length && !showPlan && !blockers.length) {
    html += '<button class="vr-chat-plan-row" type="button" data-action="view-fix-plan" data-chat-index="' + String(chatIndex) + '">' + Icon('report') + '<strong>View fix plan</strong><em>' + String(planSteps.length) + ' actions</em><b></b></button>';
  }
  html += '</div>';
  return html;
}

let taskElapsedTimer = null;
function formatElapsed(ms) {
  const s = Math.max(0, Math.floor(ms / 1000));
  return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
}
function anyLaneWorking() {
  return (demo.chatContexts || []).some((c) => c && c.activeTask && c.activeTask.phase === 'working' && c.activeTask.startedAt);
}
// Live heartbeat: while the agent runs, tick the elapsed clock every second so it never looks frozen.
function startTaskElapsedTimer() {
  if (taskElapsedTimer) return;
  taskElapsedTimer = window.setInterval(() => {
    if (!anyLaneWorking()) { window.clearInterval(taskElapsedTimer); taskElapsedTimer = null; return; }
    document.querySelectorAll('[data-task-elapsed]').forEach((el) => {
      const start = Number(el.getAttribute('data-task-elapsed')) || 0;
      if (start) el.textContent = formatElapsed(Date.now() - start);
    });
  }, 1000);
}

function ChatTaskAnimation(chatIndex, compact) {
  const chat = chatContext(chatIndex);
  const task = chat.activeTask;
  if (!task || task.phase !== 'working') return '';
  const meta = taskMeta(task.kind);
  const statusText = task.kind === 'verify' ? 'Verifying...' : task.kind === 'diff' ? 'Reviewing...' : task.kind === 'explain' ? 'Explaining...' : 'Working...';
  const thoughtText = 'reading your repo';
  const started = task.startedAt || Date.now();
  const elapsedHtml = '<span class="vr-task-elapsed" data-task-elapsed="' + started + '">' + formatElapsed(Date.now() - started) + '</span>';
  const compactClass = compact ? ' is-compact' : '';
  const rail = compact ? '' : '<div class="vr-task-rail" aria-hidden="true"><span></span></div>';
  const detail = compact ? '' : '<p>' + escapeHtml(meta.line) + ' On a large repo this can take a minute.</p>';
  return '<section class="vr-chat-agent-task is-working' + compactClass + '" data-task="' + escapeHtml(task.kind) + '">' +
    '<header><span class="vr-task-glyph" aria-hidden="true"></span><div><strong>' + escapeHtml(statusText) + '</strong><em>(' + escapeHtml(thoughtText) + ')</em></div>' + elapsedHtml + '<b>' + escapeHtml(meta.title) + '</b></header>' +
    rail +
    detail +
    '</section>';
}

function formatAgentOutput(value) {
  let clean = String(value || '').replace(/\\r\\n/g, '\\n').trim();
  clean = clean
    .split('\\n')
    .filter((line) => !/^\\d{4}-\\d{2}-\\d{2}T.*\\s(WARN|ERROR)\\s/.test(line))
    .filter((line) => !/^(OpenAI Codex v|workdir:|model:|provider:|approval:|sandbox:|reasoning effort:|reasoning summaries:|session id:|--------$|user$)/.test(line.trim()))
    .join('\\n')
    .trim();
  // CLI-failure rewrites only apply to SHORT error output. A long real answer that merely
  // mentions "auth"/"sign in" (e.g. a production auth review) must never be mistaken for one.
  const compact = clean.length < 800;
  if (compact && /IneligibleTierError|UNSUPPORTED_CLIENT|no longer supported for Gemini Code Assist/i.test(clean)) {
    return 'Gemini CLI is installed, but this account/client is not eligible for the current Gemini Code Assist CLI. Connect a supported Gemini CLI account, then retry this chat.';
  }
  if (compact && /not running in a trusted directory|--skip-trust|GEMINI_CLI_TRUST_WORKSPACE/i.test(clean)) {
    return 'Gemini CLI needs this project trusted for headless chat. VibeRaven now passes the trust flag for Gemini runs; retry after your Gemini account is eligible.';
  }
  if (compact && /command not found|not recognized as an internal or external command|ENOENT/i.test(clean)) {
    return 'The selected CLI is not available on PATH. Install it or sign in, then reconnect it from the chat header.';
  }
  if (compact && /not logged in|login required|not authenticated|authentication failed|unauthorized|please (run|sign|log)|run (codex|gemini|claude)[^\\n]{0,40}login/i.test(clean)) {
    return 'The selected CLI needs sign-in before VibeRaven can use it. Sign in with the CLI, then retry this mission.';
  }
  const missionIndex = clean.indexOf('User mission:');
  if (missionIndex >= 0) {
    const afterMission = clean.slice(missionIndex + 'User mission:'.length).trim();
    if (afterMission && afterMission.length < clean.length) clean = afterMission;
  }
  if (!clean) return 'Ready for the next safe action.';
  return clean;
}

function agentVerifyButton(chatIndex) {
  return '<button type="button" class="vr-agent-inline-action is-primary" data-action="verify-now" data-chat-index="' + String(chatIndex) + '">' + Icon('shield') + '<span>Verify</span></button>';
}

function agentLinkButton(label, url) {
  return '<a class="vr-agent-inline-action" href="' + escapeHtml(url) + '" target="_blank" rel="noreferrer">' + Icon('external') + '<span>' + escapeHtml(label) + '</span></a>';
}

function agentApplyFixButton(chatIndex) {
  return '<button type="button" class="vr-agent-inline-action is-primary" data-action="start-agent-fix" data-chat-index="' + String(chatIndex) + '">' + Icon('agent') + '<span>Apply fix</span></button>';
}

function linkLabelForUrl(url) {
  const lower = String(url).toLowerCase();
  if (lower.includes('sentry.io')) return 'Open Sentry';
  if (lower.includes('supabase.com')) return 'Open Supabase';
  if (lower.includes('vercel.com')) return 'Open Vercel';
  if (lower.includes('github.com')) return 'Open GitHub';
  if (lower.includes('stripe.com')) return 'Open Stripe';
  if (lower.includes('cli.github.com')) return 'Open GitHub CLI docs';
  if (lower.includes('dashboard')) return 'Open dashboard';
  return 'Open link';
}

function stripVerifyCommandText(text) {
  const tick = String.fromCharCode(96);
  const cmd = '(?:' + tick + ')?npx(?:\\s+-y)?\\s+viberaven(?:\\s+--verify|\\s+verify)[^' + tick + '.]*(?:' + tick + ')?';
  return String(text || '')
    .replace(new RegExp(',?\\s*then run\\s+' + cmd + '\\.?', 'gi'), '.')
    .replace(new RegExp('run\\s+' + cmd + '\\s+once[^.]*\\.?', 'gi'), '')
    .replace(new RegExp(cmd, 'gi'), '')
    .replace(/\\s{2,}/g, ' ')
    .replace(/\\.\\s*\\./g, '.')
    .trim();
}

function inlineAgentMarkdown(line, chatIndex) {
  const tick = String.fromCharCode(96);
  let raw = String(line || '');
  const actions = [];
  const verifyPattern = new RegExp('npx(?:\\s+-y)?\\s+viberaven(?:\\s+--verify|\\s+verify)[^\\s,.' + tick + ']*', 'gi');
  raw = raw.replace(new RegExp(tick + 'npx[^' + tick + ']*viberaven[^' + tick + ']*' + tick, 'gi'), () => {
    actions.push('verify');
    return '';
  });
  raw = raw.replace(verifyPattern, () => {
    actions.push('verify');
    return '';
  });
  raw = raw.replace(/https?:\\/\\/[^\\s,)]+/g, (url) => {
    actions.push('link:' + url);
    return '';
  });
  raw = stripVerifyCommandText(raw);
  let html = escapeHtml(raw.trim());
  html = html.replace(/\\*\\*(.+?)\\*\\*/g, '<strong>$1</strong>');
  html = html.replace(new RegExp(tick + '([^' + tick + ']+)' + tick, 'g'), '<code>$1</code>');
  if (actions.length) {
    const actionHtml = actions.map((token) => {
      if (token === 'verify') return agentVerifyButton(chatIndex);
      if (token.indexOf('link:') === 0) {
        const url = token.slice(5);
        return agentLinkButton(linkLabelForUrl(url), url);
      }
      return '';
    }).filter(Boolean).join('');
    html = (html ? html + ' ' : '') + '<span class="vr-agent-inline-actions">' + actionHtml + '</span>';
  }
  return html || '<span class="vr-agent-muted">—</span>';
}

function renderAgentListItems(items, chatIndex) {
  return items.map((item) => '<li>' + inlineAgentMarkdown(item, chatIndex) + '</li>').join('');
}

function normalizeAgentSectionKey(raw) {
  const key = String(raw || '').trim().toLowerCase().replace(/\\s*\\(\\d+\\)\\s*$/, '').trim();
  if (/^(gate|production gate)$/.test(key)) return null;
  if (/^(blockers?|context gaps?)$/.test(key)) return 'Context gaps';
  if (/^(suggested steps?|fix plan)$/.test(key)) return 'Suggested steps';
  if (/^(summary|tl;dr|tldr)$/.test(key)) return 'Summary';
  if (key === 'findings') return 'Findings';
  if (key === 'changes made') return 'Changes made';
  if (key === 'files touched') return 'Files touched';
  if (key === 'next step') return 'Next step';
  return null;
}

function dedupeAgentMarkdownBody(text, cards) {
  if (!cards) return String(text || '');
  let result = String(text || '');
  const blockers = Array.isArray(cards.blockers) ? cards.blockers : [];
  const planSteps = Array.isArray(cards.planSteps) ? cards.planSteps : [];
  if (!blockers.length && !planSteps.length) return result;
  const lines = result.split('\\n');
  const filtered = lines.filter((line) => {
    const trimmed = line.trim();
    if (!trimmed) return true;
    for (let i = 0; i < blockers.length; i += 1) {
      const title = String(blockers[i].title || '').trim();
      if (title && trimmed.indexOf(title) >= 0) return false;
    }
    for (let j = 0; j < planSteps.length; j += 1) {
      const stepTitle = String(planSteps[j].title || '').trim();
      if (stepTitle && trimmed.indexOf(stepTitle) >= 0) return false;
    }
    return true;
  });
  return filtered.join('\\n').replace(/\\n{3,}/g, '\\n\\n').trim();
}

function AgentGateStrip(gateText, gateState) {
  return '';
}

function parseAgentSections(text, options) {
  const opts = options || {};
  const skipPlanSections = Boolean(opts.skipPlanSections);
  const lines = String(text || '').split('\\n');
  const sections = [];
  let current = null;

  function pushSection(name, bodyLines) {
    const items = [];
    const paragraphs = [];
    bodyLines.forEach((line) => {
      const trimmed = line.trim();
      if (!trimmed) return;
      const bullet = trimmed.match(/^[-*]\\s+(.*)$/);
      const ordered = trimmed.match(/^\\d+[.)]\\s+(.*)$/);
      if (bullet) items.push(bullet[1]);
      else if (ordered) items.push(ordered[1]);
      else paragraphs.push(trimmed);
    });
    sections.push({ name, items, paragraphs });
  }

  lines.forEach((line) => {
    const trimmed = line.trim();
    const heading = trimmed.match(/^#{1,3}\\s+(.+)$/) || trimmed.match(/^\\*\\*([^*]+)\\*\\*$/) || trimmed.match(/^\\d+[.)]\\s+\\*\\*([^*]+)\\*\\*$/);
    if (heading) {
      const normalized = normalizeAgentSectionKey(heading[1]);
      if (normalized) {
        if (skipPlanSections && normalized === 'Suggested steps') return;
        if (current) pushSection(current.name, current.lines);
        current = { name: normalized, lines: [] };
        return;
      }
    }
    if (current) current.lines.push(line);
  });
  if (current) pushSection(current.name, current.lines);
  return sections.length >= 2 ? sections : null;
}

function renderAgentSectionCard(section, chatIndex, usedActions) {
  const name = section.name;
  const lower = name.toLowerCase();
  if (lower === 'gate') {
    return '';
  }
  const isNext = lower === 'next step';
  const isBlockers = lower === 'blockers';
  const isSummary = lower === 'summary';
  const bodyParts = [];
  if (section.paragraphs.length) {
    bodyParts.push(section.paragraphs.map((p) => '<p>' + inlineAgentMarkdown(p, chatIndex) + '</p>').join(''));
  }
  if (section.items.length) {
    const listClass = isBlockers ? 'vr-agent-list is-blockers' : 'vr-agent-list';
    bodyParts.push('<ul class="' + listClass + '">' + renderAgentListItems(section.items, chatIndex) + '</ul>');
  }
  let footer = '';
  if (isNext) {
    const seen = usedActions || new Set();
    const blob = section.items.concat(section.paragraphs).join(' ').toLowerCase();
    const actions = [];
    if (/fix|wire|implement|add|configure|apply|sentry|monitor/.test(blob) && !seen.has('start-agent-fix')) {
      seen.add('start-agent-fix');
      actions.push(agentApplyFixButton(chatIndex));
    }
    if (blob.includes('github')) actions.push(agentLinkButton('Open GitHub', providerDashboardUrls.github || goLiveUrls.githubNew));
    if (blob.includes('sentry')) actions.push(agentLinkButton('Open Sentry', providerDashboardUrls.sentry || 'https://sentry.io'));
    if (blob.includes('supabase')) actions.push(agentLinkButton('Open Supabase', providerDashboardUrls.supabase || 'https://supabase.com/dashboard/projects'));
    if (blob.includes('vercel')) actions.push(agentLinkButton('Open Vercel', providerDashboardUrls.vercel || 'https://vercel.com/dashboard'));
    if (/npx|viberaven|verify|re-run|gate-result/.test(blob) && !seen.has('verify-now')) {
      seen.add('verify-now');
      actions.push(agentVerifyButton(chatIndex));
    }
    if (!actions.length && !seen.has('verify-now')) {
      seen.add('verify-now');
      actions.push(agentVerifyButton(chatIndex));
    }
    if (actions.length) footer = '<div class="vr-agent-section-actions">' + actions.slice(0, 3).join('') + '</div>';
  }
  const sectionClass = 'vr-agent-section' + (isBlockers ? ' is-blockers' : isSummary ? ' is-summary' : '');
  return '<article class="' + sectionClass + '"><h4 class="vr-agent-heading">' + escapeHtml(name) + '</h4>' +
    (bodyParts.join('') || '<p class="vr-agent-muted">No details yet.</p>') +
    footer +
  '</article>';
}

function agentStatusTone(line) {
  if (/^(✅|🟢)/.test(line)) return 'ok';
  if (/^(❌|🔴)/.test(line)) return 'blocker';
  if (/^(⚠️|🟡)/.test(line)) return 'warn';
  if (/^⚪/.test(line)) return 'info';
  return null;
}

function splitAgentTelemetry(text) {
  const raw = String(text || '');
  const lines = raw.split('\\n');
  const noise = lines.some((line) => /^(exec\\b|exec$|warning:|thinking\\b|tool\\b)/i.test(line.trim()));
  if (!noise) return { work: '', answer: raw };
  let lastMarker = -1;
  for (let i = 0; i < lines.length; i++) {
    const t = lines[i].trim();
    if (t === 'codex' || /^(succeeded|failed) in \\d+/i.test(t)) lastMarker = i;
  }
  if (lastMarker < 0 || lastMarker >= lines.length - 1) return { work: '', answer: raw };
  const work = lines.slice(0, lastMarker + 1).join('\\n').trim();
  const answer = lines.slice(lastMarker + 1)
    .filter((line) => !/^tokens used:?/i.test(line.trim()))
    .join('\\n').trim();
  if (!answer) return { work: '', answer: raw };
  return { work: work, answer: answer };
}

function agentWorkLogHtml(work) {
  const lineCount = work.split('\\n').filter((line) => line.trim()).length;
  return '<details class="vr-agent-work"><summary>' +
    '<b></b><span>Agent work</span><em>' + String(lineCount) + ' lines</em>' +
    '</summary><pre>' + escapeHtml(work) + '</pre></details>';
}

function agentErrorPresentation(text) {
  const raw = String(text || '').trim();
  if (/networkerror|failed to fetch|econnrefused|enotfound|etimedout|socket hang up/i.test(raw)) {
    return { headline: 'Could not reach the agent - retry when the connection is back.', raw: raw };
  }
  if (/timeout|timed out/i.test(raw)) {
    return { headline: 'The agent took too long to respond - retry the mission.', raw: raw };
  }
  return { headline: raw, raw: '' };
}

function looksLikeRawTranscript(text) {
  const nonEmpty = String(text || '').split('\\n').filter((line) => line.trim());
  if (nonEmpty.length < 24) return false;
  let grepLike = 0;
  let structured = 0;
  nonEmpty.forEach((line) => {
    const t = line.trim();
    if (/:\\d+:\\s/.test(t) || /\\.(json|jsonl|ts|tsx|js|md|txt):\\d+/.test(t)) grepLike++;
    if (/^#{1,3}\\s+/.test(t) || /^\\*\\*[^*]+\\*\\*/.test(t)) structured++;
  });
  if (grepLike >= 8) return true;
  if (nonEmpty.length > 60 && structured <= 1) return true;
  return false;
}

function renderAgentAnswerHtml(rawText, chatIndex, cards, isError, usedActions) {
  const tick = String.fromCharCode(96);
  const fence = tick + tick + tick;
  const text = formatAgentOutput(rawText);
  if (!text) return '<div class="vr-agent-answer-body"><p class="vr-agent-empty">Ready for the next safe action.</p></div>';
  if (isError) {
    const presented = agentErrorPresentation(text);
    if (presented.raw) {
      return '<div class="vr-agent-answer-body">' +
        '<p>' + escapeHtml(presented.headline) + '</p>' +
        '<p class="vr-hud-raw">' + escapeHtml(presented.raw.slice(0, 240)) + '</p>' +
      '</div>';
    }
  }
  if (looksLikeRawTranscript(text)) {
    const headline = isError
      ? 'The agent explored your repo but did not finish with a clean summary.'
      : 'The agent returned raw work instead of a summary.';
    return '<div class="vr-agent-answer-body vr-agent-answer-raw">' +
      '<p class="vr-agent-raw-headline">' + escapeHtml(headline) + '</p>' +
      '<p class="vr-agent-raw-sub">Open the agent work below for the raw detail, or use Retry for a clean answer.</p>' +
      agentWorkLogHtml(text) +
    '</div>';
  }
  const split = splitAgentTelemetry(text);
  const workLog = split.work ? agentWorkLogHtml(split.work) : '';
  let visibleText = dedupeAgentMarkdownBody(split.answer, cards);
  const hasMissionPlanSteps = Boolean(cards && Array.isArray(cards.planSteps) && cards.planSteps.length);
  const structured = parseAgentSections(visibleText, { skipPlanSections: hasMissionPlanSteps });
  if (structured) {
    const sectionCards = structured.map((section) => renderAgentSectionCard(section, chatIndex, usedActions)).join('');
    return '<div class="vr-agent-answer-body vr-agent-answer-structured">' + workLog + '<div class="vr-agent-sections">' + sectionCards + '</div></div>';
  }
  const blocks = [];
  let listType = null;
  let listItems = [];
  let codeLines = [];
  let inCode = false;

  function flushList() {
    if (!listType || !listItems.length) return;
    blocks.push('<' + listType + ' class="vr-agent-list">' + listItems.map((item) => '<li>' + item + '</li>').join('') + '</' + listType + '>');
    listType = null;
    listItems = [];
  }

  function flushCode() {
    if (!codeLines.length) return;
    blocks.push('<div class="vr-agent-code-wrap"><button type="button" class="vr-agent-code-copy" data-action="copy-code" title="Copy code" aria-label="Copy code">' + Icon('copy') + '</button><pre class="vr-agent-code"><code>' + escapeHtml(codeLines.join('\\n')) + '</code></pre></div>');
    codeLines = [];
  }

  visibleText.split('\\n').forEach((line) => {
    const trimmed = line.trim();
    if (trimmed.startsWith(fence)) {
      flushList();
      if (inCode) {
        flushCode();
        inCode = false;
      } else {
        inCode = true;
      }
      return;
    }
    if (inCode) {
      codeLines.push(line);
      return;
    }
    if (!trimmed) {
      flushList();
      return;
    }
    if (/^#{1,3}\\s+/.test(trimmed)) {
      flushList();
      blocks.push('<h4 class="vr-agent-heading">' + inlineAgentMarkdown(trimmed.replace(/^#{1,3}\\s+/, ''), chatIndex) + '</h4>');
      return;
    }
    if (/^\\*\\*[^*]+\\*\\*$/.test(trimmed)) {
      flushList();
      blocks.push('<h4 class="vr-agent-heading">' + inlineAgentMarkdown(trimmed.replace(/^\\*\\*|\\*\\*$/g, ''), chatIndex) + '</h4>');
      return;
    }
    const ordered = trimmed.match(/^\\d+[.)]\\s+(.*)$/);
    if (ordered) {
      if (listType !== 'ol') {
        flushList();
        listType = 'ol';
      }
      listItems.push(inlineAgentMarkdown(ordered[1], chatIndex));
      return;
    }
    if (/^[-*]\\s+/.test(trimmed)) {
      if (listType !== 'ul') {
        flushList();
        listType = 'ul';
      }
      listItems.push(inlineAgentMarkdown(trimmed.replace(/^[-*]\\s+/, ''), chatIndex));
      return;
    }
    const statusTone = agentStatusTone(trimmed);
    if (statusTone) {
      flushList();
      blocks.push('<p class="vr-agent-status-row is-' + statusTone + '">' + inlineAgentMarkdown(trimmed, chatIndex) + '</p>');
      return;
    }
    flushList();
    blocks.push('<p>' + inlineAgentMarkdown(trimmed, chatIndex) + '</p>');
  });
  flushList();
  if (inCode) flushCode();

  const body = blocks.join('') || ('<p>' + inlineAgentMarkdown(visibleText, chatIndex) + '</p>');
  return '<div class="vr-agent-answer-body">' + workLog + body + '</div>';
}

function AgentFollowUpButton(spec, chatIndex) {
  return '<button type="button" class="' + (spec.primary ? 'is-primary' : '') + '" data-action="' + escapeHtml(spec.action) + '" data-chat-index="' + String(chatIndex) + '">' +
    Icon(spec.icon) + '<span>' + escapeHtml(spec.label) + '</span></button>';
}

function AgentActionRow(specs, chatIndex, usedActions) {
  const seen = usedActions || new Set();
  let primaryUsed = false;
  const deduped = [];
  (specs || []).forEach((spec) => {
    if (!spec || !spec.action || seen.has(spec.action)) return;
    seen.add(spec.action);
    let primary = Boolean(spec.primary);
    if (primary && primaryUsed) primary = false;
    if (primary) primaryUsed = true;
    deduped.push({ action: spec.action, label: spec.label, icon: spec.icon, primary: primary });
  });
  if (!deduped.length) return '';
  return '<div class="vr-agent-followups">' + deduped.slice(0, 3).map((spec) => AgentFollowUpButton(spec, chatIndex)).join('') + '</div>';
}

function AgentResponseFollowUps(kind, isError, chatIndex, usedActions) {
  // Follow-ups always show — structured sections do not suppress the action row.
  if (isError) {
    return AgentActionRow([
      { action: 'start-agent-fix', label: 'Retry fix', icon: 'refresh', primary: true },
      { action: 'terminal-tab', label: 'Terminal', icon: 'shell' },
    ], chatIndex, usedActions);
  }
  const specs = {
    plan: [
      { action: 'start-agent-fix', label: 'Apply fix', icon: 'agent', primary: true },
      { action: 'verify-now', label: 'Verify', icon: 'shield' },
      { action: 'view-fix-plan', label: 'View plan', icon: 'report' },
    ],
    fix: [
      { action: 'show-diff', label: 'Review diff', icon: 'code', primary: true },
      { action: 'verify-now', label: 'Verify', icon: 'shield' },
    ],
    verify: [
      { action: 'recheck', label: 'Re-check gate', icon: 'refresh', primary: true },
    ],
    analyze: [
      { action: 'plan', label: 'Build plan', icon: 'report', primary: true },
      { action: 'start-agent-fix', label: 'Apply fix', icon: 'agent' },
    ],
    provider: [
      { action: 'verify-now', label: 'Verify', icon: 'shield', primary: true },
    ],
    explain: [
      { action: 'show-diff', label: 'Review diff', icon: 'code', primary: true },
    ],
    diff: [
      { action: 'show-diff', label: 'Review diff', icon: 'code', primary: true },
      { action: 'verify-now', label: 'Verify', icon: 'shield' },
    ],
  };
  const items = specs[kind] || [{ action: 'verify-now', label: 'Verify', icon: 'shield', primary: true }];
  return AgentActionRow(items, chatIndex, usedActions);
}

function readOnlyContextChipsHtml(providerId, releaseId) {
  const provider = providerId ? providers.find((item) => item.id === providerId) : null;
  const release = releaseId ? releases.find((item) => item.id === releaseId) : null;
  if (!provider && !release) return '';
  return (provider ? contextChipHtml({
    kind: 'provider',
    index: 0,
    id: provider.id,
    iconHtml: provider.iconHtml || '<img src="' + providerAssetSrc(provider) + '" alt="" />',
    mutedLabel: provider.area,
    label: provider.name,
    readOnly: true,
  }) : '') +
  (release ? contextChipHtml({
    kind: 'release',
    index: 0,
    id: release.id,
    iconHtml: contextIconChip('repo'),
    mutedLabel: 'Version',
    label: release.label,
    readOnly: true,
  }) : '');
}

function ChatAgentResponse(meta, responseText, isError, providerId, releaseId, kind, chatIndex, messageId, cards, cardsOptions) {
  const contextChips = readOnlyContextChipsHtml(providerId, releaseId);
  const contextLine = contextChips
    ? '<div class="vr-agent-context-line">' + contextChips + '</div>'
    : '';
  const usedActions = new Set();
  const cardsHtml = cards ? ChatMissionCards(cards, chatIndex, cardsOptions || {}, usedActions) : '';
  const chat = chatContext(chatIndex);
  const cliAgent = chat ? cliAgents.find((item) => item.id === chat.cliId) : null;
  const statusWord = isError ? 'BLOCKED' : 'NOMINAL';
  const statusTone = isError ? 'blocked' : 'nominal';
  const via = cliAgent && cliAgent.id !== 'terminal'
    ? '<em>via ' + escapeHtml(cliAgent.label) + '</em>'
    : '';
  const gateNow = (currentState && currentState.gate) || {};
  const clearStamp = !isError && kind === 'verify' && gateNow.status === 'clear'
    ? '<div class="vr-stamp-row"><span class="vr-stamp is-clear">RAVEN &middot; CLEAR</span></div>'
    : '';
  return '<section class="vr-chat-message is-agent vr-chat-agent-response vr-hud-card is-' + statusTone + ' ' + (isError ? 'is-error' : 'is-ready') + '">' +
    '<header class="vr-hud-strip">' +
      '<span class="vr-hud-avatar is-raven"><img src="/manga/emblem.png" alt="" /></span>' +
      '<strong>VibeRaven</strong>' +
      '<span class="vr-hud-aibadge">AI AGENT</span>' +
      '<span class="vr-hud-status is-' + statusTone + '"><i></i>' + statusWord + '</span>' +
      via +
      '<b>Just now</b>' +
    '</header>' +
    contextLine +
    '<div class="vr-agent-response-stack">' +
    cardsHtml +
    renderAgentAnswerHtml(responseText, chatIndex, cards, isError, usedActions) +
    clearStamp +
    AgentResponseFollowUps(kind, isError, chatIndex, usedActions) +
    '</div>' +
    '</section>';
}

function SentContextPills(providerId, releaseId) {
  const chips = readOnlyContextChipsHtml(providerId, releaseId);
  if (!chips) return '';
  return '<div class="vr-sent-context">' + chips + '</div>';
}

function storyIconFor(kind) {
  if (kind === 'fix') return 'bolt';
  if (kind === 'verify') return 'shield';
  if (kind === 'diff') return 'code';
  if (kind === 'provider') return 'cube';
  if (kind === 'explain') return 'prompt';
  if (kind === 'plan') return 'report';
  return 'spark';
}

function storyNode(kindClass, dotHtml, bodyHtml) {
  return '<div class="vr-story-node ' + kindClass + '">' +
    '<span class="vr-story-dot">' + dotHtml + '</span>' +
    '<div class="vr-story-body">' + bodyHtml + '</div>' +
    '</div>';
}

function missionScopeLabel(providerId, releaseId) {
  const provider = providerId ? providers.find((item) => item.id === providerId) : null;
  if (provider) {
    const area = String(provider.area || '').trim();
    const name = String(provider.name || '').trim();
    return (area && name ? area + '/' + name : name || area).toUpperCase();
  }
  const release = releaseId ? releases.find((item) => item.id === releaseId) : null;
  if (release) return ('VERSION ' + String(release.label || '')).toUpperCase();
  return '';
}

function ProviderCardMessage(message) {
  const provider = providers.find((item) => item.id === message.providerId);
  if (!provider) return '';
  const grade = message.grade || provider.grade || { value: null, tier: 'facedown', label: 'FACE DOWN' };
  const rows = !Array.isArray(message.rows)
    ? '<div class="vr-card-row is-running"><span>&#9676;</span> running checks&hellip;</div>'
    : message.rows.map((row) => {
        const ready = row.state === 'ready';
        return '<div class="vr-card-row ' + (ready ? 'is-ready' : 'is-fix') + '">' +
          '<span>' + (ready ? '&#10003;' : '&#9679;') + '</span> ' + escapeHtml(row.title) +
          (ready ? '' : '<button class="vr-card-fix" type="button" data-action="fix-provider-item" data-provider="' + escapeHtml(provider.id) + '" data-item="' + escapeHtml(row.id) + '">fix &#9656;</button>') +
          '</div>';
      }).join('');
  const stamp = !message.done
    ? ''
    : grade.tier === 'review'
      ? '<span class="vr-stamp is-mini is-review">REVIEW</span>'
      : grade.tier === 'facedown'
        ? '<span class="vr-stamp is-mini is-idle">NOT SCANNED</span>'
        : '<span class="vr-stamp is-mini is-clear">RAVEN &middot; CLEAR</span>';
  const fixCount = Array.isArray(message.rows) ? message.rows.filter((row) => row.state !== 'ready').length : 0;
  const summary = !message.done
    ? ''
    : message.error
      ? '<p class="vr-card-error">' + escapeHtml(message.error) + '</p>'
      : fixCount > 0
        ? '<p class="vr-card-summary">' + String(fixCount) + ' thing' + (fixCount === 1 ? '' : 's') + ' before you ship.</p>'
        : '<p class="vr-card-summary">nothing blocking here.</p>';
  return '<section class="vr-chat-message is-agent vr-hud-card vr-card-message is-' + escapeHtml(grade.tier) + '">' +
    '<div class="vr-card-portrait">' + TradingCard({ ...provider, grade: grade }, 'dealt', { asDiv: true, forceFace: message.done && !message.error }) + '</div>' +
    '<div class="vr-card-rows">' + rows + summary + (stamp ? '<div class="vr-card-stamp-row">' + stamp + '</div>' : '') + '</div>' +
    '</section>';
}

function ReleaseCardMessage(message) {
  const release = releases.find((item) => item.id === message.releaseId);
  if (!release) return '';
  const isProd = release.tone === 'current';
  const pair = message.pair || releaseComparePair();
  const stats = message.compare && message.compare.stats;
  const statsText = stats && typeof stats === 'object'
    ? '+' + String(stats.insertions || 0) + ' / -' + String(stats.deletions || 0) + ' across ' + String(stats.files || 0) + ' file' + (Number(stats.files) === 1 ? '' : 's')
    : typeof stats === 'string' && stats.trim()
      ? stats.trim()
      : message.compare && message.compare.diff
        ? String(message.compare.diff).split('\\n').length + ' changed lines'
        : '';
  const body = !message.done
    ? '<div class="vr-card-row is-running"><span>&#9676;</span> reading ' + escapeHtml(pair.fromLabel) + ' &#8594; ' + escapeHtml(pair.toLabel) + '&hellip;</div>'
    : message.error
      ? '<p class="vr-card-error">' + escapeHtml(message.error) + '</p>'
      : (statsText ? '<div class="vr-card-row is-ready"><span>&#916;</span> ' + escapeHtml(statsText) + '</div>' : '') +
        (Array.isArray(message.changelog) && message.changelog.length
          ? message.changelog.slice(0, 5).map((entry) =>
              '<div class="vr-card-row is-log"><span>' + escapeHtml(entry.short || '') + '</span> ' + escapeHtml(entry.subject || '') + '</div>'
            ).join('')
          : '<p class="vr-card-summary">no commits between these two.</p>');
  const actions = message.done && !message.error
    ? '<div class="vr-card-actions">' +
      '<button type="button" data-action="show-release-diff" data-release="' + escapeHtml(release.id) + '">view diff &#9656;</button>' +
      '<button type="button" data-action="explain-release" data-release="' + escapeHtml(release.id) + '">explain changes &#9656;</button>' +
      '</div>'
    : '';
  return '<section class="vr-chat-message is-agent vr-hud-card vr-card-message vr-release-card-message">' +
    '<div class="vr-card-portrait">' +
      '<div class="vr-vcard is-mini' + (isProd ? ' is-current' : '') + '">' +
        '<span class="vr-vcard-top"><b>' + escapeHtml(release.label) + '</b></span>' +
        '<span class="vr-vcard-branch">' + escapeHtml(release.branch) + '</span>' +
        '<span class="vr-vcard-foot"><span class="vr-stamp is-mini ' + (isProd ? 'is-clear' : 'is-review') + '">' + (isProd ? 'PRODUCTION' : 'PREVIEW') + '</span></span>' +
      '</div>' +
    '</div>' +
    '<div class="vr-card-rows">' + body + actions + '</div>' +
    '</section>';
}

function renderChatMessages(chat, index) {
  const html = (chat.messages || []).map((message, messageIndex) => {
    if (message.kind === 'provider-card') {
      return storyNode('is-agent', Icon('cube'), ProviderCardMessage(message));
    }
    if (message.kind === 'release-card') {
      return storyNode('is-agent', Icon('clock'), ReleaseCardMessage(message));
    }
    if (message.role === 'user') {
      const scope = missionScopeLabel(message.providerId, message.releaseId);
      return storyNode('is-user',
        '<i></i>',
        '<section class="vr-chat-message is-user vr-hud-card is-mission">' +
          '<header class="vr-hud-strip"><strong>MISSION</strong>' + (scope ? '<em>' + escapeHtml(scope) + '</em>' : '') + '</header>' +
          '<p>' + escapeHtml(message.text) + '</p>' + SentContextPills(message.providerId, message.releaseId) + '</section>');
    }
    const meta = message.kind ? taskMeta(message.kind) : { title: 'VibeRaven Agent' };
    const messageId = String(index) + '-' + String(messageIndex);
    return storyNode('is-agent has-raven' + (message.isError ? ' is-error' : ''),
      '<img class="vr-raven-coin" src="/manga/emblem.png" alt="" />',
      ChatAgentResponse(meta, message.text, Boolean(message.isError), message.providerId, message.releaseId, message.kind, index, messageId, message.cards, { showPlan: demo.fixPlanExpandedChatIndex === index }));
  }).join('');
  return html;
}

function ChatMissionStatusStrip() {
  const gate = (currentState && currentState.gate) || {};
  const tone = gate.status === 'clear' ? 'ok' : gate.status === 'not_clear' ? 'blocker' : 'info';
  const stampTone = gate.status === 'clear' ? 'is-clear' : gate.status === 'not_clear' ? 'is-notyet' : 'is-idle';
  const label = gate.status === 'clear' ? 'RAVEN &middot; CLEAR' : gate.status === 'not_clear' ? 'NOT YET' : 'NOT SCANNED';
  const detected = providers.filter((provider) => provider.state !== 'not_detected').slice(0, 6);
  const dots = detected.map((provider) =>
    '<span class="vr-chat-provider-dot" draggable="true" data-provider="' + escapeHtml(provider.id) + '" data-provider-tone="' + escapeHtml(provider.tone || 'neutral') + '" title="' + escapeHtml(provider.name + ' · ' + provider.status) + '">' +
      (provider.iconHtml || '<img src="' + providerAssetSrc(provider) + '" alt="" />') +
    '</span>'
  ).join('');
  const versionDots = releases.slice(0, 4).map((release) =>
    '<span class="vr-chat-version-dot ' + (release.id === demo.selectedReleaseId ? 'is-selected' : '') + '" draggable="true" data-release="' + escapeHtml(release.id) + '" data-tone="' + escapeHtml(release.tone || 'planned') + '" title="' + escapeHtml(release.label + ' · ' + release.meta) + '">' +
      '<small>' + escapeHtml(String(release.label || '').replace(/^v/i, '')) + '</small>' +
    '</span>'
  ).join('');
  return '<div class="vr-chat-status-strip">' +
    '<button class="vr-chat-gate-chip vr-stamp is-mini ' + stampTone + ' is-' + tone + '" type="button" data-action="notifications" title="Open launch signals"><i></i>' + label + '</button>' +
    (dots ? '<span class="vr-chat-provider-dots" title="Detected providers — drag one into the chat">' + dots + '</span>' : '') +
    (versionDots ? '<span class="vr-chat-version-dots" title="Recent versions — drag one into the chat">' + versionDots + '</span>' : '') +
    '</div>';
}

function ChatQuickActions(index) {
  const buttons = quickActionButtonSpec(index);
  const primary = buttons.find((button) => button.action === 'start-agent-fix') || buttons[0];
  const scoped = demo.pickerChatIndex === index;
  const expanded = scoped && demo.quickActionsOpen
    ? '<div class="vr-chat-command-popover">' + buttons.map((button) =>
      '<button type="button" class="' + (button.primary ? 'is-primary' : button.muted ? 'is-muted' : '') + '" data-chat-index="' + String(index) + '" data-action="' + escapeHtml(button.action) + '"' + (button.hint ? ' title="' + escapeHtml(button.hint) + '"' : '') + '>' +
        Icon(button.icon) + '<span>' + escapeHtml(button.label) + '</span></button>'
    ).join('') + '</div>'
    : '';
  const worstId = worstProviderId();
  return '<div class="vr-chat-inline-actions">' +
    '<button type="button" data-action="add-context" data-chat-index="' + String(index) + '">' + Icon('plus') + '<span>Add context</span></button>' +
    '<button type="button" data-action="prompt" data-chat-index="' + String(index) + '">' + Icon('prompt') + '<span>Mention</span></button>' +
    '<span class="vr-chat-command-trigger"><button type="button" data-action="toggle-quick-actions" data-chat-index="' + String(index) + '" title="' + escapeHtml(primary.hint || 'Open commands') + '">' + Icon('code') + '<span>Commands</span></button>' +
      expanded +
    '</span>' +
    (worstId ? '<button type="button" class="is-worst-card" data-action="deal-provider" data-provider="' + escapeHtml(worstId) + '" title="Deal your weakest card — fix the biggest gap first">' + Icon('bolt') + '<span>Worst card</span></button>' : '') +
    '<button type="button" data-action="add-provider" title="Add a provider card to the table">' + Icon('cube') + '<span>Add card</span></button>' +
    '</div>';
}

function ChatComposerScope(index) {
  const chat = chatContext(index);
  const scoped = demo.pickerChatIndex === index;
  const menu = scoped && demo.scopeMenuOpen
    ? '<div class="vr-scope-menu" role="menu"><p>Context</p>' + contextLevels.map((level) =>
      '<button type="button" data-context="' + escapeHtml(level) + '" data-chat-index="' + String(index) + '">' +
        Icon(level === 'Security' ? 'shield' : level === 'Release' ? 'branch' : level === 'Provider' ? 'cube' : 'spark') +
        '<span>' + escapeHtml(level) + '</span>' + (chat.context === level ? '<b></b>' : '') +
      '</button>'
    ).join('') + '</div>'
    : '';
  return '<div class="vr-composer-scope-wrap">' +
    '<button type="button" class="vr-composer-scope" data-action="toggle-scope-menu" data-chat-index="' + String(index) + '">' +
      Icon(chat.context === 'Security' ? 'shield' : chat.context === 'Release' ? 'branch' : chat.context === 'Provider' ? 'cube' : 'spark') +
      '<strong>' + escapeHtml(chat.context || 'Production') + '</strong><i></i>' +
    '</button>' +
    menu +
    '</div>';
}

function contextChipHtml(options) {
  const kind = options.kind;
  const readOnly = Boolean(options.readOnly);
  const dataAttr = readOnly ? '' : (kind === 'provider'
    ? ' data-attached-provider="' + escapeHtml(options.id) + '"'
    : ' data-attached-release="' + escapeHtml(options.id) + '"');
  const removeAction = kind === 'provider' ? 'remove-provider-context' : 'remove-release-context';
  const removeLabel = kind === 'provider' ? 'Remove provider context' : 'Remove version context';
  let chipClass = 'vr-context-chip';
  if (kind === 'release') chipClass += ' is-release';
  if (readOnly) chipClass += ' is-readonly';
  const removeBtn = readOnly ? '' : '<button class="vr-context-chip-remove" type="button" data-action="' + removeAction + '" data-chat-index="' + String(options.index) + '" aria-label="' + removeLabel + '">×</button>';
  return '<span class="' + chipClass + '"' + dataAttr + '>' +
    '<span class="vr-context-chip-icon">' + options.iconHtml + '</span>' +
    '<span class="vr-context-chip-label"><span class="muted">' + escapeHtml(options.mutedLabel) + '</span> · ' + escapeHtml(options.label) + '</span>' +
    removeBtn +
    '</span>';
}

function ContextDropZone(index, showAttached) {
  const show = showAttached !== false;
  const context = chatContext(index);
  const provider = show && context.providerId ? providers.find((item) => item.id === context.providerId) : null;
  const release = show && context.releaseId ? releases.find((item) => item.id === context.releaseId) : null;
  if (!provider && !release && !demo.dropActive) return '';
  return '<div class="vr-provider-drop-zone ' + (demo.dropActive ? 'is-active' : '') + ((provider || release) ? ' has-provider' : '') + '" data-chat-drop="true" data-chat-index="' + String(index) + '">' +
    '<span class="vr-provider-drop-label">' + (provider || release ? 'Context attached' : 'Drop provider or version here to add context') + '</span>' +
    (provider ? contextChipHtml({
      kind: 'provider',
      index,
      id: provider.id,
      iconHtml: provider.iconHtml || '<img src="' + providerAssetSrc(provider) + '" alt="" />',
      mutedLabel: provider.area,
      label: provider.name,
    }) : '') +
    (release ? contextChipHtml({
      kind: 'release',
      index,
      id: release.id,
      iconHtml: contextIconChip('repo'),
      mutedLabel: 'Version',
      label: release.label,
    }) : '') +
    '</div>';
}

function ContextTray(index) {
  if (!(demo.pickerChatIndex === index && demo.contextTrayOpen)) return '';
  const providerItems = orderedProviders().filter((provider) => provider.state !== 'not_detected').slice(0, 6);
  const releaseItems = releases.slice(0, 4);
  const providersHtml = providerItems.map((provider) =>
    '<button type="button" draggable="true" data-provider="' + escapeHtml(provider.id) + '" data-context-provider="' + escapeHtml(provider.id) + '" data-chat-index="' + String(index) + '">' +
      '<span>' + (provider.iconHtml || '<img src="' + providerAssetSrc(provider) + '" alt="" />') + '</span>' +
      '<strong>' + escapeHtml(provider.name) + '</strong>' +
      '<em>' + escapeHtml(stackSlots[provider.id] || provider.area) + '</em>' +
    '</button>'
  ).join('');
  const releasesHtml = releaseItems.map((release) =>
    '<button type="button" draggable="true" data-release="' + escapeHtml(release.id) + '" data-context-release="' + escapeHtml(release.id) + '" data-chat-index="' + String(index) + '">' +
      '<span>' + Icon('branch') + '</span>' +
      '<strong>' + escapeHtml(release.label) + '</strong>' +
      '<em>' + escapeHtml(release.meta || release.branch) + '</em>' +
    '</button>'
  ).join('');
  return '<div class="vr-context-tray">' +
    '<header><strong>Add context</strong><button type="button" data-action="close-context-tray" data-chat-index="' + String(index) + '" aria-label="Close context tray">' + Icon('x') + '</button></header>' +
    '<section><p>Providers</p><div>' + (providersHtml || '<span class="vr-context-tray-empty">No providers detected yet.</span>') + '</div></section>' +
    '<section><p>Versions</p><div>' + (releasesHtml || '<span class="vr-context-tray-empty">No versions detected yet.</span>') + '</div></section>' +
    '</div>';
}

function ChatEnvironmentConnectCard() {
  const slots = [
    { label: 'GitHub', providerId: 'github', icon: 'github', action: 'provider' },
    { label: 'Database', providerId: 'supabase', icon: 'supabase', action: 'provider' },
    { label: 'Sentry', providerId: 'sentry', icon: 'sentry', action: 'provider' },
    { label: 'Deployment', providerId: 'vercel', icon: 'vercel', action: 'provider' },
    { label: 'Payments', providerId: 'stripe', icon: 'stripe', action: 'provider' },
    { label: 'More', providerId: '', icon: '', action: 'more' },
  ];
  const slotHtml = slots.map((slot) => {
    const provider = slot.providerId ? providers.find((item) => item.id === slot.providerId) : null;
    const mcp = provider ? providerMcp(provider) : null;
    // Two independent facts, and the panel used to collapse them into one. MCP
    // status comes from the user's global config (~/.codex/config.toml), so it
    // says "connected" for providers this repo does not use — which contradicted
    // the card next to it reading actual repo evidence. Project membership wins:
    // never claim a provider is wired up when it is not in this project.
    const inProject = Boolean(provider && provider.state !== 'not_detected');
    const mcpConnected = Boolean(mcp && mcp.status === 'connected');
    const connected = inProject && mcpConnected;
    const icon = provider
      ? (provider.iconHtml || '<img src="' + providerAssetSrc(provider) + '" alt="" />')
      : Icon('plus');
    const tone = slot.action === 'more'
      ? 'is-browse'
      : !inProject
        ? 'is-absent'
        : connected
          ? 'is-connected'
          : 'is-disconnected';
    const status = slot.action === 'more'
      ? 'Browse'
      : !inProject
        ? 'Not in project'
        : connected
          ? 'Connected'
          : 'Connect';
    const hint = slot.action === 'more'
      ? 'Browse every provider card'
      : !inProject
        ? slot.label + ' was not found in this repo' + (mcpConnected ? ', even though its MCP server is in your global config' : '')
        : connected
          ? slot.label + ' is in this repo and chat can read its live state'
          : slot.label + ' is in this repo. Connect MCP so chat reads live state instead of guessing.';
    // A provider that is not in the repo has nothing to connect, so send that
    // click to the provider context flow (which prefills the "help me add it"
    // mission) rather than an MCP connect that would not mean anything.
    const attrs = slot.action === 'more'
      ? 'data-action="add-provider"'
      : connected || !inProject
        ? 'data-provider="' + escapeHtml(slot.providerId) + '"'
        : 'data-action="connect-mcp" data-provider-id="' + escapeHtml(slot.providerId) + '"';
    return '<button type="button" class="vr-env-connect-option ' + tone + '" ' + attrs + ' title="' + escapeHtml(hint) + '">' +
      '<span>' + icon + '</span>' +
      '<strong>' + escapeHtml(slot.label) + '</strong>' +
      '<b>' + escapeHtml(status) + '</b>' +
    '</button>';
  }).join('');
  return '<section class="vr-env-connect-card">' +
    '<header><strong>Connect your environment</strong></header>' +
    '<div>' + slotHtml + '</div>' +
  '</section>';
}

function StudioChatLane(index) {
  const provider = providers.find((item) => item.id === demo.selectedProviderId) || providers[0];
  const chat = chatContext(index);
  const agent = cliAgents.find((item) => item.id === chat.cliId) || cliAgents[0];
  const model = selectedModelLabel(index);
  const secondary = index > 0;
  const laneHasTask = laneHasActiveTask(chat);
  const fresh = !secondary && !demo.activeRecentChatId && chat.messages.length === 0 && !chat.activeTask && !chat.providerId && !chat.releaseId;
  const showFirstConnect = fresh && !demo.cliSetupComplete && index === 0;
  const introBlock = showFirstConnect
    ? ChatFirstTimeConnect(index)
    : secondary && chat.messages.length === 0
      ? '<p class="vr-chat-copy">This chat is ready for a focused release or provider follow-up.</p>'
      : '';
  const laneWorking = laneHasTask;
  const sendAction = laneWorking ? 'stop-agent' : 'send-chat-message';
  const sendIcon = laneWorking ? 'stop' : 'arrowUp';
  const sendLabel = laneWorking ? 'Stop connected agent' : 'Send mission to connected agent';
  const gateNotClear = Boolean(currentState.gate && currentState.gate.status && currentState.gate.status !== 'clear');
  const introBlocker = missionCards && Array.isArray(missionCards.blockers) && missionCards.blockers.length ? missionCards.blockers[0] : null;
  const introBody = '<p>I\\'m at the table. Your providers are the cards on the right &mdash; grade 10 means production-ready. The gold medallion opens your region map.<br><strong>Start here:</strong> ' + escapeHtml(gateNotClear && introBlocker ? introBlocker.title : 'flip your first card — click any card in your hand.') + '</p>' +
    (gateNotClear && introBlocker ? '<button class="vr-start-here-cta" type="button" data-action="start-agent-fix" data-chat-index="' + String(index) + '">' + Icon('bolt') + '<span>Fix it with the connected agent</span></button>' : '') +
    ChatEnvironmentConnectCard();
  const staticIntro = fresh
    ? storyNode('is-agent is-intro has-raven', '<img class="vr-raven-coin" src="/manga/emblem.png" alt="" />', '<section class="vr-chat-message is-agent vr-chat-intro-message"><div><span class="vr-intro-raven"><img src="/manga/emblem.png" alt="" /></span><p><strong>VibeRaven Agent</strong><b>Agent</b><em class="is-ready">Ready</em></p></div>' + introBody + '</section>')
    : '';
  return '<article class="vr-chat-lane ' + (secondary ? 'is-secondary' : 'is-primary') + '" data-chat-index="' + String(index) + '">' +
    (secondary ? '<button class="vr-chat-close" type="button" data-action="close-chat" data-chat-index="' + String(index) + '" aria-label="Close chat">' + Icon('x') + '</button>' : '') +
    (demo.activeChatCount > 1 ? CliConnectPanel(index) : '') +
    '<div class="vr-chat-transcript vr-chat-story" data-chat-transcript="' + String(index) + '">' +
      staticIntro +
      introBlock +
      renderChatMessages(chat, index) +
    '</div>' +
    '<footer class="vr-chat-command-bar">' +
      (laneHasTask ? ChatTaskAnimation(index, true) : '') +
      '<div class="vr-chat-composer" data-chat-drop="true" data-chat-index="' + String(index) + '">' +
        '<div class="vr-composer-top">' + ChatComposerScope(index) + '</div>' +
        '<textarea class="vr-chat-input" data-chat-input="' + String(index) + '" rows="1" placeholder="Ask VibeRaven anything about this deployment...">' + escapeHtml(chat.draft || '') + '</textarea>' +
        ContextTray(index) +
        ContextDropZone(index, true) +
        '<div class="vr-composer-bottom">' + ChatQuickActions(index) + '<div class="vr-composer-controls">' + ModelPicker(index) + '<button class="vr-chat-send ' + (laneWorking ? 'is-stop' : '') + '" type="button" data-action="' + sendAction + '" data-chat-index="' + String(index) + '" aria-label="' + sendLabel + '">' + Icon(sendIcon) + '</button></div></div>' +
      '</div>' +
    '</footer>' +
    '</article>';
}

function readArchLayout() {
  try {
    const raw = window.localStorage.getItem('vrArchLayout');
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch { return null; }
}

function saveArchLayout() {
  try {
    if (demo.archGraph && demo.archGraph.pos) window.localStorage.setItem('vrArchLayout', JSON.stringify(demo.archGraph.pos));
  } catch { /* ignore */ }
}

function tableCardRotation(providerId) {
  let hash = 0;
  for (let i = 0; i < providerId.length; i += 1) hash = (hash * 31 + providerId.charCodeAt(i)) % 997;
  return (hash % 9) - 4;
}

function TablePlaymat() {
  const entries = Object.entries(demo.tablePlacements || {});
  if (!entries.length) return '';
  const cards = entries.map(([key, pos]) => {
    if (!pos) return '';
    const x = Math.max(0.04, Math.min(0.96, Number(pos.x) || 0.5));
    const y = Math.max(0.06, Math.min(0.9, Number(pos.y) || 0.5));
    const place = 'left:' + (x * 100).toFixed(2) + '%;top:' + (y * 100).toFixed(2) + '%;--vr-rot:' + tableCardRotation(key) + 'deg';
    if (key.indexOf('rel:') === 0) {
      const release = releases.find((item) => item.id === key.slice(4));
      if (!release) return '';
      const isProd = release.tone === 'current';
      return '<button class="vr-vcard is-mini is-placed" type="button" data-release="' + escapeHtml(release.id) + '" style="' + place + '" title="Deal ' + escapeHtml(release.label) + ' into chat">' +
        '<span class="vr-tcard-unplace" data-action="unplace-card" data-unplace="' + escapeHtml(key) + '" title="Return to the pile">&#10005;</span>' +
        '<span class="vr-vcard-top"><b>' + escapeHtml(release.label) + '</b></span>' +
        '<span class="vr-vcard-branch">' + escapeHtml(release.branch) + '</span>' +
        '<span class="vr-vcard-foot"><span class="vr-stamp is-mini ' + (isProd ? 'is-clear' : 'is-review') + '">' + (isProd ? 'PRODUCTION' : 'PREVIEW') + '</span></span>' +
        '</button>';
    }
    const provider = providers.find((item) => item.id === key);
    if (!provider) return '';
    return TradingCard(provider, 'hand', {
      placed: true,
      style: place,
    });
  }).join('');
  return '<div class="vr-playmat">' + cards + '</div>';
}

function VersionPile() {
  if (!releases.length) return '';
  if (demo.pileCollapsed) {
    return '<aside class="vr-version-pile is-collapsed"><button class="vr-pile-shuffle" type="button" data-action="toggle-pile" title="Show the version pile">VERSIONS &#9656;</button></aside>';
  }
  const offset = ((demo.pileOffset || 0) % releases.length + releases.length) % releases.length;
  const ordered = releases.slice(offset).concat(releases.slice(0, offset));
  const pile = ordered.slice(0, 4);
  return '<aside class="vr-version-pile" aria-label="Versions — click the top card, shuffle, or drag one anywhere">' +
    '<div class="vr-version-pile-stack">' +
      pile.map((release, index) =>
        index === 0
          ? '<button class="vr-vpile-card is-top" type="button" data-release="' + escapeHtml(release.id) + '" style="--vr-i:0" title="Deal ' + escapeHtml(release.label) + ' — compare and changelog land in chat">' +
              '<b>' + escapeHtml(release.label) + '</b>' +
              '<em>' + escapeHtml(release.branch) + '</em>' +
            '</button>'
          : '<button class="vr-vpile-card" type="button" data-action="pile-front" data-release="' + escapeHtml(release.id) + '" style="--vr-i:' + index + '" title="Bring ' + escapeHtml(release.label) + ' to the top">' +
              '<b>' + escapeHtml(release.label) + '</b>' +
            '</button>'
      ).join('') +
    '</div>' +
    '<span class="vr-version-pile-row">' +
      '<span class="vr-version-pile-label">VERSIONS &middot; ' + escapeHtml(pile[0] ? pile[0].label : '') + '</span>' +
      '<button class="vr-pile-shuffle" type="button" data-action="pile-shuffle" title="Shuffle the pile">&#10227; SHUFFLE</button>' +
    '</span>' +
    '</aside>';
}

function AddProviderPopover() {
  const candidates = providers
    .filter((item) => !demo.tablePlacements[item.id])
    .slice()
    .sort((a, b) => (a.state === 'not_detected' ? 0 : 1) - (b.state === 'not_detected' ? 0 : 1));
  const body = candidates.length
    ? '<div class="vr-addpick-grid">' + candidates.map((provider) => {
        const isNew = provider.state === 'not_detected';
        return '<button class="vr-addpick-card" type="button" data-action="pick-provider" data-pick="' + escapeHtml(provider.id) + '" title="Place ' + escapeHtml(provider.name) + ' on the table">' +
          TradingCard(provider, 'map', { asDiv: true }) +
          '<em>' + (isNew ? 'NEW &middot; ' : '') + escapeHtml(String(provider.area || '').toUpperCase()) + '</em>' +
        '</button>';
      }).join('') + '</div>'
    : '<p class="vr-addpick-empty">Every provider card is already on the table. Drag one to rearrange, or click it to run its checks.</p>';
  return '<div class="vr-addpick-backdrop" data-action="add-provider" aria-hidden="true"></div>' +
    '<div class="vr-addpick" role="dialog" aria-label="Add a provider card to the table">' +
    '<header><strong>ADD A CARD TO THE TABLE</strong><button type="button" data-action="add-provider" aria-label="Close">' + Icon('x') + '</button></header>' +
    body +
    '<footer>Placing a card puts it face-down on the felt — click it there to run its first checks. Nothing goes to chat until you say so.</footer>' +
    '</div>';
}

function ConnectCardPopover() {
  const provider = providers.find((item) => item.id === demo.connectCardId);
  if (!provider) return '';
  const name = escapeHtml(provider.name);
  const mcp = providerMcp(provider);
  const mcpConnected = mcp.status === 'connected';
  const mcpAvailable = mcp.available !== false;
  const busy = demo.mcpConnecting === provider.id;
  const message = String(demo.mcpConnectMessage || '');
  const step1Action = mcpConnected
    ? '<span class="vr-connectcard-done">' + Icon('check') + ' CONNECTED &mdash; missions can see live state</span>'
    : mcpAvailable
      ? '<button type="button" data-action="connect-mcp" data-provider-id="' + escapeHtml(provider.id) + '"' + (busy ? ' disabled' : '') + '>' + (busy ? 'Connecting&hellip;' : 'Connect MCP &mdash; one click') + '</button>'
      : '<span class="vr-connectcard-skip">No one-click server for ' + name + ' yet &mdash; step 2 covers the setup instead.</span>';
  return '<div class="vr-addpick-backdrop" data-action="close-connect-card" aria-hidden="true"></div>' +
    '<div class="vr-addpick vr-connectcard" role="dialog" aria-label="Connect ' + name + '">' +
    '<header><strong>CONNECT ' + name.toUpperCase() + '</strong><button type="button" data-action="close-connect-card" aria-label="Close">' + Icon('x') + '</button></header>' +
    '<p class="vr-connectcard-sub">The card is on your table. Two clicks make it useful: give chat live ' + name + ' context, then let your agent wire the code.</p>' +
    '<div class="vr-connectcard-body">' +
      '<div class="vr-connectcard-card">' + TradingCard(provider, 'dealt', { asDiv: true }) + '</div>' +
      '<ol class="vr-connectcard-steps">' +
        '<li class="' + (mcpConnected ? 'is-done' : '') + '">' +
          '<strong><b>1</b> SEE LIVE ' + name.toUpperCase() + ' STATE</strong>' +
          '<p>' + (mcpConnected
            ? 'Already set up in this repo (.mcp.json). Chat missions check real ' + name + ' state instead of guessing.'
            : 'Adds the ' + name + ' MCP server to this repo (.mcp.json). Chat missions then check real provider state instead of guessing.') + '</p>' +
          step1Action +
          (message && !mcpConnected ? '<em class="vr-connectcard-msg">' + escapeHtml(message) + '</em>' : '') +
        '</li>' +
        '<li>' +
          '<strong><b>2</b> LET YOUR AGENT WIRE IT</strong>' +
          '<p>Puts a ready-made mission in chat: SDK, env placeholders, config' + (mcpAvailable || mcpConnected ? '' : ', MCP setup') + ', and a final check. Nothing runs until you press send.</p>' +
          '<button type="button" data-action="connect-provider-mission" data-provider-id="' + escapeHtml(provider.id) + '">Put the mission in chat</button>' +
        '</li>' +
        '<li class="is-note">' +
          '<strong><b>3</b> YOUR KEYS STAY YOURS</strong>' +
          '<p>Secrets and product setup happen in the ' + name + ' dashboard. The mission ends with the exact steps that are yours.</p>' +
        '</li>' +
      '</ol>' +
    '</div>' +
    '<footer>Nothing runs without your OK. Close this and the ' + name + ' card stays on your table.</footer>' +
    '</div>';
}

function worstProviderId() {
  const graded = providers.filter((item) => item.state !== 'not_detected' && item.grade && typeof item.grade.value === 'number');
  const worst = graded.slice().sort((a, b) => a.grade.value - b.grade.value)[0];
  return worst ? worst.id : null;
}

// Top-left plaque = the live table STATS (real repo/provider data), replacing
// the old crimson ribbon. Compact stat cells so it fits the header row.
function TablePlaque() {
  const gate = (currentState && currentState.gate) || {};
  const gateClear = gate.status === 'clear';
  const stamp = gateClear
    ? '<span class="vr-stamp is-mini is-clear">RAVEN &middot; CLEAR</span>'
    : gate.status === 'not_clear'
      ? '<span class="vr-stamp is-mini is-notyet">NOT YET</span>'
      : '<span class="vr-stamp is-mini is-idle">NOT SCANNED</span>';
  const detected = providers.filter((item) => item.state !== 'not_detected');
  const review = detected.filter((item) => item.grade && item.grade.tier === 'review').length;
  const graded = detected.filter((item) => item.grade && typeof item.grade.value === 'number');
  const avg = graded.length ? graded.reduce((sum, item) => sum + item.grade.value, 0) / graded.length : 0;
  const dirty = (demo.worktree && Number(demo.worktree.dirtyCount)) || 0;
  // Two different numbers used to sit here unlabelled: the average provider card
  // grade (0-10) and, in the terminal, the gate score (0-100). A repo could read
  // "GRADE 0.0" here and "score 65" from viberaven check with nothing saying
  // they measure different things. Both now carry their scale, and the gate score
  // is shown so the header and the terminal agree on the headline verdict.
  const gateScore = typeof gate.score === 'number' ? gate.score : null;
  const cells = [
    { label: 'Providers', value: String(detected.length), tone: 'gold' },
    {
      label: 'Gate score /100',
      value: gateScore == null ? '&#8212;' : String(gateScore),
      tone: gateClear ? 'green' : gateScore == null ? 'muted' : 'orange',
    },
    { label: 'Grade /10', value: graded.length ? avg.toFixed(1) : '&#8212;', tone: 'gold' },
    { label: 'Review', value: String(review), tone: review > 0 ? 'orange' : 'muted' },
    { label: 'Uncommitted', value: String(dirty), tone: dirty > 0 ? 'orange' : 'green' },
  ];
  return '<div class="vr-table-ribbon">' +
    '<div class="vr-ribbon-brand"><strong>' + escapeHtml(projectName()).toUpperCase() + '</strong>' + stamp + '</div>' +
    '<div class="vr-ribbon-stats">' +
      cells.map((c) => '<span class="vr-ribbon-stat is-' + c.tone + '"><b>' + c.value + '</b><i>' + escapeHtml(c.label) + '</i></span>').join('') +
    '</div>' +
    '</div>';
}

function TheHand() {
  const hand = orderedProviders();
  const count = hand.length;
  if (!count) return '';
  const mid = (count - 1) / 2;
  const cards = hand.map((provider, index) => {
    const rot = ((index - mid) * 5).toFixed(1);
    const lift = (Math.abs(index - mid) * 7).toFixed(0);
    return TradingCard(provider, 'hand', { style: '--vr-rot:' + rot + 'deg;--vr-lift:' + lift + 'px' });
  }).join('');
  return '<aside class="vr-hand' + (demo.handCollapsed ? ' is-collapsed' : '') + '" aria-label="Your providers — click a card to deal it into chat">' +
    '<div class="vr-hand-fan">' + cards + '</div>' +
    '</aside>';
}

function TableShelf() {
  const handCount = orderedProviders().length;
  return '<footer class="vr-table-shelf" aria-label="Your versions, provider cards, and table actions">' +
    '<div class="vr-shelf-slot is-left">' + VersionPile() + '</div>' +
    '<div class="vr-shelf-slot is-right">' +
      '<span class="vr-shelf-chip-row">' +
        (handCount ? '<button class="vr-shelf-chip" type="button" data-action="toggle-hand" title="' + (demo.handCollapsed ? 'Show your hand' : 'Tuck the hand away') + '">' + (demo.handCollapsed ? 'HAND &middot; ' + String(handCount) : 'TUCK &#9662;') + '</button>' : '') +
        '<button class="vr-shelf-chip is-gold" type="button" data-action="add-provider">&#65291; ADD CARD</button>' +
      '</span>' +
      TheHand() +
    '</div>' +
    '</footer>';
}

function StudioChatView() {
  const lanes = Array.from({ length: demo.activeChatCount }, (_, index) => StudioChatLane(index)).join('');
  const single = demo.activeChatCount === 1;
  return '<section class="vr-studio-chat ' + (demo.activeChatCount > 1 ? 'is-split' : '') + (demo.dropActive ? ' is-drop-preview' : '') + '" data-chat-count="' + String(demo.activeChatCount) + '" data-table-drop="true" aria-label="Production mission chat workspace">' +
    (single ? TablePlaymat() : '') +
    '<div class="vr-chat-lanes" data-chat-drop="true">' + lanes + '</div>' +
    (single ? TableShelf() : '') +
    (demo.addProviderOpen ? AddProviderPopover() : '') +
    (demo.connectCardId ? ConnectCardPopover() : '') +
    (single ? '<button class="vr-map-medallion" type="button" data-studio-tab="architecture" title="Open the region map">' + Icon('branch') + '<em>REGION MAP</em></button>' : '') +
    '</section>';
}

function StudioDiffView() {
  const diff = demo.releaseDiff || {};
  const stats = diff.stats || null;
  const headerMeta = diff.loading
    ? 'Loading git diff…'
    : diff.error
      ? 'Compare failed'
      : stats && (stats.files || stats.insertions || stats.deletions)
        ? ('+' + String(stats.insertions || 0) + ' -' + String(stats.deletions || 0) + ' · ' + String(stats.files || 0) + ' files')
        : diff.text
          ? (diff.fromLabel && diff.toLabel ? diff.fromLabel + ' → ' + diff.toLabel : 'Release diff ready')
          : (demo.verified ? 'Verified changes' : demo.agentFixing ? 'Agent running' : 'Compare releases to load a diff');
  const body = diff.loading
    ? '<pre><code>Fetching git diff…</code></pre>'
    : diff.error
      ? '<pre><code class="del">' + escapeHtml(diff.error) + '</code></pre>'
      : diff.text
        ? '<pre>' + formatDiffPreHtml(diff.text) + '</pre>'
        : '<pre><code><em>Use Compare Releases in the Versions panel to load a real git diff.</em></code></pre>';
  return '<section class="vr-studio-diff" aria-label="Live git diff preview">' +
    '<header><strong>Live Diff</strong><span>' + escapeHtml(headerMeta) + '</span></header>' +
    body +
    '<footer><button type="button" data-action="diff-to-chat">Explain in Chat</button><button type="button" data-action="verify-now">Accept & Verify</button></footer>' +
    '</section>';
}

const ARCH_NODE_W = 168;
const ARCH_NODE_H = 56;

function archAreaTarget(area) {
  const key = String(area || '').toLowerCase();
  if (key.includes('database') || key.includes('cache')) return 'data';
  if (key.includes('cloud') || key.includes('deploy') || key.includes('version') || key.includes('analytics')) return 'pages';
  return 'api';
}

const ARCH_AREA_TO_NODE = {
  database: 'data', auth: 'api', payments: 'api', security: 'api',
  deployment: 'pages', frontend: 'pages', errorHandling: 'pages',
  monitoring: 'api', testing: 'api', landing: 'pages', backend: 'api', appFlow: 'pages',
};

function buildArchGraph(data, gaps) {
  const nodes = [];
  const edges = [];
  const pos = {};
  const place = (id, x, y) => { pos[id] = { x, y }; };

  const health = {};
  const healthGaps = {};
  (gaps || []).forEach((gap) => {
    const nodeId = ARCH_AREA_TO_NODE[gap.area] || 'api';
    const tone = String(gap.severity) === 'critical' ? 'red' : 'orange';
    if (health[nodeId] !== 'red') health[nodeId] = tone;
    (healthGaps[nodeId] = healthGaps[nodeId] || []).push(gap);
  });

  const core = (id, icon, label, sub, ask) => {
    nodes.push({ id, kind: 'core', icon, label, sub, ask, health: health[id] || '', gapCount: (healthGaps[id] || []).length });
  };

  core('user', 'people', 'Users', (data.archetype || 'App') + ' traffic', 'the user-facing entry path');
  core('pages', 'doc', 'Pages', data.pages.length ? data.pages.length + ' route' + (data.pages.length === 1 ? '' : 's') : 'none detected', 'the page/user surface');
  core('api', 'bolt', 'API', data.apiRoutes.length ? data.apiRoutes.length + ' route' + (data.apiRoutes.length === 1 ? '' : 's') : 'none detected', 'the API surface');
  core('data', 'cube', 'Data', data.migrations.length ? data.migrations.length + ' migration' + (data.migrations.length === 1 ? '' : 's') : 'no migrations', 'the data layer and schema history');
  place('user', 16, 44); place('pages', 236, 44); place('api', 456, 44); place('data', 676, 44);
  edges.push({ from: 'user', to: 'pages' }, { from: 'pages', to: 'api' }, { from: 'api', to: 'data' });

  if (data.webhooks.length) {
    core('webhooks', 'bell', 'Webhooks', data.webhooks.length + ' handler' + (data.webhooks.length === 1 ? '' : 's'), 'the webhook handlers');
    place('webhooks', 896, 44);
    edges.push({ from: 'api', to: 'webhooks' });
  }

  const modules = Array.isArray(data.modules) ? data.modules : [];
  const modulesY = 152;
  modules.forEach((mod, index) => {
    const id = 'mod:' + mod.name;
    nodes.push({ id, kind: 'core', icon: 'repo', label: mod.name, sub: mod.files + ' files', ask: 'the ' + mod.name + ' module', isModule: true });
    place(id, 16 + (index % 5) * 195, modulesY + Math.floor(index / 5) * 82);
    if (mod.hasPages) edges.push({ from: id, to: 'pages' });
    if (mod.hasApi) edges.push({ from: id, to: 'api' });
    if (mod.hasData) edges.push({ from: id, to: 'data' });
  });
  const moduleRows = modules.length ? Math.ceil(Math.min(modules.length, 8) / 5) : 0;

  if (data.jobs.length) {
    core('jobs', 'gear', 'Jobs', data.jobs.length + ' worker file' + (data.jobs.length === 1 ? '' : 's'), 'the background jobs');
    place('jobs', 896, modulesY);
    edges.push({ from: 'data', to: 'jobs' });
  }

  const providersY = modules.length ? modulesY + moduleRows * 82 + 46 : 262;
  const board = providers
    .filter((provider) => provider.state !== 'not_detected')
    .slice()
    .sort((a, b) => String(a.area || '').localeCompare(String(b.area || '')) || String(a.name || '').localeCompare(String(b.name || '')));
  board.forEach((provider, index) => {
    const id = 'prov:' + provider.id;
    nodes.push({ id, kind: 'provider', providerId: provider.id, label: provider.name, sub: provider.area, tone: provider.tone || 'neutral', iconHtml: provider.iconHtml || '<img src="' + providerAssetSrc(provider) + '" alt="" />' });
    place(id, 16 + (index % 5) * 195, providersY + Math.floor(index / 5) * 158);
    edges.push({ from: id, to: archAreaTarget(provider.area) });
  });

  const savedLayout = readArchLayout();
  if (savedLayout) {
    Object.keys(savedLayout).forEach((key) => {
      const saved = savedLayout[key];
      if (pos[key] && saved && Number.isFinite(saved.x) && Number.isFinite(saved.y)) pos[key] = { x: saved.x, y: saved.y };
    });
  }
  return { nodes, edges, pos, healthGaps, zones: { modulesY: modules.length ? modulesY : 0, providersY } };
}

function compactArchGraph(graph) {
  const pos = {};
  const columnGap = 204;
  const rowGap = 74;
  const left = 16;
  const place = (id, x, y) => { pos[id] = { x, y }; };
  const existing = (ids) => ids.filter((id) => graph.nodes.some((node) => node.id === id));
  const placeGrid = (ids, y, columns) => {
    ids.forEach((id, index) => {
      place(id, left + (index % columns) * columnGap, y + Math.floor(index / columns) * rowGap);
    });
    return y + Math.max(1, Math.ceil(ids.length / columns)) * rowGap;
  };

  let y = 42;
  y = placeGrid(existing(['user', 'pages', 'api', 'data']), y, 2);
  const secondaryCore = existing(['webhooks', 'jobs']);
  if (secondaryCore.length) y = placeGrid(secondaryCore, y + 6, 2);

  const modulesY = graph.nodes.some((node) => node.id.indexOf('mod:') === 0) ? y + 18 : 0;
  if (modulesY) {
    y = placeGrid(graph.nodes.filter((node) => node.id.indexOf('mod:') === 0).map((node) => node.id), modulesY, 2);
  }

  const providersY = y + 18;
  placeGrid(graph.nodes.filter((node) => node.id.indexOf('prov:') === 0).map((node) => node.id), providersY, 2);

  return {
    ...graph,
    pos,
    zones: { modulesY, providersY },
    compact: true,
  };
}

function archNodeSize(graph, nodeId) {
  const node = graph && Array.isArray(graph.nodes) ? graph.nodes.find((item) => item.id === nodeId) : null;
  if (node && node.kind === 'provider') return { w: 90, h: 126 };
  return { w: ARCH_NODE_W, h: ARCH_NODE_H };
}

function archEdgePath(graph, edge) {
  const pos = graph.pos;
  const a = pos[edge.from];
  const b = pos[edge.to];
  if (!a || !b) return '';
  const sa = archNodeSize(graph, edge.from);
  const sb = archNodeSize(graph, edge.to);
  const ax = a.x + sa.w / 2;
  const ay = a.y + sa.h / 2;
  const bx = b.x + sb.w / 2;
  const by = b.y + sb.h / 2;
  const goingDown = by >= ay;
  const x1 = ax;
  const y1 = goingDown ? a.y + sa.h : a.y;
  const x2 = bx;
  const y2 = goingDown ? b.y : b.y + sb.h;
  const my = (y1 + y2) / 2;
  return 'M' + x1 + ' ' + y1 + ' C' + x1 + ' ' + my + ' ' + x2 + ' ' + my + ' ' + x2 + ' ' + y2;
}

function updateArchEdges() {
  const svg = app.querySelector('.vr-arch-edges');
  const graph = demo.archGraph;
  if (!svg || !graph) return;
  graph.edges.forEach((edge) => {
    const path = svg.querySelector('[data-arch-edge="' + edge.from + ':' + edge.to + '"]');
    if (path) path.setAttribute('d', archEdgePath(graph.pos, edge));
  });
}

function archDrawerItems(map, nodeId) {
  const data = map.data || {};
  if (nodeId === 'pages') return { title: 'Pages / User Surface', items: data.pages || [] };
  if (nodeId === 'api') return { title: 'API Surface', items: data.apiRoutes || [] };
  if (nodeId === 'data') return { title: 'Data Layer / Migrations', items: data.migrations || [] };
  if (nodeId === 'webhooks') return { title: 'Webhook Handlers', items: data.webhooks || [] };
  if (nodeId === 'jobs') return { title: 'Background Jobs', items: data.jobs || [] };
  if (nodeId === 'user') return { title: 'Product', items: [data.archetype || 'App', 'Stack: ' + ((data.stack || []).join(', ') || 'unknown')] };
  if (nodeId && nodeId.indexOf('mod:') === 0) {
    const name = nodeId.slice(4);
    const mod = (data.modules || []).find((m) => m.name === name);
    return { title: name, items: mod ? [mod.files + ' code files', mod.hasPages ? 'contains pages' : '', mod.hasApi ? 'contains API/server code' : '', mod.hasData ? 'contains schema/migrations' : ''].filter(Boolean) : [] };
  }
  return null;
}

function archBoundaryPresets(nodeId) {
  if (nodeId === 'user') return {
    blurb: 'Everyone who visits, signs up, and signs into your product.',
    actions: [
      { icon: 'shield', label: 'Add login & sign-up', prompt: 'Add authentication to this app: sign-up, login, logout, and session handling using the auth provider already in the stack (or recommend one). Smallest safe implementation first.' },
      { icon: 'lock', label: 'Protect private pages', prompt: 'Find pages and API routes that should require login but do not, and protect them. Show me the list before changing anything.' },
      { icon: 'report', label: 'Understand my users', prompt: 'Wire product analytics so I can see sign-ups, active users, and drop-off. Use the analytics provider already detected, or recommend one and set it up.' },
    ],
  };
  if (nodeId === 'pages') return {
    blurb: 'The screens your users actually see.',
    actions: [
      { icon: 'plus', label: 'Add a new page', prompt: 'Help me add a new page: ask me what the page is for, then create it matching the existing layout, navigation, and styles.' },
      { icon: 'spark', label: 'Improve SEO & speed', prompt: 'Audit the pages for SEO and speed: titles, meta descriptions, image sizes, and loading states. Fix the easy wins and list the rest.' },
      { icon: 'flag', label: 'Find broken pages', prompt: 'Check every page route for broken links, missing 404/error pages, and dead navigation. Fix what is safe and report the rest.' },
    ],
  };
  if (nodeId === 'api') return {
    blurb: 'The endpoints where your app talks to the outside world.',
    actions: [
      { icon: 'shield', label: 'Secure my endpoints', prompt: 'Audit the API routes for missing auth checks, rate limiting, and input validation. Fix the highest-risk route first and explain what you did in plain language.' },
      { icon: 'bolt', label: 'Add rate limiting', prompt: 'Add rate limiting to the API routes so one abusive client cannot run up my provider bills. Protect auth and AI endpoints first.' },
      { icon: 'plus', label: 'Add an endpoint', prompt: 'Help me add a new API endpoint: ask me what it should do, then implement it with validation, auth, and an error response that will not leak internals.' },
    ],
  };
  if (nodeId === 'data') return {
    blurb: 'Your database — schema, migrations, and the rules protecting user data.',
    actions: [
      { icon: 'lock', label: 'Protect user data (RLS)', prompt: 'Check my database tables for missing row-level security and add policies so users can only see their own data. Keep every policy in a migration file.' },
      { icon: 'spark', label: 'Fix slow queries', prompt: 'Find database queries with no limit or missing indexes that will get slow as I grow. Add pagination and indexes where needed — this is my scaling safety net.' },
      { icon: 'doc', label: 'Change my schema', prompt: 'Help me change my database schema: ask me what I need, then write the migration, update the code that uses it, and tell me how to roll back if it breaks.' },
    ],
  };
  if (nodeId === 'webhooks') return {
    blurb: 'Where providers like Stripe call back into your app.',
    actions: [
      { icon: 'shield', label: 'Verify webhook security', prompt: 'Audit my webhook handlers: signature verification, idempotency, and error handling. Fix what is unsafe.' },
    ],
  };
  if (nodeId === 'jobs') return {
    blurb: 'Background work that runs without a user watching.',
    actions: [
      { icon: 'flag', label: 'Make jobs reliable', prompt: 'Audit my background jobs for missing retries, timeouts, and failure alerts. Fix the riskiest one.' },
    ],
  };
  if (nodeId && nodeId.indexOf('mod:') === 0) {
    const name = nodeId.slice(4);
    return {
      blurb: 'A module of your codebase.',
      actions: [
        { icon: 'prompt', label: 'Explain this module', prompt: 'Explain the ' + name + ' module in plain language: what it does, what depends on it, and what I should be careful about when changing it.' },
        { icon: 'flag', label: 'Find risky code here', prompt: 'Review the ' + name + ' module for the riskiest code: missing error handling, security issues, and things that break at scale. Fix the worst one.' },
      ],
    };
  }
  return { blurb: '', actions: [] };
}

function ArchDrawer(map, graph) {
  const nodeId = demo.archDrawer;
  if (!nodeId) return '';
  const info = archDrawerItems(map, nodeId);
  if (!info) return '';
  const node = graph.nodes.find((item) => item.id === nodeId);
  const presets = archBoundaryPresets(nodeId);
  const nodeGaps = (graph.healthGaps && graph.healthGaps[nodeId]) || [];
  const gapsHtml = nodeGaps.length
    ? '<h4>Needs attention</h4>' + nodeGaps.map((gap) => '<p class="vr-arch-drawer-gap is-' + (String(gap.severity) === 'critical' ? 'red' : 'orange') + '"><i></i>' + escapeHtml(gap.title || gap.id) + '</p>').join('')
    : '';
  const actionsHtml = presets.actions.length
    ? '<h4>Take control</h4><div class="vr-arch-drawer-actions">' + presets.actions.map((action) =>
        '<button type="button" data-action="arch-preset" data-prompt="' + escapeHtml(action.prompt) + '">' + Icon(action.icon) + '<span>' + escapeHtml(action.label) + '</span></button>'
      ).join('') + '</div>'
    : '';
  const items = info.items.slice(0, 8).map((item) => '<li>' + escapeHtml(item) + '</li>').join('');
  const critical = nodeGaps.filter((gap) => String(gap.severity) === 'critical').length;
  const statusTone = critical ? 'red' : nodeGaps.length ? 'orange' : 'green';
  const statusText = critical
    ? critical + ' critical issue' + (critical === 1 ? '' : 's') + ' — fix before launch'
    : nodeGaps.length
      ? nodeGaps.length + ' thing' + (nodeGaps.length === 1 ? '' : 's') + ' to improve'
      : 'Looking good — nothing flagged here';
  return '<aside class="vr-arch-drawer">' +
    '<header><strong>' + escapeHtml(info.title) + '</strong><button type="button" data-action="arch-drawer-close" aria-label="Close">' + Icon('x') + '</button></header>' +
    '<p class="vr-arch-drawer-status is-' + statusTone + '"><i></i>' + escapeHtml(statusText) + '</p>' +
    (presets.blurb ? '<p class="vr-arch-drawer-blurb">' + escapeHtml(presets.blurb) + '</p>' : '') +
    gapsHtml +
    actionsHtml +
    (items ? '<h4>Detected</h4><ul>' + items + '</ul>' : '<p class="vr-arch-empty">Nothing detected on this boundary yet — the actions above still work.</p>') +
    (info.items.length > 8 ? '<p class="vr-arch-empty">…and ' + (info.items.length - 8) + ' more</p>' : '') +
    '<footer>' +
      '<button type="button" data-action="arch-copy-paths" data-node="' + escapeHtml(nodeId) + '">' + Icon('copy') + 'Copy list</button>' +
      '<button class="is-primary" type="button" data-action="arch-node-ask" data-node-label="' + escapeHtml(node && node.ask ? node.ask : info.title) + '">' + Icon('agent') + 'Ask agent</button>' +
    '</footer>' +
    '</aside>';
}

function StudioArchitectureView() {
  const map = demo.architectureMap || {};
  const inspectorMap = false; // card table: architecture is always the fullscreen region map
  let body;
  if (map.loading) {
    body = '<p class="vr-arch-empty">Reading architecture evidence…</p>';
  } else if (map.error) {
    body = '<p class="vr-arch-empty">' + escapeHtml(map.error) + '</p>';
  } else if (map.data) {
    if (!demo.archGraph) demo.archGraph = buildArchGraph(map.data, map.gaps || []);
    const graph = inspectorMap ? compactArchGraph(demo.archGraph) : demo.archGraph;
    const minWidth = inspectorMap ? 408 : 1120;
    const width = Math.max(minWidth, Math.max.apply(null, Object.values(graph.pos).map((p) => p.x)) + ARCH_NODE_W + 32);
    const height = Math.max(360, Math.max.apply(null, Object.values(graph.pos).map((p) => p.y)) + ARCH_NODE_H + 32);
    const edgesSvg = '<svg class="vr-arch-edges" width="' + width + '" height="' + height + '" viewBox="0 0 ' + width + ' ' + height + '">' +
      graph.edges.map((edge) => '<path data-arch-edge="' + escapeHtml(edge.from + ':' + edge.to) + '" d="' + archEdgePath(graph, edge) + '" />').join('') +
      '</svg>';
    const nodesHtml = graph.nodes.map((node) => {
      const p = graph.pos[node.id];
      if (node.kind === 'provider') {
        const mapProvider = providers.find((item) => item.id === node.providerId);
        if (mapProvider) {
          return '<div class="vr-arch-node is-provider is-card" data-arch-node="' + escapeHtml(node.id) + '" style="transform:translate(' + p.x + 'px,' + p.y + 'px)">' +
            TradingCard(mapProvider, 'map') +
            '</div>';
        }
      }
      const icon = node.kind === 'provider'
        ? '<span class="vr-arch-node-icon" data-provider-tone="' + escapeHtml(node.tone) + '">' + node.iconHtml + '</span>'
        : '<span class="vr-arch-node-icon is-core">' + Icon(node.icon) + '</span>';
      const action = node.kind === 'provider'
        ? ' data-provider="' + escapeHtml(node.providerId) + '"'
        : '';
      const ask = node.kind === 'core'
        ? '<button class="vr-arch-node-ask" type="button" data-action="arch-node-ask" data-node-label="' + escapeHtml(node.ask) + '" title="Ask agent about this boundary">' + Icon('agent') + '</button>'
        : '';
      const badge = node.gapCount
        ? '<span class="vr-arch-node-badge vr-stamp is-mini ' + (node.health === 'red' ? 'is-notyet' : 'is-review') + '" title="' + node.gapCount + ' open gap' + (node.gapCount === 1 ? '' : 's') + '">' + node.gapCount + ' &middot; ' + (node.health === 'red' ? 'NOT YET' : 'REVIEW') + '</span>'
        : '<span class="vr-arch-node-badge vr-stamp is-mini is-clear" title="Nothing flagged here">CLEAR</span>';
      return '<div class="vr-arch-node is-' + node.kind + (node.health ? ' has-health-' + escapeHtml(node.health) : '') + (demo.archDrawer === node.id ? ' is-selected' : '') + '" data-arch-node="' + escapeHtml(node.id) + '"' + action + ' style="transform:translate(' + p.x + 'px,' + p.y + 'px)">' +
        icon + '<div><strong>' + escapeHtml(node.label) + '</strong><em>' + escapeHtml(node.sub) + '</em></div>' + ask + badge +
        '</div>';
    }).join('');
    const zones = graph.zones || { modulesY: 0, providersY: 262 };
    const zonesHtml =
      '<span class="vr-arch-zone" style="left:16px;top:12px">App Flow</span>' +
      (zones.modulesY ? '<span class="vr-arch-zone" style="left:16px;top:' + (zones.modulesY - 20) + 'px">Modules</span>' : '') +
      '<span class="vr-arch-zone" style="left:16px;top:' + (zones.providersY - 24) + 'px">Providers</span>' +
      '<i class="vr-arch-divider" style="top:' + (zones.providersY - 30) + 'px"></i>' +
      '<span class="vr-arch-hint">Click a node to inspect · use zoom to scan · ✦ sends it to the agent</span>';
    if (!inspectorMap) {
      const fit = Math.max(1, Math.min(1.22, (window.innerWidth - 240) / width));
      demo.archFitBase = Math.round(fit * 100) / 100;
      if (!demo.archZoom) demo.archZoom = demo.archFitBase;
    }
    const zoom = demo.archZoom || 1;
    const zoomControls = '<div class="vr-arch-zoom">' +
      '<button type="button" data-action="arch-zoom" data-dir="out" aria-label="Zoom out">−</button>' +
      '<button type="button" data-action="arch-zoom" data-dir="reset">' + Math.round((zoom / (demo.archFitBase || 1)) * 100) + '%</button>' +
      '<button type="button" data-action="arch-zoom" data-dir="in" aria-label="Zoom in">+</button>' +
      '</div>';
    body = '<div class="vr-arch-viewport"><div class="vr-arch-canvas" style="min-width:' + width + 'px;min-height:' + height + 'px;transform:scale(' + zoom + ')">' + zonesHtml + edgesSvg + nodesHtml + '</div></div>' + zoomControls + ArchDrawer(map, graph);
  } else if (map.markdown) {
    body = renderAgentAnswerHtml(map.markdown, 0, null);
  } else {
    body = '<p class="vr-arch-empty">No architecture map yet. Run a scan and it is written automatically.</p>';
  }
  const territories = providers.filter((item) => item.state !== 'not_detected');
  const flawlessCount = territories.filter((item) => item.grade && item.grade.tier === 'flawless').length;
  const reviewCount = territories.filter((item) => item.grade && item.grade.tier === 'review').length;
  const unexplored = providers.length - territories.length;
  const territoryLine = territories.length + ' territories &middot; ' + flawlessCount + ' flawless &middot; ' + reviewCount + ' review' + (unexplored > 0 ? ' &middot; ' + unexplored + ' unexplored' : '');
  if (inspectorMap) {
    return '<section class="vr-studio-architecture is-inspector-map" aria-label="Architecture map">' +
      '<header><strong>Region Map</strong><span>' + territoryLine + '</span></header>' +
      '<div class="vr-arch-body ' + (map.data ? 'is-graph' : '') + '">' + body + '</div>' +
      '</section>';
  }
  return '<section class="vr-studio-architecture is-region-map" aria-label="Region map">' +
    '<header>' +
      '<strong>YOUR APP &middot; REGION MAP</strong>' +
      '<span>' + territoryLine + '</span>' +
      '<em class="vr-region-hint">CLICK A CARD &#8212; IT DEALS INTO CHAT &middot; ESC TO CLOSE</em>' +
      '<button class="vr-region-reset" type="button" data-action="arch-reset-layout" title="Reset the card layout">RESET LAYOUT</button>' +
      '<button class="vr-region-close" type="button" data-studio-tab="chat" aria-label="Close the map">' + Icon('x') + '</button>' +
    '</header>' +
    '<div class="vr-arch-body ' + (map.data ? 'is-graph' : '') + '">' + body + '</div>' +
    '</section>';
}

function loadArchitectureMap() {
  if (demo.architectureMap && (demo.architectureMap.markdown || demo.architectureMap.loading)) return;
  demo.architectureMap = { markdown: '', data: null, loading: true, error: '' };
  fetch('/api/architecture-map')
    .then(async (response) => {
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Architecture map not available.');
      demo.architectureMap = { markdown: String(data.markdown || ''), data: data.data || null, gaps: Array.isArray(data.gaps) ? data.gaps : [], loading: false, error: '' };
      demo.archGraph = null;
      render();
    })
    .catch((error) => {
      demo.architectureMap = { markdown: '', data: null, loading: false, error: error instanceof Error ? error.message : String(error) };
      render();
    });
}

function VersionTableCard(release, index) {
  const isCurrent = release.tone === 'current';
  const stamp = isCurrent
    ? '<span class="vr-stamp is-mini is-clear">PRODUCTION</span>'
    : release.tone === 'prod'
      ? '<span class="vr-stamp is-mini is-review">STABLE</span>'
      : '<span class="vr-stamp is-mini is-idle">HISTORY</span>';
  const rot = ((index % 3) - 1) * 1.6;
  return '<button class="vr-vcard' + (isCurrent ? ' is-current' : '') + '" type="button" draggable="true" data-release="' + escapeHtml(release.id) + '" style="--vr-rot:' + rot + 'deg" title="Deal ' + escapeHtml(release.label) + ' into chat — compare and changelog run instantly">' +
    '<span class="vr-vcard-top"><b>' + escapeHtml(release.label) + '</b></span>' +
    '<span class="vr-vcard-branch">' + escapeHtml(release.branch) + '</span>' +
    '<span class="vr-vcard-meta">' + escapeHtml(release.meta || '') + '</span>' +
    '<span class="vr-vcard-foot">' + stamp + '</span>' +
    '</button>';
}

function TableVersionsView() {
  return '<section class="vr-table-view" aria-label="Versions on the table">' +
    '<header class="vr-table-view-head">' +
      '<strong>VERSIONS &middot; THE TIMELINE</strong>' +
      '<span>' + String(releases.length) + ' release' + (releases.length === 1 ? '' : 's') + ' &mdash; click a card, what changed lands in chat</span>' +
      '<button class="vr-region-close" type="button" data-studio-tab="chat" aria-label="Back to the table">' + Icon('x') + '</button>' +
    '</header>' +
    '<div class="vr-version-spread">' + releases.map(VersionTableCard).join('') + '</div>' +
    '</section>';
}

function BranchTableCard(branch, index) {
  const drift = branch.current
    ? 'current branch'
    : ((branch.ahead ? branch.ahead + ' ahead' : '') + (branch.ahead && branch.behind ? ' &middot; ' : '') + (branch.behind ? branch.behind + ' behind' : '') || 'in sync');
  const rot = ((index % 3) - 1) * 1.4;
  return '<div class="vr-bcard' + (branch.current ? ' is-current' : '') + '" style="--vr-rot:' + rot + 'deg">' +
    '<b>' + escapeHtml(branch.name) + '</b>' +
    '<em>' + drift + (branch.when ? ' &middot; ' + escapeHtml(branch.when) : '') + '</em>' +
    '<span class="vr-bcard-actions">' +
      '<button type="button" data-action="worktree-review" data-branch="' + escapeHtml(branch.name) + '">REVIEW &#9656;</button>' +
      '<button type="button" data-action="worktree-diff" data-branch="' + escapeHtml(branch.name) + '">DIFF &#9656;</button>' +
    '</span>' +
    (branch.current ? '<span class="vr-stamp is-mini is-clear">YOU ARE HERE</span>' : '') +
    '</div>';
}

function TableWorktreeView() {
  const tree = demo.worktree || { branches: [], loading: true };
  const branches = Array.isArray(tree.branches) ? tree.branches : [];
  const dirty = Number(tree.dirtyCount) > 0
    ? '<div class="vr-table-warning"><span><strong>' + tree.dirtyCount + ' uncommitted change' + (tree.dirtyCount === 1 ? '' : 's') + '</strong> &mdash; commit or review before merging.</span><button type="button" data-action="worktree-commit">COMMIT &#9656;</button></div>'
    : '';
  return '<section class="vr-table-view" aria-label="Worktree on the table">' +
    '<header class="vr-table-view-head">' +
      '<strong>WORKTREE &middot; THE BRANCHES</strong>' +
      '<span>' + (tree.loading ? 'reading branches&hellip;' : String(branches.length) + ' branch' + (branches.length === 1 ? '' : 'es') + ' &mdash; ' + escapeHtml(tree.currentBranch || 'local')) + '</span>' +
      '<button class="vr-region-close" type="button" data-studio-tab="chat" aria-label="Back to the table">' + Icon('x') + '</button>' +
    '</header>' +
    dirty +
    '<div class="vr-branch-spread">' + (branches.length
      ? branches.slice(0, 12).map(BranchTableCard).join('')
      : '<p class="vr-table-empty">' + (tree.loading ? 'Reading branches&hellip;' : 'No branches detected.') + '</p>') + '</div>' +
    '</section>';
}

function TableBinderView() {
  const boardProviders = orderedProviders();
  return '<section class="vr-table-view" aria-label="Your cards on the table">' +
    '<header class="vr-table-view-head">' +
      '<strong>YOUR CARDS &middot; THE BINDER</strong>' +
      '<span>' + String(boardProviders.length) + ' cards &mdash; click one, its checks run in chat</span>' +
      '<button class="vr-region-close" type="button" data-studio-tab="chat" aria-label="Back to the table">' + Icon('x') + '</button>' +
    '</header>' +
    '<div class="vr-binder-spread">' + boardProviders.map((provider) => TradingCard(provider, 'dealt')).join('') + '</div>' +
    '<footer class="vr-table-foot"><button type="button" data-action="add-provider">' + Icon('plus') + ' ADD PROVIDER</button></footer>' +
    '</section>';
}

function StudioDock() {
  return '<section class="vr-studio-dock ' + (demo.agentFixing ? 'is-running' : '') + (demo.verified ? ' is-verified' : '') + '" aria-label="VibeRaven Studio agent workspace">' +
    '<div class="vr-studio-head">' +
      '<div class="vr-studio-head-status">' + TablePlaque() + '</div>' +
      (demo.activeStudioTab === 'chat' && demo.activeChatCount === 1 ? '<div class="vr-studio-head-cli">' + CliConnectPanel(0) + '</div>' : '') +
      '<div class="vr-studio-head-actions"><div class="vr-studio-tabs">' + StudioTabButton('chat', 'Chat') + StudioTabButton('architecture', 'Architecture') + StudioTabButton('terminal', 'Terminal') + StudioTabButton('diff', 'Diff') + '</div></div>' +
    '</div>' +
    '<div class="vr-studio-body">' + (
      demo.activeStudioTab === 'architecture' ? StudioArchitectureView()
        : demo.activeStudioTab === 'versions' ? TableVersionsView()
          : demo.activeStudioTab === 'worktree' ? TableWorktreeView()
            : demo.activeStudioTab === 'providers' ? TableBinderView()
              : StudioChatView()
    ) + '</div>' +
    '</section>';
}

function InspectorProviderView() {
  const boardProviders = orderedProviders();
  const activeCount = boardProviders.filter((provider) => provider.state !== 'not_detected').length;
  return '<section class="vr-inspector-card vr-provider-inspector">' +
    '<header class="vr-inspector-hero">' +
      '<div><p>Provider Control</p><h3>The Deck</h3><em>' + String(activeCount || boardProviders.length) + ' cards — click one, its checks run in chat.</em></div>' +
      '<img src="' + mascotAssets.verified + '" alt="" />' +
    '</header>' +
    '<div class="vr-inspector-provider-grid vr-binder">' + boardProviders.map((provider) => TradingCard(provider, 'hand')).join('') + '</div>' +
    '<footer class="vr-inspector-footer"><button type="button" data-action="add-provider">' + Icon('plus') + 'Add provider</button><button type="button" data-action="provider-proof">' + Icon('agent') + 'Ask agent</button></footer>' +
  '</section>';
}

function InspectorVersionsView() {
  const selected = releases.find((item) => item.id === demo.selectedReleaseId) || releases[0];
  const pair = releaseComparePair();
  const entries = Array.isArray(demo.releaseChangelog?.entries) ? demo.releaseChangelog.entries.slice(0, 8) : [];
  const changelog = demo.releaseChangelog?.loading
    ? '<p class="vr-inspector-empty">Loading changelog...</p>'
    : demo.releaseChangelog?.error
      ? '<p class="vr-release-error">' + escapeHtml(demo.releaseChangelog.error) + '</p>'
      : entries.length
        ? '<div class="vr-inspector-changelog">' + entries.map((entry) =>
          '<button type="button" data-action="diff-to-chat"><strong>' + escapeHtml(entry.short || entry.sha || '') + '</strong><span>' + escapeHtml(entry.subject || '') + '</span><em>' + escapeHtml((entry.author || 'unknown') + ' · ' + (entry.when || '')) + '</em></button>'
        ).join('') + '</div>'
        : '<p class="vr-inspector-empty">Open changelog to load commits between ' + escapeHtml(pair.fromLabel) + ' and ' + escapeHtml(pair.toLabel) + '.</p>';
  return '<section class="vr-inspector-card vr-version-inspector">' +
    '<header class="vr-inspector-hero">' +
      '<div><p>Version Control</p><h3>' + escapeHtml(selected.label) + '</h3><em>' + escapeHtml(selected.meta + ' · ' + selected.branch) + '</em></div>' +
      '<img src="' + mascotAssets.idle + '" alt="" />' +
    '</header>' +
    '<button class="vr-inspector-compare" type="button" data-action="compare">' + Icon('refresh') + '<span>Compare release</span><strong>' + escapeHtml(pair.fromLabel) + ' → ' + escapeHtml(pair.toLabel) + '</strong></button>' +
    '<section class="vr-inspector-section"><header><strong>Recent versions</strong><button type="button" data-action="changelog">Load changelog</button></header>' +
      '<div class="vr-inspector-release-list">' + releases.slice(0, 5).map((release) =>
        '<button class="' + (release.id === selected.id ? 'is-selected' : '') + '" type="button" draggable="true" data-release="' + escapeHtml(release.id) + '">' +
          '<span><strong>' + escapeHtml(release.label) + '</strong><em>' + escapeHtml(release.summary || release.meta) + '</em></span><small>' + escapeHtml(release.branch) + '</small>' +
        '</button>'
      ).join('') + '</div>' +
    '</section>' +
    '<section class="vr-inspector-section"><header><strong>Changelog</strong><button type="button" data-action="ask-release-agent" data-release="' + escapeHtml(selected.id) + '">Ask agent</button></header>' + changelog + '</section>' +
    '<footer class="vr-inspector-footer"><button type="button" data-action="show-release-diff">' + Icon('code') + 'View diff</button><button type="button" data-action="rollback-release">' + Icon('refresh') + 'Rollback</button></footer>' +
  '</section>';
}

function InspectorWorktreeView() {
  const tree = demo.worktree || { branches: [], loading: true };
  const defaultBranch = tree.defaultBranch || 'main';
  const branches = Array.isArray(tree.branches) ? tree.branches : [];
  return '<section class="vr-inspector-card vr-worktree-inspector">' +
    '<header class="vr-inspector-hero">' +
      '<div><p>Worktree</p><h3>' + escapeHtml(tree.currentBranch || defaultBranch) + '</h3><em>' + (tree.loading ? 'Reading branches...' : String(branches.length || 0) + ' branches detected') + '</em></div>' +
      '<img src="' + mascotAssets.idle + '" alt="" />' +
    '</header>' +
    (tree.dirtyCount > 0 ? '<section class="vr-inspector-warning"><i></i><span><strong>' + tree.dirtyCount + ' uncommitted change' + (tree.dirtyCount === 1 ? '' : 's') + '</strong><em>Commit or review before merging.</em></span><button type="button" data-action="worktree-commit">Commit</button></section>' : '') +
    '<section class="vr-inspector-section"><header><strong>Branches</strong><button type="button" data-action="worktree-review" data-branch="' + escapeHtml(defaultBranch) + '">Health report</button></header>' +
      '<div class="vr-inspector-branch-list">' + (branches.length ? branches.slice(0, 8).map((branch) => {
        const drift = branch.current ? 'current' : ((branch.ahead ? branch.ahead + ' ahead' : '') + (branch.ahead && branch.behind ? ' · ' : '') + (branch.behind ? branch.behind + ' behind' : '') || 'in sync');
        return '<div class="' + (branch.current ? 'is-current' : '') + '"><span><strong>' + escapeHtml(branch.name) + '</strong><em>' + escapeHtml(drift + (branch.when ? ' · ' + branch.when : '')) + '</em></span><div><button type="button" data-action="worktree-review" data-branch="' + escapeHtml(branch.name) + '">Review</button><button type="button" data-action="worktree-diff" data-branch="' + escapeHtml(branch.name) + '">Diff</button></div></div>';
      }).join('') : '<p class="vr-inspector-empty">' + (tree.loading ? 'Reading branches...' : 'No branches detected.') + '</p>') + '</div>' +
    '</section>' +
  '</section>';
}

function StudioInspectorPanel() {
  if (demo.activeStudioTab !== 'terminal' && demo.activeStudioTab !== 'diff') return '';
  const labels = {
    architecture: ['Region Map', 'Repo structure and provider boundaries'],
    providers: ['Your Cards', 'Provider cards and MCP context'],
    versions: ['Versions', 'Release comparison and changelog'],
    worktree: ['Worktree', 'Branches and local changes'],
    terminal: ['Terminal', 'Connect and test local CLIs'],
    diff: ['Diff', 'Release and code changes'],
  };
  const label = labels[demo.activeStudioTab] || ['Inspector', 'Context panel'];
  const view = demo.activeStudioTab === 'terminal'
    ? StudioTerminalView()
    : demo.activeStudioTab === 'diff'
      ? StudioDiffView()
      : demo.activeStudioTab === 'providers'
        ? InspectorProviderView()
        : demo.activeStudioTab === 'versions'
          ? InspectorVersionsView()
          : demo.activeStudioTab === 'worktree'
            ? InspectorWorktreeView()
            : StudioArchitectureView();
  return '<aside class="vr-inspector-panel ' + (demo.inspectorExpanded ? 'is-expanded' : '') + '" aria-label="' + escapeHtml(label[0]) + '">' +
    '<header class="vr-inspector-head"><div><strong>' + escapeHtml(label[0]) + '</strong><span>' + escapeHtml(label[1]) + '</span></div><button type="button" data-action="toggle-inspector-size" aria-label="' + (demo.inspectorExpanded ? 'Shrink inspector' : 'Expand inspector') + '">' + Icon(demo.inspectorExpanded ? 'collapse' : 'expand') + '</button><button type="button" data-studio-tab="chat" aria-label="Close inspector">' + Icon('x') + '</button></header>' +
    '<div class="vr-inspector-body">' + view + '</div>' +
    '</aside>';
}

function QuickActionRow(action) {
  return '<button class="vr-quick-action" type="button" data-action="' + escapeHtml(action.id) + '">' + Icon(action.icon) + '<span><strong>' + escapeHtml(action.title) + '</strong><em>' + escapeHtml(action.caption) + '</em></span></button>';
}

function loadWorktree() {
  if (demo.worktree && (demo.worktree.loading || demo.worktree.loaded)) return;
  demo.worktree = { loading: true, loaded: false, branches: [], currentBranch: '', defaultBranch: '' };
  fetch('/api/worktree')
    .then(async (response) => {
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'worktree unavailable');
      demo.worktree = { loading: false, loaded: true, branches: data.branches || [], currentBranch: data.currentBranch || '', defaultBranch: data.defaultBranch || '', dirtyCount: Number(data.dirtyCount) || 0 };
      render();
    })
    .catch(() => {
      demo.worktree = { loading: false, loaded: true, branches: [], currentBranch: '', defaultBranch: '' };
      render();
    });
}

function runBranchDiff(branchName) {
  const tree = demo.worktree || {};
  const fromRef = tree.defaultBranch || 'main';
  if (!branchName || branchName === fromRef) {
    demo.notice = branchName === fromRef ? branchName + ' is the default branch — pick another branch to compare.' : 'No branch selected.';
    render();
    return;
  }
  demo.releaseDiff = { text: '', from: fromRef, to: branchName, fromLabel: fromRef, toLabel: branchName, stats: null, loading: true, error: '' };
  demo.activeStudioTab = 'diff';
  demo.activeModal = null;
  render();
  fetch('/api/releases/compare?from=' + encodeURIComponent(fromRef) + '&to=' + encodeURIComponent(branchName))
    .then(async (response) => {
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Compare failed');
      demo.releaseDiff = { text: data.text || '', from: fromRef, to: branchName, fromLabel: fromRef, toLabel: branchName, stats: data.stats || null, loading: false, error: '' };
      render();
    })
    .catch((error) => {
      demo.releaseDiff = { text: '', from: fromRef, to: branchName, fromLabel: fromRef, toLabel: branchName, stats: null, loading: false, error: error instanceof Error ? error.message : String(error) };
      render();
    });
}

function WorktreeModal() {
  const tree = demo.worktree || { branches: [], loading: true };
  const defaultBranch = tree.defaultBranch || 'main';
  const trunk = (tree.branches || []).find((branch) => branch.name === defaultBranch);
  const limbs = (tree.branches || []).filter((branch) => branch.name !== defaultBranch);
  const dirtyBlock = tree.dirtyCount > 0
    ? '<section class="vr-wt-dirty"><i></i><div><strong>' + tree.dirtyCount + ' uncommitted change' + (tree.dirtyCount === 1 ? '' : 's') + '</strong><em>on ' + escapeHtml(tree.currentBranch || 'this branch') + ' — commit before merging or switching</em></div>' +
      '<button type="button" data-action="worktree-commit">' + Icon('bolt') + 'Commit with agent</button></section>'
    : '';
  const rowH = 104;
  const branchX = 300;
  const cardW = 470;
  const canvasH = Math.max(200, limbs.length * rowH + 32);
  const canvasW = branchX + cardW + 24;
  const trunkY = Math.max(16, canvasH / 2 - 34);
  const edgePaths = limbs.map((branch, index) => {
    const x1 = 16 + 190;
    const y1 = trunkY + 34;
    const x2 = branchX;
    const y2 = 16 + index * rowH + 40;
    const mx = (x1 + x2) / 2;
    return '<path d="M' + x1 + ' ' + y1 + ' C' + mx + ' ' + y1 + ' ' + mx + ' ' + y2 + ' ' + x2 + ' ' + y2 + '"' + (branch.current ? ' class="is-current"' : '') + ' />';
  }).join('');
  const trunkNode = '<div class="vr-wt-cnode is-trunk" style="transform:translate(16px,' + trunkY + 'px)">' +
    '<span class="vr-wt-dot"></span>' +
    '<div><strong>' + escapeHtml(defaultBranch) + '</strong><em>' + escapeHtml(trunk && trunk.when ? 'trunk · ' + trunk.when : 'the branch you ship from') + '</em></div>' +
    '<button type="button" data-action="worktree-review" data-branch="' + escapeHtml(defaultBranch) + '" title="Plain-language health report">' + Icon('agent') + '</button>' +
    '</div>';
  const limbNodes = limbs.map((branch, index) => {
    const drift = ((branch.ahead ? branch.ahead + ' ahead' : '') + (branch.ahead && branch.behind ? ' · ' : '') + (branch.behind ? branch.behind + ' behind' : '')) || 'in sync';
    return '<div class="vr-wt-cnode is-branch' + (branch.current ? ' is-current' : '') + '" style="transform:translate(' + branchX + 'px,' + (16 + index * rowH) + 'px)">' +
      '<span class="vr-wt-dot"></span>' +
      '<div><strong>' + escapeHtml(branch.name) + (branch.current ? ' <b>current</b>' : '') + '</strong>' +
        '<em>' + escapeHtml(drift + (branch.when ? ' · ' + branch.when : '')) + '</em>' +
        (branch.subject ? '<em class="vr-wt-subject">' + escapeHtml(branch.subject) + '</em>' : '') + '</div>' +
      '<div class="vr-wt-actions">' +
        '<button type="button" data-action="worktree-review" data-branch="' + escapeHtml(branch.name) + '">' + Icon('agent') + 'Review</button>' +
        '<button type="button" data-action="worktree-diff" data-branch="' + escapeHtml(branch.name) + '">' + Icon('code') + 'Diff</button>' +
        (branch.current ? '' : '<button class="is-primary" type="button" data-action="worktree-branch" data-branch="' + escapeHtml(branch.name) + '" data-current="0">' + Icon('branch') + 'Merge</button>') +
      '</div>' +
      '</div>';
  }).join('');
  return ModalShell('worktree',
    '<header class="vr-modal-provider-head">' +
      '<span class="vr-modal-provider-orb" data-provider-tone="neutral">' + Icon('branch') + '</span>' +
      '<div><h2>Worktree</h2>' + StatusBadge(tree.dirtyCount > 0 ? String(tree.dirtyCount) + ' uncommitted' : 'Clean', tree.dirtyCount > 0 ? 'orange' : 'green') + '<p>Branches & merges</p></div>' +
      '<img class="vr-modal-mascot" src="' + mascotAssets.idle + '" alt="" />' +
    '</header>' +
    dirtyBlock +
    '<section class="vr-wt-canvas" style="height:' + canvasH + 'px;min-width:' + canvasW + 'px">' +
      '<svg class="vr-wt-edges" width="' + canvasW + '" height="' + canvasH + '" viewBox="0 0 ' + canvasW + ' ' + canvasH + '">' + edgePaths + '</svg>' +
      trunkNode +
      (limbNodes || '') +
    '</section>' +
    '<p class="vr-modal-footnote">Review sends a plain-language branch summary to the agent chat. Merge asks the agent to merge safely — nothing is pushed without you.</p>'
  );
}

function WorktreeSection() {
  const tree = demo.worktree || { branches: [], loading: true };
  const dirtyRow = tree.dirtyCount > 0
    ? '<button class="vr-branch-row is-dirty" type="button" data-action="worktree-commit" title="Group and commit with the agent">' +
        '<i></i><span><strong>' + tree.dirtyCount + ' uncommitted change' + (tree.dirtyCount === 1 ? '' : 's') + '</strong><em>on ' + escapeHtml(tree.currentBranch || 'this branch') + '</em></span><b>Commit</b>' +
      '</button>'
    : '';
  const rows = (tree.branches || []).slice(0, 5).map((branch) => {
    const drift = branch.current ? '' : ((branch.ahead ? branch.ahead + '↑ ' : '') + (branch.behind ? branch.behind + '↓ ' : ''));
    const meta = (drift + (branch.when || '')).trim();
    return '<div class="vr-branch-row' + (branch.current ? ' is-current' : '') + '">' +
      '<i></i>' +
      '<button class="vr-branch-open" type="button" data-action="open-worktree" title="Open the worktree">' +
        '<strong>' + escapeHtml(branch.name) + '</strong><em>' + escapeHtml(meta) + '</em>' +
      '</button>' +
      (branch.current
        ? '<b class="is-current">current</b>'
        : '<button class="vr-branch-merge" type="button" data-action="worktree-branch" data-branch="' + escapeHtml(branch.name) + '" data-current="0">Merge</button>') +
    '</div>';
  }).join('');
  return '<section class="vr-agent-worktree"><h3>Worktree</h3>' + dirtyRow +
    (rows || '<p class="vr-signal-empty">' + (tree.loading ? 'Reading branches…' : 'No git branches detected.') + '</p>') +
    '</section>';
}

function AgentActionPanel() {
  const fixing = demo.agentFixing;
  const verified = demo.verified;
  const gate = (currentState && currentState.gate) || {};
  const gateClear = gate.status === 'clear';
  const cards = missionCards || { blockers: [], connectProviders: [] };
  const blockers = Array.isArray(cards.blockers) ? cards.blockers.slice(0, 3) : [];
  const connects = Array.isArray(cards.connectProviders) ? cards.connectProviders.slice(0, 2) : [];
  const signalRows = blockers.map((blocker) =>
    '<button class="vr-signal-row" type="button" data-action="start-agent-fix" data-chat-index="0" title="' + escapeHtml(blocker.title || '') + '">' +
      '<i class="is-' + (String(blocker.severity || '').toLowerCase() === 'critical' ? 'blocker' : 'warn') + '"></i>' +
      '<span><strong>' + escapeHtml(truncateMissionLabel(blocker.title || 'Repo fix', 42)) + '</strong><em>' + escapeHtml(blocker.severity || 'warning') + '</em></span>' +
      '<b>Fix</b>' +
    '</button>'
  ).join('') + connects.map((item) =>
    '<button class="vr-signal-row" type="button" data-provider="' + escapeHtml(item.id || '') + '" title="Open ' + escapeHtml(item.name || 'provider') + '">' +
      '<i class="is-info"></i>' +
      '<span><strong>Connect ' + escapeHtml(item.name || 'provider') + '</strong><em>' + escapeHtml(item.status || 'provider setup') + '</em></span>' +
      '<b>Open</b>' +
    '</button>'
  ).join('');
  const signals = signalRows ||
    '<p class="vr-signal-empty">' + (gateClear ? 'Gate clear. No blockers from the last scan.' : 'Run a verify mission to load launch signals.') + '</p>';
  return '<aside class="vr-agent-panel" aria-label="VibeRaven AI Agent panel">' +
    '<div class="vr-agent-control">' +
      '<section class="vr-agent-hero ' + (fixing ? 'is-fixing' : '') + (verified ? ' is-verified' : '') + '">' +
        '<div><p>VibeRaven Agent</p><h2>' + (verified ? 'Ready with proof' : fixing ? 'Fixing what changed' : gateClear ? 'Gate clear' : 'Ready') + '</h2><em>' + (verified ? 'High confidence. Safe to proceed.' : fixing ? 'Patching proof now.' : gateClear ? 'Everything evidenced. Ship when you are.' : (blockers.length ? String(blockers.length) + ' blocker' + (blockers.length === 1 ? '' : 's') + ' between you and launch.' : 'High confidence. Safe to proceed.')) + '</em></div>' +
        '<img src="' + mascotUrl() + '" alt="" />' +
      '</section>' +
      '<section class="vr-agent-signals"><h3>Launch Signals</h3>' + signals + '</section>' +
      WorktreeSection() +
      GlowButton(fixing ? 'Applying...' : 'Open Worktree', { id: 'vr-chat-agent-fix', action: 'open-worktree', tone: verified ? 'green' : 'purple' }) +
    '</div>' +
    '</aside>';
}

function BottomTipBar() {
  const message = demo.notice || 'Connect all providers to unlock full verification and faster launches.';
  return '<footer class="vr-bottom-tip-bar"><span class="vr-tip-mascot"><img src="' + mascotAssets.idle + '" alt="" /></span><span><b>Tip:</b> ' + escapeHtml(message) + '</span><nav><a href="' + docsUrl + '" target="_blank" rel="noreferrer">Docs</a><a href="' + communityUrl + '" target="_blank" rel="noreferrer">Community</a><a class="vr-bottom-github" href="' + publicGithubUrl + '" target="_blank" rel="noreferrer">' + BrandMark('github') + 'GitHub</a></nav></footer>';
}

function LaunchFlowPage() {
  return StudioDock();
}

function TableRail() {
  const tabs = [
    ['chat', 'spark', 'Chat — the table'],
    ['architecture', 'branch', 'Region map'],
    ['providers', 'cube', 'Your cards'],
    ['versions', 'clock', 'Versions'],
    ['worktree', 'repo', 'Worktree'],
  ];
  return '<aside class="vr-left-context-rail is-table-rail" aria-label="Studio navigation">' +
    '<span class="vr-rail-raven is-emblem" title="VibeRaven"><img src="/manga/emblem.png" alt="VibeRaven" /></span>' +
    '<button class="vr-rail-icon is-new" type="button" data-action="new-chat" title="New chat">' + Icon('plus') + '</button>' +
    '<button class="vr-rail-icon' + (demo.chatsFlyoutOpen ? ' is-active' : '') + '" type="button" data-action="toggle-chats-flyout" title="Recent chats">' + Icon('prompt') + '</button>' +
    '<span class="vr-rail-sep" aria-hidden="true"></span>' +
    tabs.map(([id, icon, label]) =>
      '<button class="vr-rail-icon' + (demo.activeStudioTab === id && !demo.chatsFlyoutOpen ? ' is-active' : '') + '" type="button" data-studio-tab="' + id + '" title="' + label + '">' + Icon(icon) + '</button>'
    ).join('') +
    (demo.chatsFlyoutOpen ? '<div class="vr-chats-flyout">' + RecentChatRail() + '</div>' : '') +
    '</aside>';
}

function VibeShell() {
  const inspectorOpen = demo.activeStudioTab === 'terminal' || demo.activeStudioTab === 'diff';
  return '<main class="vr-composed-shell is-fullscreen-table">' +
      '<div class="vr-composition-body is-table ' + (inspectorOpen ? 'has-inspector' : '') + (demo.inspectorExpanded ? ' inspector-expanded' : '') + '">' +
        TableRail() +
        '<section class="vr-main-canvas">' + LaunchFlowPage() + '</section>' +
        StudioInspectorPanel() +
      '</div>' +
      BottomTipBar() +
    '</main>' +
    ActiveModal();
}

function captureChatScroll(node) {
  const lane = node.closest('.vr-chat-lane');
  const index = lane ? lane.getAttribute('data-chat-index') : node.getAttribute('data-chat-transcript');
  if (!index) return;
  chatScrollCache[index] = {
    top: node.scrollTop,
    nearBottom: node.scrollHeight - node.scrollTop - node.clientHeight < 56
  };
}

function readChatScrollState() {
  app.querySelectorAll('.vr-chat-transcript').forEach((node) => captureChatScroll(node));
  const state = {};
  Object.keys(chatScrollCache).forEach((key) => {
    state[key] = { ...chatScrollCache[key] };
  });
  return state;
}

function restoreChatScrollState(state, options) {
  const opts = options || {};
  const apply = () => {
    app.querySelectorAll('.vr-chat-transcript').forEach((node) => {
      const lane = node.closest('.vr-chat-lane');
      const index = lane ? lane.getAttribute('data-chat-index') : node.getAttribute('data-chat-transcript');
      if (!index) return;
      const saved = state[index] || chatScrollCache[index];
      const scrollToBottom = opts.scrollToBottom === true || opts.scrollToBottom === Number(index) || opts.scrollToBottom === index;
      if (scrollToBottom || (saved && saved.nearBottom)) {
        node.scrollTop = node.scrollHeight;
        captureChatScroll(node);
      } else if (saved) {
        node.scrollTop = saved.top;
        captureChatScroll(node);
      }
    });
  };
  window.requestAnimationFrame(() => {
    apply();
    window.requestAnimationFrame(apply);
  });
}

function refreshBottomTip() {
  const tipSpan = app.querySelector('.vr-bottom-tip-bar > span:nth-child(2)');
  if (!tipSpan) return;
  const message = demo.notice || 'Connect all providers to unlock full verification and faster launches.';
  tipSpan.innerHTML = '<b>Tip:</b> ' + escapeHtml(message);
}

function refreshPickerMenus() {
  app.querySelectorAll('.vr-chat-lane').forEach((lane) => {
    const index = Number(lane.getAttribute('data-chat-index') || '0');
    const picker = lane.querySelector('.vr-model-picker');
    if (!picker) return;
    const wrapper = document.createElement('div');
    wrapper.innerHTML = ModelPicker(index);
    const nextPicker = wrapper.firstElementChild;
    if (nextPicker) picker.replaceWith(nextPicker);
  });
}

function closeComposerPopovers() {
  demo.quickActionsOpen = false;
  demo.contextTrayOpen = false;
  demo.scopeMenuOpen = false;
  demo.modelMenuOpen = false;
  demo.reasoningMenuOpen = false;
  demo.contextMenuOpen = false;
  demo.accessMenuOpen = false;
  demo.dropActive = false;
}

// anime.js entrance for the region map: stagger the nodes in when the view opens.
// The nodes are positioned with inline transform:translate(x,y), so we animate
// OPACITY ONLY (never transform) and clear the inline value on complete. Gated by
// a flag that resets when the view leaves, so it plays once per open, not on every
// full re-render.
let regionMapAnimated = false;
function animateRegionMapOnce() {
  const nodes = app.querySelectorAll('.vr-studio-architecture.is-region-map .vr-arch-node');
  if (!nodes.length) { regionMapAnimated = false; return; }
  if (regionMapAnimated || !window.anime || typeof window.anime.animate !== 'function') return;
  regionMapAnimated = true;
  const clear = () => nodes.forEach((n) => { n.style.opacity = ''; });
  try {
    window.anime.animate(nodes, {
      opacity: [0, 1],
      duration: 460,
      delay: window.anime.stagger(34),
      ease: 'out(2)',
      onComplete: clear,
    });
  } catch (err) { clear(); }
}

// Release timeline (Versions view): stagger the version cards in when it opens.
// The cards carry a --vr-rot rotation transform, so we animate OPACITY ONLY
// (translate/scale would clobber the rotation) and clear it on complete. Gated
// once per open like the region map.
let releaseTimelineAnimated = false;
function animateReleaseTimelineOnce() {
  const spread = app.querySelector('.vr-version-spread');
  if (!spread) { releaseTimelineAnimated = false; return; }
  if (releaseTimelineAnimated || !window.anime || typeof window.anime.animate !== 'function') return;
  const cards = app.querySelectorAll('.vr-version-spread .vr-vcard');
  if (!cards.length) return;
  releaseTimelineAnimated = true;
  const clear = () => cards.forEach((c) => { c.style.opacity = ''; });
  try {
    window.anime.animate(cards, {
      opacity: [0, 1],
      duration: 440,
      delay: window.anime.stagger(50),
      ease: 'out(2)',
      onComplete: clear,
    });
  } catch (err) { clear(); }
}

// Chat view: stagger the existing message rows in when the chat first shows, so
// there is visible motion on the default view (opening / refreshing / switching
// to chat). Story nodes have no positioning transform, so translateY is safe;
// cleared on complete. Gated once per chat-view open (a new deal animates its own
// card separately). Reset when leaving chat or when the transcript is empty.
let chatEntranceAnimated = false;
function animateChatEntranceOnce() {
  if (demo.activeStudioTab !== 'chat') { chatEntranceAnimated = false; return; }
  const nodes = app.querySelectorAll('.vr-chat-transcript .vr-story-node');
  if (!nodes.length) { chatEntranceAnimated = false; return; }
  if (chatEntranceAnimated || !window.anime || typeof window.anime.animate !== 'function') return;
  chatEntranceAnimated = true;
  const clear = () => nodes.forEach((n) => { n.style.opacity = ''; n.style.transform = ''; });
  try {
    window.anime.animate(nodes, {
      opacity: [0, 1],
      translateY: [14, 0],
      duration: 440,
      delay: window.anime.stagger(60),
      ease: 'out(2)',
      onComplete: clear,
    });
  } catch (err) { clear(); }
}

// Card dealt into chat: fade + scale + lift the newest provider-card message in.
// Called only from dealProviderCard (not the generic render) so it plays once on
// deal, not on the later check-complete re-render.
function animateDealtCardIntoChat() {
  if (!window.anime || typeof window.anime.animate !== 'function') return;
  const cards = app.querySelectorAll('.vr-card-message');
  const el = cards[cards.length - 1];
  if (!el) return;
  const clear = () => {
    el.style.opacity = '';
    el.style.transform = '';
    el.style.scale = '';
    el.style.rotate = '';
    el.style.translate = '';
    el.style.transformOrigin = '';
  };
  try {
    el.style.transformOrigin = '18% 60%';
    window.anime.animate(el, {
      opacity: [0, 1],
      scale: [0.55, 1],
      translateY: [46, 0],
      translateX: [-30, 0],
      rotate: [-7, 0],
      duration: 720,
      ease: 'out(3)',
      onComplete: clear,
    });
  } catch (err) { clear(); }
}

function render(options) {
  const opts = options || {};
  const scrollState = opts.preserveScroll === false ? null : readChatScrollState();
  stableModalRender = Boolean(demo.activeModal && demo.activeModal === lastRenderedModal);
  app.innerHTML = VibeShell();
  window.requestAnimationFrame(() => {
    animateRegionMapOnce();
    animateReleaseTimelineOnce();
    animateChatEntranceOnce();
    if (opts.scrollToBottom != null) {
      restoreChatScrollState({}, { scrollToBottom: opts.scrollToBottom });
    } else if (scrollState) {
      restoreChatScrollState(scrollState, {});
    }
    if (demo.activeModal && demo.activeModal !== lastRenderedModal) {
      const closeButton = app.querySelector('.vr-modal-close');
      if (closeButton) closeButton.focus({ preventScroll: true });
    }
    if (demo.activeStudioTab === 'terminal') {
      const shellInput = app.querySelector('[data-terminal-shell-input]');
      const scroll = app.querySelector('[data-terminal-scroll]');
      if (scroll) scroll.scrollTop = scroll.scrollHeight;
      if (shellInput && !demo.activeModal) shellInput.focus({ preventScroll: true });
    }
  });
  lastRenderedModal = demo.activeModal;
}

async function loadGithubStats() {
  if (githubStats.loading || githubStats.loaded) return;
  githubStats.loading = true;
  try {
    const response = await fetch(publicGithubApiUrl, { headers: { accept: 'application/vnd.github+json' } });
    if (!response.ok) throw new Error('GitHub stats request failed');
    const data = await response.json();
    githubStats.stars = Number(data.stargazers_count) || 0;
    githubStats.forks = Number(data.forks_count) || 0;
    githubStats.issues = Number(data.open_issues_count) || 0;
    githubStats.loaded = true;
  } catch {
    githubStats.error = true;
  } finally {
    githubStats.loading = false;
    render();
  }
}

app.addEventListener('click', async (event) => {
  const recentChatButton = event.target.closest('[data-chat-id]');
  if (recentChatButton) {
    demo.chatsFlyoutOpen = false;
    const chatId = recentChatButton.getAttribute('data-chat-id');
    const recent = recentChats.find((chat) => chat.id === chatId);
    demo.activeRecentChatId = chatId;
    demo.activeChatCount = 1;
    demo.chatContexts = [restoreRecentChat(recent)];
    syncDemoFromChatContext(demo.chatContexts[0]);
    demo.pickerChatIndex = 0;
    demo.activeStudioTab = 'chat';
    demo.agentFixing = false;
    demo.verified = false;
    demo.notice = recent ? recent.title + ' loaded with saved context.' : 'Recent production chat loaded into the mission workspace.';
    render();
    return;
  }

  const studioTab = event.target.closest('[data-studio-tab]');
  if (studioTab) {
    demo.activeStudioTab = studioTab.getAttribute('data-studio-tab');
    demo.activeNavId = 'agents';
    if (demo.activeStudioTab === 'terminal' && !demo.cliTerminalLines.length) {
        demo.cliTerminalLines = [
          'VibeRaven Studio shell',
          'Type commands at the $ prompt. Use Test connection after sign-in.',
          ''
        ];
      }
    if (demo.activeStudioTab === 'architecture') {
      demo.archVisited = true;
      loadArchitectureMap();
    }
    if (demo.activeStudioTab === 'worktree') {
      loadWorktree();
    }
    if (demo.activeStudioTab === 'versions') {
      runReleaseChangelog(false);
      return;
    }
    demo.notice = 'Studio switched to ' + studioTab.textContent.trim() + '.';
    render();
    return;
  }

  const copyCodeButton = event.target.closest('[data-action="copy-code"]');
  if (copyCodeButton) {
    const wrap = copyCodeButton.closest('.vr-agent-code-wrap');
    const code = wrap ? wrap.querySelector('code') : null;
    const copied = await copyText(code ? code.textContent || '' : '');
    if (copied) {
      copyCodeButton.classList.add('is-copied');
      window.setTimeout(() => copyCodeButton.classList.remove('is-copied'), 1200);
    }
    return;
  }

  const askProviderButton = event.target.closest('[data-action="ask-provider-agent"]');
  if (askProviderButton) {
    const providerId = askProviderButton.getAttribute('data-provider');
    const provider = providers.find((item) => item.id === providerId);
    const chat = chatContext(0);
    if (providerId) chat.providerId = providerId;
    if (provider && !String(chat.draft || '').trim()) {
      chat.draft = 'Check ' + provider.name + ' (' + provider.area + '): what is proven from repo evidence, what still needs dashboard or MCP proof, and what is the one next fix?';
    }
    demo.pickerChatIndex = 0;
    demo.activeModal = null;
    demo.activeStudioTab = 'chat';
    demo.notice = provider ? provider.name + ' context attached to the mission chat. Review the prompt and send.' : 'Provider context attached to the mission chat.';
    render();
    const chatInput = app.querySelector('[data-chat-input="0"]');
    if (chatInput && typeof chatInput.focus === 'function') chatInput.focus();
    return;
  }

  const archZoomButton = event.target.closest('[data-action="arch-zoom"]');
  if (archZoomButton) {
    const dir = archZoomButton.getAttribute('data-dir');
    const current = demo.archZoom || 1;
    demo.archZoom = dir === 'in' ? Math.min(2.2, current + 0.15) : dir === 'out' ? Math.max(0.5, current - 0.15) : (demo.archFitBase || 1);
    render();
    return;
  }

  const archResetButton = event.target.closest('[data-action="arch-reset-layout"]');
  if (archResetButton) {
    try { window.localStorage.removeItem('vrArchLayout'); } catch { /* ignore */ }
    demo.archGraph = null;
    demo.archZoom = 0;
    demo.notice = 'Architecture layout reset.';
    render();
    return;
  }

  const archDrawerCloseButton = event.target.closest('[data-action="arch-drawer-close"]');
  if (archDrawerCloseButton) {
    demo.archDrawer = null;
    render();
    return;
  }

  const archCopyPathsButton = event.target.closest('[data-action="arch-copy-paths"]');
  if (archCopyPathsButton) {
    const info = archDrawerItems(demo.architectureMap || {}, archCopyPathsButton.getAttribute('data-node'));
    const copied = await copyText(info && info.items.length ? info.items.join('\\n') : '');
    demo.notice = copied ? 'Boundary list copied.' : 'Clipboard unavailable.';
    render();
    return;
  }

  const worktreeDiffButton = event.target.closest('[data-action="worktree-diff"]');
  if (worktreeDiffButton) {
    runBranchDiff(worktreeDiffButton.getAttribute('data-branch') || '');
    return;
  }

  const toggleQuickActionsButton = event.target.closest('[data-action="toggle-quick-actions"]');
  if (toggleQuickActionsButton) {
    const chatIndex = Number(toggleQuickActionsButton.getAttribute('data-chat-index') || '0');
    const samePicker = demo.pickerChatIndex === chatIndex && demo.quickActionsOpen;
    closeComposerPopovers();
    demo.pickerChatIndex = chatIndex;
    demo.quickActionsOpen = !samePicker;
    render();
    return;
  }

  const flipTrigger = event.target.closest('[data-action="flip-discover"]');
  if (flipTrigger) {
    const flipCard = flipTrigger.closest('[data-flip-card]');
    if (flipCard && !flipCard.classList.contains('is-flipped')) {
      flipCard.classList.add('is-flipped');
      const flipId = flipCard.getAttribute('data-flip-id');
      if (flipId) demo.flippedCards[flipId] = true;
    }
    return;
  }

  const revealAllButton = event.target.closest('[data-action="discover-reveal-all"]');
  if (revealAllButton) {
    document.querySelectorAll('.vr-discover-grid [data-flip-card]:not(.is-flipped)').forEach((flipCard, index) => {
      const flipId = flipCard.getAttribute('data-flip-id');
      if (flipId) demo.flippedCards[flipId] = true;
      window.setTimeout(() => flipCard.classList.add('is-flipped'), index * 140);
    });
    return;
  }

  const discoverDoneButton = event.target.closest('[data-action="discover-done"]');
  if (discoverDoneButton) {
    demo.activeModal = null;
    demo.notice = 'Your cards are on the table — click one in the deck to run its checks.';
    render();
    return;
  }

  const quickstartDismissButton = event.target.closest('[data-action="quickstart-dismiss"]');
  if (quickstartDismissButton) {
    try { window.localStorage.setItem('vrOnboarded', '1'); } catch { /* ignore */ }
    demo.activeModal = null;
    try {
      if (!window.localStorage.getItem('vrPackOpened') && providers.some((provider) => provider.state !== 'not_detected')) {
        window.localStorage.setItem('vrPackOpened', '1');
        demo.activeModal = 'discover';
      }
    } catch { /* ignore */ }
    render();
    return;
  }

  const quickstartGoButton = event.target.closest('[data-action="quickstart-go"]');
  if (quickstartGoButton) {
    const stepKind = quickstartGoButton.getAttribute('data-step');
    demo.activeModal = null;
    if (stepKind === 'map') {
      demo.activeStudioTab = 'architecture';
      demo.archVisited = true;
      loadArchitectureMap();
      demo.notice = 'This is your product as a live map. Weak boundaries glow — click one.';
    } else if (stepKind === 'fix') {
      demo.activeStudioTab = 'chat';
      demo.pickerChatIndex = 0;
      runChatTask('fix');
      return;
    } else {
      demo.activeStudioTab = 'terminal';
      demo.activeNavId = 'agents';
      selectTerminalCli(demo.selectedCliId || 'codex');
      demo.notice = 'Step 1: run the install command. Step 2: sign in. Step 3: hit Test connection — then you are live.';
      return;
    }
    render();
    return;
  }

  const openWorktreeButton = event.target.closest('[data-action="open-worktree"]');
  if (openWorktreeButton) {
    demo.activeStudioTab = 'worktree';
    loadWorktree();
    demo.notice = 'Worktree opened in the inspector.';
    render();
    return;
  }

  const worktreeReviewButton = event.target.closest('[data-action="worktree-review"]');
  if (worktreeReviewButton) {
    const branchName = worktreeReviewButton.getAttribute('data-branch') || '';
    const defaultBranch = (demo.worktree && demo.worktree.defaultBranch) || 'main';
    const chat = chatContext(0);
    chat.draft = branchName === defaultBranch
      ? 'Give me a plain-language health report of ' + defaultBranch + ': what shipped recently, what unmerged branches exist, and what I should do next. Keep it simple.'
      : 'Explain branch \\'' + branchName + '\\' in plain language: what was built there, how it differs from ' + defaultBranch + ', whether it is safe to merge, and what to check first. Keep it simple — no raw diffs.';
    demo.pickerChatIndex = 0;
    demo.activeModal = null;
    demo.activeStudioTab = 'chat';
    demo.notice = 'Branch review for ' + branchName + ' ready in chat. Review and send.';
    render();
    const reviewInput = app.querySelector('[data-chat-input="0"]');
    if (reviewInput && typeof reviewInput.focus === 'function') reviewInput.focus();
    return;
  }

  const worktreeCommitButton = event.target.closest('[data-action="worktree-commit"]');
  if (worktreeCommitButton) {
    const chat = chatContext(0);
    const count = (demo.worktree && demo.worktree.dirtyCount) || 0;
    chat.draft = 'There are ' + count + ' uncommitted changes in this repo. Review them with git status and git diff, group them into clean commits with clear messages, and commit. Do not push.';
    demo.pickerChatIndex = 0;
    demo.activeModal = null;
    demo.activeStudioTab = 'chat';
    demo.notice = 'Commit mission ready in chat. Review and send.';
    render();
    const commitInput = app.querySelector('[data-chat-input="0"]');
    if (commitInput && typeof commitInput.focus === 'function') commitInput.focus();
    return;
  }

  const worktreeBranchButton = event.target.closest('[data-action="worktree-branch"]');
  if (worktreeBranchButton) {
    const branchName = worktreeBranchButton.getAttribute('data-branch') || '';
    const isCurrent = worktreeBranchButton.getAttribute('data-current') === '1';
    const defaultBranch = (demo.worktree && demo.worktree.defaultBranch) || 'main';
    const chat = chatContext(0);
    chat.draft = isCurrent
      ? 'Summarize the state of branch \\'' + branchName + '\\' versus ' + defaultBranch + ': commits ahead/behind, what changed, and whether it is safe to merge. Do not push.'
      : 'Review branch \\'' + branchName + '\\' against ' + defaultBranch + ': summarize the diff, then merge it into ' + defaultBranch + ' safely. Stop and report if there are conflicts or failing checks. Do not push without telling me.';
    demo.pickerChatIndex = 0;
    demo.activeStudioTab = 'chat';
    demo.notice = (isCurrent ? 'Branch review' : 'Merge mission') + ' for ' + branchName + ' ready in chat. Review and send.';
    render();
    const branchInput = app.querySelector('[data-chat-input="0"]');
    if (branchInput && typeof branchInput.focus === 'function') branchInput.focus();
    return;
  }

  const archPresetButton = event.target.closest('[data-action="arch-preset"]');
  if (archPresetButton) {
    const chat = chatContext(0);
    chat.draft = archPresetButton.getAttribute('data-prompt') || '';
    demo.pickerChatIndex = 0;
    demo.archDrawer = null;
    demo.activeStudioTab = 'chat';
    demo.notice = 'Mission ready in chat with boundary context. Review and send.';
    render();
    const presetInput = app.querySelector('[data-chat-input="0"]');
    if (presetInput && typeof presetInput.focus === 'function') presetInput.focus();
    return;
  }

  const archNodeAskButton = event.target.closest('[data-action="arch-node-ask"]');
  if (archNodeAskButton) {
    const boundary = archNodeAskButton.getAttribute('data-node-label') || 'this boundary';
    const chat = chatContext(0);
    chat.draft = 'Focus on ' + boundary + ' in this repo. Read .viberaven/architecture-map.md for the structure, list the production risks on that boundary with file evidence, and apply the smallest safe fix.';
    demo.pickerChatIndex = 0;
    demo.activeStudioTab = 'chat';
    demo.notice = 'Boundary mission ready in chat. Review and send.';
    render();
    const nodeInput = app.querySelector('[data-chat-input="0"]');
    if (nodeInput && typeof nodeInput.focus === 'function') nodeInput.focus();
    return;
  }

  const archCopyButton = event.target.closest('[data-action="arch-copy-map"]');
  if (archCopyButton) {
    const copied = await copyText((demo.architectureMap && demo.architectureMap.markdown) || '');
    demo.notice = copied ? 'Architecture map copied as markdown.' : 'Clipboard unavailable — the map lives at .viberaven/architecture-map.md.';
    render();
    return;
  }

  const archFixWeakestButton = event.target.closest('[data-action="arch-fix-weakest"]');
  if (archFixWeakestButton) {
    const chat = chatContext(0);
    chat.draft = 'Read .viberaven/architecture-map.md and .viberaven/agent-tasklist.md. Identify the weakest architecture boundary (pages, API, data, or a provider), apply the smallest safe repo fix for it, and tell me exactly what to verify after.';
    demo.pickerChatIndex = 0;
    demo.activeStudioTab = 'chat';
    demo.notice = 'Weakest-boundary mission ready in chat. Review and send.';
    render();
    const weakInput = app.querySelector('[data-chat-input="0"]');
    if (weakInput && typeof weakInput.focus === 'function') weakInput.focus();
    return;
  }

  const archNodeCard = event.target.closest('[data-arch-node]');
  if (archNodeCard && !archNodeCard.getAttribute('data-provider') && !archNodeCard.classList.contains('is-card')) {
    demo.archDrawer = archNodeCard.getAttribute('data-arch-node');
    render();
    return;
  }

  const architectureToChatButton = event.target.closest('[data-action="architecture-to-chat"]');
  if (architectureToChatButton) {
    const chat = chatContext(0);
    if (!String(chat.draft || '').trim()) {
      chat.draft = 'Read .viberaven/architecture-map.md and propose the next architecture improvement: which boundary is weakest (pages, API, data, providers), what one change makes it production-stronger, and what to verify after.';
    }
    demo.pickerChatIndex = 0;
    demo.activeStudioTab = 'chat';
    demo.notice = 'Architecture context ready in chat. Review the mission and send.';
    render();
    const archInput = app.querySelector('[data-chat-input="0"]');
    if (archInput && typeof archInput.focus === 'function') archInput.focus();
    return;
  }

  const askReleaseButton = event.target.closest('[data-action="ask-release-agent"]');
  if (askReleaseButton) {
    const releaseId = askReleaseButton.getAttribute('data-release');
    const release = releases.find((item) => item.id === releaseId);
    const chat = chatContext(0);
    if (releaseId) chat.releaseId = releaseId;
    if (release && !String(chat.draft || '').trim()) {
      chat.draft = 'What changed in ' + release.label + ' compared to the previous release? Summarize provider, migration, and env risk, and tell me what to verify before promoting.';
    }
    demo.pickerChatIndex = 0;
    demo.activeModal = null;
    demo.activeStudioTab = 'chat';
    demo.notice = release ? release.label + ' attached to the mission chat. Review the prompt and send.' : 'Release context attached to the mission chat.';
    render();
    const chatInput = app.querySelector('[data-chat-input="0"]');
    if (chatInput && typeof chatInput.focus === 'function') chatInput.focus();
    return;
  }

  const connectActionButton = event.target.closest('[data-action="run-cli-install"], [data-action="run-cli-signin"], [data-action="open-os-terminal"], [data-action="test-cli-connection"], [data-action="copy-cli-command"], [data-action="terminal-select-cli"], [data-action="terminal-shell-run"], [data-action="connect-complete-chat"], [data-action="reset-cli-connect"]');
  if (connectActionButton) {
    const action = connectActionButton.getAttribute('data-action');
    const agentId = connectActionButton.getAttribute('data-cli-agent') || demo.cliConnectTargetId || 'codex';
    const chatIndex = Number(connectActionButton.getAttribute('data-chat-index') || demo.pickerChatIndex || 0);
    if (action === 'terminal-select-cli') {
      selectTerminalCli(agentId);
      return;
    }
    if (action === 'terminal-shell-run') {
      const shellInput = app.querySelector('[data-terminal-shell-input]');
      const command = String((shellInput && 'value' in shellInput ? shellInput.value : demo.cliTerminalDraft) || '').trim();
      demo.cliTerminalDraft = command;
      await runStudioShellCommand(command, undefined, terminalTargetId());
      if (shellInput && 'value' in shellInput) shellInput.value = '';
      demo.cliTerminalDraft = '';
      return;
    }
    if (action === 'connect-complete-chat') {
      demo.activeModal = null;
      demo.activeStudioTab = 'chat';
      demo.cliConnectTargetId = null;
      demo.cliProbeStatus = 'idle';
      demo.cliProbeMessage = '';
      demo.notice = (cliAgents.find((item) => item.id === agentId)?.label || agentId) + ' ready for chat missions.';
      render();
      return;
    }
    if (action === 'reset-cli-connect') {
      const mode = connectActionButton.getAttribute('data-reset-mode') || 'soft';
      resetCliConnectFlow({ fullReset: mode === 'full', keepLog: mode !== 'full' });
      if (mode === 'full') {
        await hydrateCliAgents({ forceFresh: true });
      }
      demo.activeStudioTab = mode === 'full' ? 'chat' : 'terminal';
      demo.notice = mode === 'full' ? 'Connect flow fully reset. First-time setup is visible again.' : 'Connect flow reset. Terminal log cleared.';
      render();
      return;
    }
    if (action === 'copy-cli-command') {
      const command = connectActionButton.getAttribute('data-cli-command') || '';
      const copied = command ? await copyText(command) : false;
      demo.notice = copied ? 'CLI command copied. Run it in your terminal, then test the connection.' : 'Copy the command manually if clipboard access is blocked.';
      render();
      return;
    }
    if (action === 'run-cli-install') {
      await runCliInstall(agentId, chatIndex);
      return;
    }
    if (action === 'run-cli-signin') {
      await runCliSignInInStudio(agentId, chatIndex);
      return;
    }
    if (action === 'open-os-terminal') {
      await openCliOsTerminal(agentId, chatIndex);
      return;
    }
    if (action === 'test-cli-connection') {
      const currentTarget = terminalTargetId();
      if (demo.cliProbeStatus === 'success' && currentTarget === agentId) {
        demo.cliConnectCompleteAgentId = agentId;
        demo.activeModal = 'connect-complete';
        render();
        return;
      }
      await probeCliConnection(agentId, chatIndex, true);
      return;
    }
  }

  const cliButton = event.target.closest('[data-cli-agent]:not([data-action])');
  if (cliButton) {
    const chatIndex = Number(cliButton.getAttribute('data-chat-index') || String(demo.pickerChatIndex || 0));
    const chat = chatContext(chatIndex);
    const agentId = cliButton.getAttribute('data-cli-agent');
    if (cliButton.getAttribute('data-connected') === 'false') {
      if (agentId && demo.cliSessionReady[agentId] === true) {
        const restored = await silentProbeCliConnection(agentId, chatIndex);
        if (restored) {
          demo.pickerChatIndex = chatIndex;
          demo.notice = (cliAgents.find((item) => item.id === agentId)?.label || agentId) + ' is connected and ready.';
          render();
          return;
        }
      }
      demo.modelMenuOpen = false;
      demo.reasoningMenuOpen = false;
      demo.contextMenuOpen = false;
      demo.accessMenuOpen = false;
      demo.cliProbeStatus = 'idle';
      demo.cliProbeMessage = '';
      demo.pickerChatIndex = chatIndex;
      demo.notice = 'Follow install and sign-in in the Terminal tab for ' + (cliButton.querySelector('strong')?.textContent || agentId) + '.';
      selectTerminalCli(agentId);
      return;
    }
    chat.cliId = cliButton.getAttribute('data-cli-agent');
    demo.cliConnectTargetId = null;
    demo.cliLastConnectTargetId = null;
    demo.cliProbeStatus = 'idle';
    demo.cliProbeMessage = '';
    if (!demo.cliSetupComplete) {
      markCliSetupComplete(chat.cliId, chatIndex);
    } else {
      demo.selectedCliId = chat.cliId;
      demo.cliConnected = true;
      const models = cliModels[chat.cliId] || cliModels.codex;
      chat.modelId = normalizeModelId(models[0]);
      demo.selectedModelId = chat.modelId;
    }
    demo.activeStudioTab = chat.cliId === 'terminal' ? 'terminal' : 'chat';
    demo.activeNavId = 'agents';
    demo.pickerChatIndex = chatIndex;
    demo.modelMenuOpen = false;
    demo.reasoningMenuOpen = false;
    demo.contextMenuOpen = false;
    demo.accessMenuOpen = false;
    demo.notice = (cliAgents.find((item) => item.id === chat.cliId)?.label || chat.cliId) + ' selected for this chat.';
    render();
    return;
  }

  const modelButton = event.target.closest('[data-model]');
  if (modelButton) {
    event.preventDefault();
    const chatIndex = Number(modelButton.getAttribute('data-chat-index') || String(demo.pickerChatIndex || 0));
    const chat = chatContext(chatIndex);
    chat.modelId = modelButton.getAttribute('data-model');
    demo.selectedModelId = chat.modelId;
    demo.selectedCliId = chat.cliId;
    demo.cliConnected = true;
    demo.modelMenuOpen = false;
    demo.reasoningMenuOpen = false;
    demo.contextMenuOpen = false;
    demo.accessMenuOpen = false;
    demo.activeStudioTab = 'chat';
    demo.pickerChatIndex = chatIndex;
    demo.notice = selectedModelLabel(chatIndex) + ' selected for this chat.';
    refreshPickerMenus();
    refreshBottomTip();
    return;
  }

  const reasoningButton = event.target.closest('[data-reasoning]');
  if (reasoningButton) {
    event.preventDefault();
    const chatIndex = Number(reasoningButton.getAttribute('data-chat-index') || String(demo.pickerChatIndex || 0));
    const chat = chatContext(chatIndex);
    chat.reasoning = reasoningButton.getAttribute('data-reasoning');
    demo.selectedReasoning = chat.reasoning;
    demo.reasoningMenuOpen = false;
    demo.modelMenuOpen = false;
    demo.contextMenuOpen = false;
    demo.scopeMenuOpen = false;
    demo.contextTrayOpen = false;
    demo.quickActionsOpen = false;
    demo.accessMenuOpen = false;
    demo.activeStudioTab = 'chat';
    demo.pickerChatIndex = chatIndex;
    demo.notice = chat.reasoning + ' reasoning selected for this chat.';
    refreshPickerMenus();
    refreshBottomTip();
    return;
  }

  const contextButton = event.target.closest('[data-context]');
  if (contextButton) {
    event.preventDefault();
    const chatIndex = Number(contextButton.getAttribute('data-chat-index') || String(demo.pickerChatIndex || 0));
    const chat = chatContext(chatIndex);
    chat.context = contextButton.getAttribute('data-context');
    demo.selectedContext = chat.context;
    demo.contextMenuOpen = false;
    demo.scopeMenuOpen = false;
    demo.contextTrayOpen = false;
    demo.quickActionsOpen = false;
    demo.modelMenuOpen = false;
    demo.reasoningMenuOpen = false;
    demo.accessMenuOpen = false;
    demo.activeStudioTab = 'chat';
    demo.pickerChatIndex = chatIndex;
    demo.notice = chat.context + ' context selected for this chat.';
    render();
    refreshBottomTip();
    return;
  }

  const accessButton = event.target.closest('[data-access-mode]');
  if (accessButton) {
    event.preventDefault();
    const chatIndex = Number(accessButton.getAttribute('data-chat-index') || String(demo.pickerChatIndex || 0));
    const chat = chatContext(chatIndex);
    const selected = accessModes.find((mode) => mode.id === accessButton.getAttribute('data-access-mode')) || accessModes[1];
    chat.accessMode = selected.id;
    demo.selectedAccessMode = selected.id;
    demo.accessMenuOpen = false;
    demo.contextMenuOpen = false;
    demo.scopeMenuOpen = false;
    demo.contextTrayOpen = false;
    demo.quickActionsOpen = false;
    demo.modelMenuOpen = false;
    demo.reasoningMenuOpen = false;
    demo.activeStudioTab = 'chat';
    demo.pickerChatIndex = chatIndex;
    demo.notice = selected.label + ' selected for this chat.';
    refreshPickerMenus();
    refreshBottomTip();
    return;
  }

  const stageButton = event.target.closest('[data-stage-step]');
  if (stageButton) {
    const stage = stageButton.getAttribute('data-stage-step');
    demo.activeStepId = stage;
    demo.modelMenuOpen = false;
    demo.reasoningMenuOpen = false;
    demo.contextMenuOpen = false;
    demo.accessMenuOpen = false;
    if (stage === 'provider') {
      demo.activeStudioTab = 'chat';
      demo.providerPickerOpen = true;
      demo.notice = 'Provider Proof selected. Drag a provider into chat or open a stack slot.';
    } else if (stage === 'agent') {
      demo.activeStudioTab = 'chat';
      demo.providerPickerOpen = false;
      demo.notice = 'Agent Fix selected. Use chat actions to plan, fix, verify, or inspect provider proof.';
    } else if (stage === 'verify') {
      demo.activeStudioTab = 'terminal';
      demo.providerPickerOpen = false;
      demo.notice = 'Verify selected. Run verification from the chat, agent panel, or terminal view.';
    } else if (stage === 'clear') {
      demo.activeStudioTab = 'diff';
      demo.providerPickerOpen = false;
      demo.verified = true;
      demo.agentFixing = false;
      demo.notice = 'Clear selected. Review the verified diff and release state.';
    }
    render();
    return;
  }

  const contextProviderButton = event.target.closest('[data-context-provider]');
  if (contextProviderButton) {
    const chatIndex = Number(contextProviderButton.getAttribute('data-chat-index') || String(demo.pickerChatIndex || 0));
    const providerId = contextProviderButton.getAttribute('data-context-provider');
    const provider = providers.find((item) => item.id === providerId);
    const chat = chatContext(chatIndex);
    chat.providerId = providerId;
    demo.selectedProviderId = providerId;
    demo.pickerChatIndex = chatIndex;
    demo.contextTrayOpen = false;
    demo.dropActive = false;
    demo.notice = provider ? provider.name + ' context attached to chat.' : 'Provider context attached.';
    if (chatIndex === 0) syncPrimaryContext();
    render();
    return;
  }

  const contextReleaseButton = event.target.closest('[data-context-release]');
  if (contextReleaseButton) {
    const chatIndex = Number(contextReleaseButton.getAttribute('data-chat-index') || String(demo.pickerChatIndex || 0));
    const releaseId = contextReleaseButton.getAttribute('data-context-release');
    const release = releases.find((item) => item.id === releaseId);
    const chat = chatContext(chatIndex);
    chat.releaseId = releaseId;
    demo.selectedReleaseId = releaseId;
    demo.pickerChatIndex = chatIndex;
    demo.contextTrayOpen = false;
    demo.dropActive = false;
    demo.notice = release ? release.label + ' attached to chat.' : 'Version context attached.';
    if (chatIndex === 0) syncPrimaryContext();
    render();
    return;
  }

  const chatsFlyoutButton = event.target.closest('[data-action="toggle-chats-flyout"]');
  if (chatsFlyoutButton) {
    demo.chatsFlyoutOpen = !demo.chatsFlyoutOpen;
    render();
    return;
  }

  const pickProviderButton = event.target.closest('[data-action="pick-provider"]');
  if (pickProviderButton) {
    const pickId = pickProviderButton.getAttribute('data-pick');
    const provider = providers.find((item) => item.id === pickId);
    if (provider) {
      const placedCount = Object.keys(demo.tablePlacements).length;
      demo.tablePlacements[pickId] = {
        x: placedCount % 2 === 0 ? 0.13 : 0.87,
        y: Math.min(0.55, 0.22 + Math.floor(placedCount / 2) * 0.16),
      };
      saveTablePlacements();
      demo.addProviderOpen = false;
      demo.connectCardId = pickId;
      demo.mcpConnectMessage = '';
      demo.notice = provider.name + ' placed on the table. Connect it — MCP context first, then the repo wiring.';
    }
    render();
    return;
  }

  const handToggleButton = event.target.closest('[data-action="toggle-hand"]');
  if (handToggleButton) {
    demo.handCollapsed = !demo.handCollapsed;
    render();
    return;
  }

  const unplaceChip = event.target.closest('[data-action="unplace-card"]');
  if (unplaceChip) {
    event.stopPropagation();
    const unplaceId = unplaceChip.getAttribute('data-unplace');
    if (unplaceId && demo.tablePlacements[unplaceId]) {
      delete demo.tablePlacements[unplaceId];
      saveTablePlacements();
      demo.notice = 'Card returned to your hand.';
      render();
    }
    return;
  }

  const fixItemButton = event.target.closest('[data-action="fix-provider-item"]');
  if (fixItemButton) {
    const providerId = fixItemButton.getAttribute('data-provider');
    const itemId = fixItemButton.getAttribute('data-item');
    const provider = providers.find((item) => item.id === providerId);
    const row = provider && Array.isArray(provider.launchPath)
      ? provider.launchPath.find((item) => item.id === itemId)
      : null;
    if (provider && row) {
      const chat = chatContext(Math.max(0, Math.min(demo.pickerChatIndex || 0, demo.activeChatCount - 1)));
      chat.providerId = provider.id;
      runChatTask('fix', 'Fix this ' + provider.name + ' launch check: "' + row.title + '"' +
        (row.shortReason ? ' (' + row.shortReason + ')' : '') +
        '. Make the minimal repo change, show me the diff, then re-check it.');
    }
    return;
  }

  const providerButton = event.target.closest('[data-provider]');
  if (providerButton) {
    const providerId = providerButton.getAttribute('data-provider');
    demo.activeNavId = 'providers';
    demo.activeStepId = 'provider';
    demo.providerPickerOpen = false;
    dealProviderCard(providerId);
    return;
  }

  const pileToggleButton = event.target.closest('[data-action="toggle-pile"]');
  if (pileToggleButton) {
    demo.pileCollapsed = !demo.pileCollapsed;
    render();
    return;
  }

  const pileShuffleButton = event.target.closest('[data-action="pile-shuffle"]');
  if (pileShuffleButton) {
    demo.pileOffset = ((demo.pileOffset || 0) + 1) % Math.max(1, releases.length);
    render();
    return;
  }

  const pileFrontButton = event.target.closest('[data-action="pile-front"]');
  if (pileFrontButton) {
    const frontId = pileFrontButton.getAttribute('data-release');
    const idx = releases.findIndex((item) => item.id === frontId);
    if (idx >= 0) demo.pileOffset = idx;
    render();
    return;
  }

  const releaseDiffButton = event.target.closest('[data-action="show-release-diff"]');
  if (releaseDiffButton) {
    const releaseId = releaseDiffButton.getAttribute('data-release');
    if (releaseId) demo.selectedReleaseId = releaseId;
    runReleaseCompare();
    return;
  }

  const explainReleaseButton = event.target.closest('[data-action="explain-release"]');
  if (explainReleaseButton) {
    const releaseId = explainReleaseButton.getAttribute('data-release');
    if (releaseId) demo.selectedReleaseId = releaseId;
    const pair = releaseComparePair();
    const chat = chatContext(Math.max(0, Math.min(demo.pickerChatIndex || 0, demo.activeChatCount - 1)));
    chat.releaseId = demo.selectedReleaseId;
    runChatTask('explain', 'Explain what changed between ' + pair.fromLabel + ' and ' + pair.toLabel + ' in plain words: what could break in production, and anything I must re-verify with providers before promoting.');
    return;
  }

  const releaseButton = event.target.closest('[data-release]');
  if (releaseButton) {
    const releaseId = releaseButton.getAttribute('data-release');
    demo.activeNavId = 'versions';
    dealReleaseCard(releaseId);
    return;
  }

  const navButton = event.target.closest('[data-nav-target]');
  if (navButton) {
    const target = navButton.getAttribute('data-nav-target');
    demo.activeNavId = target;
    const navActions = {
      launch: () => {
        resetLaunchPreview();
        demo.notice = 'New Launch starts at repo evidence, then moves through providers, agent fix, verify, and clear.';
      },
      flow: () => {
        demo.activeStepId = 'agent';
        demo.notice = 'Launch Flow shows the five-step production path.';
      },
      providers: () => {
        demo.activeStepId = 'provider';
        demo.providerPickerOpen = true;
        demo.notice = 'Providers are ready to inspect. Pick one connector to view proof and dashboard action.';
      },
      agents: () => {
        demo.activeStepId = 'agent';
        demo.notice = 'Agent view is focused. Start Agent Fix to preview the handoff.';
      },
      evidence: () => {
        demo.activeStepId = 'repo';
        demo.notice = 'Evidence view starts with repo proof before provider dashboards matter.';
      },
      versions: () => {
        demo.notice = 'Versions & Releases is focused. Select a release to compare launch proof.';
      },
      settings: () => {
        demo.notice = 'Settings will hold project, branch, and provider preferences.';
      },
      community: () => {
        demo.notice = 'Community links are live in the open-source card and bottom bar.';
      },
    };
    if (navActions[target]) navActions[target]();
    else demo.notice = navButton.textContent.trim().replace(/\\s+/g, ' ') + ' is active in this launch-control preview.';
    render();
    return;
  }

  const actionButton = event.target.closest('[data-action]');
  if (!actionButton) return;
  const action = actionButton.getAttribute('data-action');
  const actionChatIndex = Math.max(0, Math.min(Number(actionButton.getAttribute('data-chat-index') || actionButton.closest('.vr-chat-lane')?.getAttribute('data-chat-index') || demo.pickerChatIndex || 0) || 0, demo.activeChatCount - 1));
  if (action === 'close-modal') {
    demo.activeModal = null;
    demo.cliProbeStatus = 'idle';
    render();
    return;
  }
  if (action === 'copy-cli-command') {
    const command = actionButton.getAttribute('data-cli-command') || '';
    const copied = command ? await copyText(command) : false;
    demo.notice = copied ? 'CLI command copied. Run it in your terminal, then test the connection.' : 'Copy the command manually if clipboard access is blocked.';
    render();
    return;
  }
  if (action === 'run-cli-install') {
    const agentId = actionButton.getAttribute('data-cli-agent') || demo.cliConnectTargetId || 'codex';
    const chatIndex = Number(actionButton.getAttribute('data-chat-index') || demo.pickerChatIndex || 0);
    await runCliInstall(agentId, chatIndex);
    return;
  }
  if (action === 'run-cli-signin') {
    const agentId = actionButton.getAttribute('data-cli-agent') || demo.cliConnectTargetId || 'codex';
    const chatIndex = Number(actionButton.getAttribute('data-chat-index') || demo.pickerChatIndex || 0);
    await runCliSignInInStudio(agentId, chatIndex);
    return;
  }
  if (action === 'open-os-terminal') {
    const agentId = actionButton.getAttribute('data-cli-agent') || demo.cliConnectTargetId || 'codex';
    const chatIndex = Number(actionButton.getAttribute('data-chat-index') || demo.pickerChatIndex || 0);
    await openCliOsTerminal(agentId, chatIndex);
    return;
  }
  if (action === 'terminal-select-cli') {
    selectTerminalCli(actionButton.getAttribute('data-cli-agent') || 'codex');
    return;
  }
  if (action === 'terminal-shell-run') {
    const shellInput = app.querySelector('[data-terminal-shell-input]');
    const command = String((shellInput && 'value' in shellInput ? shellInput.value : demo.cliTerminalDraft) || '').trim();
    demo.cliTerminalDraft = command;
    await runStudioShellCommand(command, undefined, terminalTargetId());
    if (shellInput && 'value' in shellInput) shellInput.value = '';
    demo.cliTerminalDraft = '';
    return;
  }
  if (action === 'connect-complete-chat') {
    const agentId = actionButton.getAttribute('data-cli-agent') || demo.cliConnectCompleteAgentId || demo.selectedCliId || 'codex';
    demo.activeModal = null;
    demo.activeStudioTab = 'chat';
    demo.cliConnectTargetId = null;
    demo.cliProbeStatus = 'idle';
    demo.cliProbeMessage = '';
    demo.notice = (cliAgents.find((item) => item.id === agentId)?.label || agentId) + ' ready for chat missions.';
    render();
    return;
  }
  if (action === 'reset-cli-connect') {
    const mode = actionButton.getAttribute('data-reset-mode') || 'soft';
    resetCliConnectFlow({ fullReset: mode === 'full', keepLog: mode !== 'full' });
    if (mode === 'full') {
      await hydrateCliAgents({ forceFresh: true });
    }
    demo.activeStudioTab = mode === 'full' ? 'chat' : 'terminal';
    demo.notice = mode === 'full' ? 'Connect flow fully reset. First-time setup is visible again.' : 'Connect flow reset. Terminal log cleared.';
    render();
    return;
  }
  if (action === 'test-cli-connection') {
    const agentId = actionButton.getAttribute('data-cli-agent') || terminalTargetId() || 'codex';
    const chatIndex = Number(actionButton.getAttribute('data-chat-index') || demo.pickerChatIndex || 0);
    const currentTarget = terminalTargetId();
    if (demo.cliProbeStatus === 'success' && currentTarget === agentId) {
      demo.cliConnectCompleteAgentId = agentId;
      demo.activeModal = 'connect-complete';
      render();
      return;
    }
    await probeCliConnection(agentId, chatIndex, true);
    return;
  }
  if (action === 'copy-prompt') {
    const copied = await copyText(agentPromptText());
    demo.notice = copied ? 'Agent mission ready. Keep the connected CLI scoped to the evidenced change.' : 'Mission is still visible; clipboard permission was not available.';
    render();
    return;
  }
  if (action === 'toggle-models') {
    event.preventDefault();
    const chatIndex = Number(actionButton.getAttribute('data-chat-index') || '0');
    const samePicker = demo.pickerChatIndex === chatIndex && demo.modelMenuOpen;
    demo.activeStudioTab = 'chat';
    closeComposerPopovers();
    demo.pickerChatIndex = chatIndex;
    demo.modelMenuOpen = !samePicker;
    refreshPickerMenus();
    return;
  }
  if (action === 'toggle-reasoning') {
    event.preventDefault();
    const chatIndex = Number(actionButton.getAttribute('data-chat-index') || '0');
    const samePicker = demo.pickerChatIndex === chatIndex && demo.reasoningMenuOpen;
    demo.activeStudioTab = 'chat';
    closeComposerPopovers();
    demo.pickerChatIndex = chatIndex;
    demo.reasoningMenuOpen = !samePicker;
    refreshPickerMenus();
    return;
  }
  if (action === 'toggle-scope-menu') {
    event.preventDefault();
    const chatIndex = Number(actionButton.getAttribute('data-chat-index') || '0');
    const samePicker = demo.pickerChatIndex === chatIndex && demo.scopeMenuOpen;
    demo.activeStudioTab = 'chat';
    closeComposerPopovers();
    demo.pickerChatIndex = chatIndex;
    demo.scopeMenuOpen = !samePicker;
    render();
    return;
  }
  if (action === 'toggle-context') {
    event.preventDefault();
    const chatIndex = Number(actionButton.getAttribute('data-chat-index') || '0');
    const samePicker = demo.pickerChatIndex === chatIndex && demo.contextMenuOpen;
    demo.activeStudioTab = 'chat';
    closeComposerPopovers();
    demo.pickerChatIndex = chatIndex;
    demo.contextMenuOpen = !samePicker;
    refreshPickerMenus();
    return;
  }
  if (action === 'toggle-access') {
    event.preventDefault();
    const chatIndex = Number(actionButton.getAttribute('data-chat-index') || '0');
    const samePicker = demo.pickerChatIndex === chatIndex && demo.accessMenuOpen;
    demo.activeStudioTab = 'chat';
    closeComposerPopovers();
    demo.pickerChatIndex = chatIndex;
    demo.accessMenuOpen = !samePicker;
    refreshPickerMenus();
    return;
  }
  if (action === 'remove-provider-context') {
    const chatIndex = Number(actionButton.getAttribute('data-chat-index') || '0');
    chatContext(chatIndex).providerId = null;
    if (chatIndex === 0) syncPrimaryContext();
    demo.dropActive = false;
    demo.notice = 'Provider context removed from this chat.';
    render();
    return;
  }
  if (action === 'remove-release-context') {
    const chatIndex = Number(actionButton.getAttribute('data-chat-index') || '0');
    chatContext(chatIndex).releaseId = null;
    if (chatIndex === 0) syncPrimaryContext();
    demo.dropActive = false;
    demo.notice = 'Version context removed from this chat.';
    render();
    return;
  }
  if (action === 'chat-agent-fix' || action === 'start-agent-fix') {
    demo.pickerChatIndex = actionChatIndex;
    runChatTask('fix');
    return;
  }
  if (action === 'verify-now') {
    demo.pickerChatIndex = actionChatIndex;
    runChatTask('verify');
    return;
  }
  if (action === 'recheck') {
    demo.pickerChatIndex = actionChatIndex;
    runChatTask('verify');
    return;
  }
  if (action === 'show-diff') {
    demo.pickerChatIndex = actionChatIndex;
    runChatTask('diff');
    return;
  }
  if (action === 'stop-agent') {
    clearChatTaskTimer();
    const stopChat = chatContext(actionChatIndex);
    if (laneHasActiveTask(stopChat)) {
      const stoppedTask = stopChat.activeTask;
      stopChat.messages.push({
        role: 'agent',
        text: 'Ready for the next safe action.',
        kind: stoppedTask.kind,
        isError: false,
        providerId: stoppedTask.providerId || null,
        releaseId: stoppedTask.releaseId || null,
        ts: Date.now(),
      });
      stopChat.activeTask = null;
    }
    demo.agentFixing = false;
    demo.activeStudioTab = 'chat';
    demo.notice = 'Agent stopped. No destructive command ran in this preview.';
    render();
    return;
  }
  if (action === 'send-chat-message') {
    const chatIndex = Number(actionButton.getAttribute('data-chat-index') || '0');
    sendChatInput(chatIndex);
    return;
  }
  if (action === 'terminal-send') {
    const chatIndex = Math.max(0, Math.min(demo.pickerChatIndex || 0, demo.activeChatCount - 1));
    const terminalInput = app.querySelector('[data-terminal-input]');
    const value = String((terminalInput && 'value' in terminalInput ? terminalInput.value : '') || '').trim();
    if (!value) {
      demo.notice = 'Type a terminal-safe mission first, then send it to chat.';
      render();
      return;
    }
    chatContext(chatIndex).draft = value;
    demo.activeStudioTab = 'chat';
    demo.notice = 'Terminal note moved into chat. Press send when ready.';
    render();
    return;
  }
  if (action === 'diff-to-chat') {
    const chatIndex = Math.max(0, Math.min(demo.pickerChatIndex || 0, demo.activeChatCount - 1));
    chatContext(chatIndex).draft = 'Explain this diff, identify production risk, and suggest the next safe verification step.';
    demo.activeStudioTab = 'chat';
    demo.notice = 'Diff question moved into chat.';
    render();
    return;
  }
  if (action === 'toggle-inspector-size') {
    demo.inspectorExpanded = !demo.inspectorExpanded;
    render();
    return;
  }
  if (action === 'add-chat') {
    demo.activeStudioTab = 'chat';
    demo.activeChatCount = 1;
    demo.activeRecentChatId = null;
    demo.fixPlanExpandedChatIndex = null;
    demo.droppedProviderId = null;
    demo.droppedReleaseId = null;
    demo.chatContexts = [defaultChatContext({ providerId: null, releaseId: null })];
    demo.pickerChatIndex = 0;
    demo.modelMenuOpen = false;
    demo.reasoningMenuOpen = false;
    demo.contextMenuOpen = false;
    demo.accessMenuOpen = false;
    demo.notice = 'New chat opened.';
    render();
    return;
  }
  if (action === 'new-chat') {
    demo.chatsFlyoutOpen = false;
    persistCurrentChatToRecent();
    demo.activeStudioTab = 'chat';
    demo.activeChatCount = 1;
    demo.activeRecentChatId = null;
    demo.fixPlanExpandedChatIndex = null;
    demo.chatContexts = [defaultChatContext({ providerId: null, releaseId: null })];
    demo.pickerChatIndex = 0;
    demo.dropActive = false;
    demo.dragKind = null;
    demo.dragProviderId = null;
    demo.dragReleaseId = null;
    demo.dragChatId = null;
    demo.agentFixing = false;
    demo.verified = false;
    clearChatTaskTimer();
    setDragUi(null);
    demo.notice = demo.cliSetupComplete ? 'New chat opened.' : 'New chat opened. Connect a CLI below to start.';
    render();
    return;
  }
  if (action === 'split-chat') {
    const lane0 = chatContext(0);
    const lane0Active = laneHasActiveTask(lane0);
    demo.activeStudioTab = 'chat';
    demo.activeChatCount = Math.min(4, demo.activeChatCount + 1);
    chatContext(demo.activeChatCount - 1);
    demo.pickerChatIndex = demo.activeChatCount - 1;
    demo.dropActive = false;
    demo.dragKind = null;
    demo.dragProviderId = null;
    demo.dragReleaseId = null;
    demo.dragChatId = null;
    if (!lane0Active) {
      demo.agentFixing = false;
      demo.verified = false;
    }
    setDragUi(null);
    demo.notice = 'New side-by-side mission chat opened. Drag a provider or version into that lane.';
    render();
    return;
  }
  if (action === 'view-all-chats') {
    demo.notice = 'Recent chats are local preview state. Open any chat or drag one into the workspace.';
    render();
    return;
  }
  if (action === 'close-chat') {
    const chatIndex = Number(actionButton.getAttribute('data-chat-index') || String(demo.activeChatCount - 1));
    if (chatIndex > 0) {
      const closing = chatContext(chatIndex);
      if (laneHasActiveTask(closing)) {
        clearChatTaskTimer();
        closing.activeTask = null;
      }
      if (demo.chatContexts.length > chatIndex) demo.chatContexts.splice(chatIndex, 1);
    }
    demo.activeChatCount = Math.max(1, demo.activeChatCount - 1);
    demo.pickerChatIndex = Math.min(demo.pickerChatIndex, demo.activeChatCount - 1);
    demo.activeStudioTab = 'chat';
    demo.notice = 'Extra mission chat closed.';
    render();
    return;
  }
  if (action === 'guide') {
    demo.pickerChatIndex = actionChatIndex;
    runChatTask('analyze');
    return;
  }
  if (action === 'go-live') {
    demo.pickerChatIndex = actionChatIndex;
    runChatTask('go-live');
    return;
  }
  if (action === 'prompt') {
    demo.activeNavId = 'agents';
    demo.activeStepId = 'agent';
    demo.providerPickerOpen = false;
    demo.activeModal = 'prompt';
    demo.notice = 'Agent mission is ready. Keep the fix scoped to the evidenced change.';
    render();
    return;
  }
  if (action === 'add-provider') {
    demo.addProviderOpen = !demo.addProviderOpen;
    if (demo.addProviderOpen) {
      demo.activeStudioTab = 'chat';
      demo.chatsFlyoutOpen = false;
    }
    render();
    return;
  }
  if (action === 'provider-proof') {
    demo.pickerChatIndex = actionChatIndex;
    runChatTask('provider');
    return;
  }
  if (action === 'plan') {
    demo.pickerChatIndex = actionChatIndex;
    runChatTask('plan');
    return;
  }
  if (action === 'view-fix-plan') {
    const chatIndex = Number(actionButton.getAttribute('data-chat-index') || String(actionChatIndex));
    demo.fixPlanExpandedChatIndex = demo.fixPlanExpandedChatIndex === chatIndex ? null : chatIndex;
    demo.pickerChatIndex = chatIndex;
    demo.notice = demo.fixPlanExpandedChatIndex === chatIndex ? 'Fix plan expanded in chat.' : 'Fix plan collapsed.';
    render();
    return;
  }
  if (action === 'connect-provider') {
    const providerId = actionButton.getAttribute('data-provider-id');
    const chatIndex = Number(actionButton.getAttribute('data-chat-index') || String(actionChatIndex));
    const provider = providers.find((item) => item.id === providerId);
    demo.pickerChatIndex = chatIndex;
    const lane = chatContext(chatIndex);
    lane.providerId = providerId;
    if (providerId) demo.selectedProviderId = providerId;
    runChatTask('provider');
    return;
  }
  if (action === 'mission-step') {
    const stepId = actionButton.getAttribute('data-step-id');
    const chatIndex = Number(actionButton.getAttribute('data-chat-index') || String(actionChatIndex));
    demo.pickerChatIndex = chatIndex;
    const steps = (missionCards && Array.isArray(missionCards.planSteps) ? missionCards.planSteps : []);
    const step = steps.find((item) => item.id === stepId);
    if (step) runChatTask('fix', step.title);
    return;
  }
  if (action === 'connect-mcp') {
    const mcpProviderId = actionButton.getAttribute('data-provider-id') || demo.selectedProviderId;
    if (mcpProviderId) connectProviderMcp(mcpProviderId);
    return;
  }
  if (action === 'close-connect-card') {
    demo.connectCardId = null;
    demo.mcpConnectMessage = '';
    render();
    return;
  }
  if (action === 'connect-provider-mission') {
    const missionProviderId = actionButton.getAttribute('data-provider-id') || demo.connectCardId;
    const missionProvider = providers.find((item) => item.id === missionProviderId);
    if (missionProvider) {
      const missionMcp = providerMcp(missionProvider);
      const needsMcpSetup = missionMcp.status !== 'connected' && missionMcp.available === false;
      const chat = chatContext(0);
      chat.providerId = missionProvider.id;
      chat.draft = 'Connect ' + missionProvider.name + ' to this app end to end: detect or install the SDK it needs, add missing env var placeholders to .env.example, wire the config in the repo, and run a safe verification.' +
        (needsMcpSetup ? ' Also look for an official ' + missionProvider.name + ' MCP server and, if one exists, add it to .mcp.json so future missions get live provider state.' : '') +
        ' Finish with the exact ' + missionProvider.name + ' dashboard steps that only I can do.';
      demo.connectCardId = null;
      demo.mcpConnectMessage = '';
      demo.activeStudioTab = 'chat';
      demo.pickerChatIndex = 0;
      demo.notice = missionProvider.name + ' connect mission staged — review and send.';
    }
    render();
    return;
  }
  if (action === 'add-context') {
    const chatIndex = Number(actionButton.getAttribute('data-chat-index') || String(actionChatIndex));
    const samePicker = demo.pickerChatIndex === chatIndex && demo.contextTrayOpen;
    demo.activeStudioTab = 'chat';
    closeComposerPopovers();
    demo.pickerChatIndex = chatIndex;
    demo.contextTrayOpen = !samePicker;
    demo.dropActive = demo.contextTrayOpen;
    demo.notice = demo.contextTrayOpen ? 'Choose a provider or version to attach, or drag it into the chat.' : 'Context tray closed.';
    render();
    return;
  }
  if (action === 'close-context-tray') {
    demo.contextTrayOpen = false;
    demo.dropActive = false;
    render();
    return;
  }
  if (action === 'terminal-tab') {
    demo.activeStudioTab = 'terminal';
    demo.notice = 'Terminal tab opened.';
    render();
    return;
  }
  if (action === 'compare' || action === 'show-release-diff') {
    runReleaseCompare();
    return;
  }
  if (action === 'changelog') {
    if (demo.activeStudioTab === 'versions') {
      runReleaseChangelog(false);
    } else {
      demo.activeStudioTab = 'versions';
      runReleaseChangelog(false);
    }
    return;
  }
  if (action === 'rollback-release') {
    runReleaseRollback();
    return;
  }
  const actionMessages = {
    notifications: 'Launch signals opened: blockers, provider proof, agent fix, and verification.',
    environment: 'Environment selector is scoped to the local Studio preview.',
    account: 'VibeRaven agent opened from the header mascot.',
    'all-releases': 'Release history view opens next; this preview keeps the timeline focused.',
    'explain-changes': 'Change summary opened with release-context wording.',
  };
  if (actionMessages[action]) {
    if (action === 'all-releases') {
      demo.activeStudioTab = 'versions';
      demo.activeModal = null;
      runReleaseChangelog(false);
      return;
    }
    if (action === 'notifications') demo.activeModal = 'notifications';
    if (action === 'explain-changes') {
      demo.pickerChatIndex = actionChatIndex;
      runChatTask('explain');
      return;
    }
    if (action === 'account') {
      demo.activeNavId = 'agents';
      demo.activeStepId = 'agent';
      demo.activeModal = 'agent';
    }
    demo.notice = actionMessages[action];
    render();
  }
});

app.addEventListener('pointerdown', (event) => {
  if (event.target && event.target.matches('[data-modal-backdrop]')) {
    demo.activeModal = null;
    render();
  }
});

app.addEventListener('input', (event) => {
  const input = event.target && event.target.closest ? event.target.closest('.vr-chat-input') : null;
  if (input) {
    const chatIndex = Number(input.getAttribute('data-chat-input') || '0');
    chatContext(chatIndex).draft = input.value || '';
    return;
  }
  const terminalInput = event.target && event.target.closest ? event.target.closest('[data-terminal-input]') : null;
  if (terminalInput) chatContext(demo.pickerChatIndex || 0).draft = terminalInput.value || '';
  const shellInput = event.target && event.target.closest ? event.target.closest('[data-terminal-shell-input]') : null;
  if (shellInput) demo.cliTerminalDraft = shellInput.value || '';
});

app.addEventListener('keydown', (event) => {
  const shellInput = event.target && event.target.closest ? event.target.closest('[data-terminal-shell-input]') : null;
  if (shellInput && event.key === 'Enter' && !event.shiftKey) {
    event.preventDefault();
    const command = String(shellInput.value || '').trim();
    if (!command) return;
    demo.cliTerminalDraft = command;
    runStudioShellCommand(command, undefined, terminalTargetId()).then(() => {
      shellInput.value = '';
      demo.cliTerminalDraft = '';
    });
    return;
  }
  const input = event.target && event.target.closest ? event.target.closest('.vr-chat-input') : null;
  if (!input || event.key !== 'Enter' || event.shiftKey) return;
  event.preventDefault();
  sendChatInput(input.getAttribute('data-chat-input') || '0');
});


function attachContextToChat(kind, id) {
  const chatIndex = Math.max(0, Math.min(demo.pickerChatIndex || 0, demo.activeChatCount - 1));
  const context = chatContext(chatIndex);
  if (kind === 'provider') {
    demo.selectedProviderId = id;
    context.providerId = id;
    const provider = providers.find((item) => item.id === id);
    demo.notice = provider ? provider.name + ' context attached to the chat.' : 'Provider context attached.';
  } else {
    demo.selectedReleaseId = id;
    context.releaseId = id;
    const release = releases.find((item) => item.id === id);
    demo.notice = release ? 'Version ' + release.label + ' attached to the chat.' : 'Version context attached.';
  }
  if (chatIndex === 0) syncPrimaryContext();
  render();
}

function playCardOnTable(kind, id, clientX, clientY, sectionEl) {
  const rect = sectionEl.getBoundingClientRect();
  const dropPos = {
    x: Math.max(0.04, Math.min(0.96, (clientX - rect.left) / Math.max(1, rect.width))),
    y: Math.max(0.06, Math.min(0.9, (clientY - rect.top) / Math.max(1, rect.height))),
  };
  const key = kind === 'release' ? 'rel:' + id : id;
  const alreadyPlaced = Boolean(demo.tablePlacements[key]);
  demo.tablePlacements[key] = dropPos;
  saveTablePlacements();
  if (alreadyPlaced) {
    render();
  } else if (kind === 'release') {
    dealReleaseCard(id);
  } else {
    dealProviderCard(id);
  }
}

let tableDragState = null;
let cardDragEndedAt = 0;

app.addEventListener('pointerdown', (event) => {
  if (event.button !== 0) return;
  if (event.target.closest('.vr-studio-architecture')) return;
  if (event.target.closest('[data-action="unplace-card"]')) return;
  const card = event.target.closest('.vr-hand-fan .vr-tcard, .vr-vpile-card, .vr-playmat .vr-tcard.is-placed, .vr-playmat .vr-vcard.is-placed');
  if (!card) return;
  const providerId = card.getAttribute('data-provider');
  const releaseId = card.getAttribute('data-release');
  if (!providerId && !releaseId) return;
  const rect = card.getBoundingClientRect();
  tableDragState = {
    kind: providerId ? 'provider' : 'release',
    id: providerId || releaseId,
    el: card,
    ghost: null,
    startX: event.clientX,
    startY: event.clientY,
    offsetX: event.clientX - rect.left,
    offsetY: event.clientY - rect.top,
    width: rect.width,
    height: rect.height,
    moved: false,
  };
});

app.addEventListener('pointermove', (event) => {
  if (!tableDragState) return;
  const dx = event.clientX - tableDragState.startX;
  const dy = event.clientY - tableDragState.startY;
  if (!tableDragState.moved && Math.abs(dx) + Math.abs(dy) < 7) return;
  if (!tableDragState.moved) {
    tableDragState.moved = true;
    const ghost = tableDragState.el.cloneNode(true);
    ghost.classList.add('vr-drag-ghost');
    ghost.classList.remove('is-placed', 'is-hand');
    ghost.style.width = tableDragState.width + 'px';
    ghost.style.height = tableDragState.height + 'px';
    document.body.appendChild(ghost);
    tableDragState.ghost = ghost;
    tableDragState.el.classList.add('is-drag-source');
  }
  if (tableDragState.ghost) {
    tableDragState.ghost.style.left = (event.clientX - tableDragState.offsetX) + 'px';
    tableDragState.ghost.style.top = (event.clientY - tableDragState.offsetY) + 'px';
  }
  const composer = document.elementFromPoint(event.clientX, event.clientY);
  const overComposer = composer && composer.closest && composer.closest('.vr-chat-composer');
  document.querySelectorAll('.vr-chat-composer.is-drop-active').forEach((el) => el.classList.remove('is-drop-active'));
  if (overComposer) overComposer.classList.add('is-drop-active');
});

app.addEventListener('pointerup', (event) => {
  if (!tableDragState) return;
  const state = tableDragState;
  tableDragState = null;
  document.querySelectorAll('.vr-chat-composer.is-drop-active').forEach((el) => el.classList.remove('is-drop-active'));
  if (state.ghost) state.ghost.remove();
  state.el.classList.remove('is-drag-source');
  if (!state.moved) return;
  cardDragEndedAt = Date.now();
  const under = document.elementFromPoint(event.clientX, event.clientY);
  if (!under) { render(); return; }
  const composer = under.closest && under.closest('.vr-chat-composer');
  if (composer) {
    attachContextToChat(state.kind, state.id);
    return;
  }
  const section = under.closest && under.closest('[data-table-drop]');
  if (section) {
    playCardOnTable(state.kind, state.id, event.clientX, event.clientY, section);
    return;
  }
  render();
});

app.addEventListener('click', (event) => {
  if (Date.now() - cardDragEndedAt < 400 && event.target.closest('.vr-tcard, .vr-vpile-card, .vr-vcard')) {
    event.stopPropagation();
    event.preventDefault();
  }
}, true);

let archDragState = null;
let archDragEndedAt = 0;

app.addEventListener('pointerdown', (event) => {
  if (event.button !== 0) return;
  const node = event.target.closest('.vr-studio-architecture.is-region-map .vr-arch-node');
  if (!node) return;
  const nodeId = node.getAttribute('data-arch-node');
  if (!nodeId || !demo.archGraph || !demo.archGraph.pos || !demo.archGraph.pos[nodeId]) return;
  archDragState = {
    id: nodeId,
    node,
    startX: event.clientX,
    startY: event.clientY,
    origin: { x: demo.archGraph.pos[nodeId].x, y: demo.archGraph.pos[nodeId].y },
    zoom: demo.archZoom || 1,
    moved: false,
  };
});

app.addEventListener('pointermove', (event) => {
  if (!archDragState) return;
  const dx = (event.clientX - archDragState.startX) / archDragState.zoom;
  const dy = (event.clientY - archDragState.startY) / archDragState.zoom;
  if (!archDragState.moved && Math.abs(dx) + Math.abs(dy) < 6) return;
  archDragState.moved = true;
  const x = Math.max(0, archDragState.origin.x + dx);
  const y = Math.max(0, archDragState.origin.y + dy);
  demo.archGraph.pos[archDragState.id] = { x, y };
  archDragState.node.style.transform = 'translate(' + x + 'px,' + y + 'px)';
  archDragState.node.classList.add('is-dragging');
  if (Array.isArray(demo.archGraph.edges)) {
    demo.archGraph.edges.forEach((edge) => {
      if (edge.from !== archDragState.id && edge.to !== archDragState.id) return;
      const pathEl = document.querySelector('[data-arch-edge="' + edge.from + ':' + edge.to + '"]');
      if (pathEl) pathEl.setAttribute('d', archEdgePath(demo.archGraph, edge));
    });
  }
});

app.addEventListener('pointerup', () => {
  if (!archDragState) return;
  const moved = archDragState.moved;
  archDragState.node.classList.remove('is-dragging');
  archDragState = null;
  if (moved) {
    archDragEndedAt = Date.now();
    saveArchLayout();
    render();
  }
});

app.addEventListener('click', (event) => {
  if (Date.now() - archDragEndedAt < 400 && event.target.closest('.vr-arch-node')) {
    event.stopPropagation();
    event.preventDefault();
  }
}, true);

app.addEventListener('dragstart', (event) => {
  if (event.target.closest && event.target.closest('.vr-studio-architecture.is-region-map')) {
    event.preventDefault();
    return;
  }
  const providerButton = event.target.closest('[data-provider]');
  const releaseButton = event.target.closest('[data-release]');
  const chatButton = event.target.closest('[data-chat-id]');
  if (providerButton) {
    const providerId = providerButton.getAttribute('data-provider');
    const provider = providers.find((item) => item.id === providerId);
    demo.dragKind = 'provider';
    demo.dragProviderId = providerId;
    demo.dragReleaseId = null;
    if (event.dataTransfer) {
      event.dataTransfer.setData('text/plain', 'provider:' + providerId);
      event.dataTransfer.setData('application/x-viberaven-provider', providerId);
      event.dataTransfer.effectAllowed = 'copyMove';
      event.dataTransfer.dropEffect = 'copy';
    }
    setDragChip(
      event,
      provider ? provider.name : 'Provider',
      provider ? provider.area : 'Drop into VibeRaven chat',
      provider ? (provider.iconHtml || '<img src="' + providerAssetSrc(provider) + '" alt="" />') : ''
    );
    providerButton.classList.add('is-being-dragged');
    demo.notice = 'Dragging a card. Drop it into the chat composer, or anywhere on the table to place it.';
    setDragUi('provider');
    return;
  }
  if (releaseButton) {
    const releaseId = releaseButton.getAttribute('data-release');
    const release = releases.find((item) => item.id === releaseId);
    demo.dragKind = 'release';
    demo.dragReleaseId = releaseId;
    demo.dragProviderId = null;
    if (event.dataTransfer) {
      event.dataTransfer.setData('text/plain', 'release:' + releaseId);
      event.dataTransfer.setData('application/x-viberaven-release', releaseId);
      event.dataTransfer.effectAllowed = 'copyMove';
      event.dataTransfer.dropEffect = 'copy';
    }
    setDragChip(event, release ? release.label : 'Release', 'Drop to compare in chat', contextIconChip('repo', 'input'));
    releaseButton.classList.add('is-being-dragged');
    demo.notice = 'Dragging version context. Drop it into chat to compare or prepare rollback.';
    setDragUi('release');
    return;
  }
  if (chatButton) {
    const chatId = chatButton.getAttribute('data-chat-id');
    demo.dragKind = 'chat';
    demo.dragChatId = chatId;
    if (event.dataTransfer) {
      event.dataTransfer.setData('text/plain', 'chat:' + chatId);
      event.dataTransfer.effectAllowed = 'copyMove';
      event.dataTransfer.dropEffect = 'copy';
    }
    setDragChip(event, 'Mission chat', 'Drop to split workspace');
    chatButton.classList.add('is-being-dragged');
    setDragUi('chat');
  }
});

app.addEventListener('dragover', (event) => {
  const dropTarget = event.target.closest('[data-chat-drop], [data-action="split-chat"], [data-table-drop]');
  if (!dropTarget) return;
  event.preventDefault();
  if (event.dataTransfer) event.dataTransfer.dropEffect = 'copy';
  demo.dropActive = true;
  dropTarget.classList.add('is-drop-active');
});

app.addEventListener('dragleave', (event) => {
  const dropTarget = event.target.closest('[data-chat-drop], [data-action="split-chat"]');
  if (!dropTarget) return;
  dropTarget.classList.remove('is-drop-active');
  demo.dropActive = false;
});

app.addEventListener('drop', (event) => {
  const newChatTarget = event.target.closest('[data-action="split-chat"]');
  const dropTarget = event.target.closest('[data-chat-drop]');
  const tableTarget = !newChatTarget && !dropTarget ? event.target.closest('[data-table-drop]') : null;
  if (tableTarget) {
    event.preventDefault();
    const droppedProviderId = event.dataTransfer?.getData('application/x-viberaven-provider') || (demo.dragKind === 'provider' ? demo.dragProviderId : '');
    const droppedReleaseId = event.dataTransfer?.getData('application/x-viberaven-release') || (demo.dragKind === 'release' ? demo.dragReleaseId : '');
    const rect = tableTarget.getBoundingClientRect();
    const dropPos = {
      x: Math.max(0.04, Math.min(0.96, (event.clientX - rect.left) / Math.max(1, rect.width))),
      y: Math.max(0.06, Math.min(0.9, (event.clientY - rect.top) / Math.max(1, rect.height))),
    };
    demo.dropActive = false;
    demo.dragKind = null;
    demo.dragProviderId = null;
    demo.dragReleaseId = null;
    if (droppedProviderId) {
      const alreadyPlaced = Boolean(demo.tablePlacements[droppedProviderId]);
      demo.tablePlacements[droppedProviderId] = dropPos;
      saveTablePlacements();
      if (alreadyPlaced) {
        render();
      } else {
        dealProviderCard(droppedProviderId);
      }
      return;
    }
    if (droppedReleaseId) {
      const releaseKey = 'rel:' + droppedReleaseId;
      const alreadyPlaced = Boolean(demo.tablePlacements[releaseKey]);
      demo.tablePlacements[releaseKey] = dropPos;
      saveTablePlacements();
      if (alreadyPlaced) {
        render();
      } else {
        dealReleaseCard(droppedReleaseId);
      }
      return;
    }
    render();
    return;
  }
  if (!newChatTarget && !dropTarget) return;
  event.preventDefault();
  (newChatTarget || dropTarget).classList.remove('is-drop-active');
  const targetLane = event.target.closest('.vr-chat-lane');
  const chatId = event.dataTransfer?.getData('text/plain').replace(/^chat:/, '') || (demo.dragKind === 'chat' ? demo.dragChatId : '');
  const isRecentChatDrop = Boolean(chatId && recentChats.some((chat) => chat.id === chatId));
  let newChatIndex = null;
  if (newChatTarget || isRecentChatDrop) {
    demo.activeChatCount = Math.min(4, demo.activeChatCount + 1);
    newChatIndex = demo.activeChatCount - 1;
    chatContext(newChatIndex);
  }
  const rawChatIndex = newChatIndex !== null ? String(newChatIndex) : (dropTarget?.getAttribute('data-chat-index') || targetLane?.getAttribute('data-chat-index') || '0');
  const chatIndex = Math.max(0, Math.min(Number(rawChatIndex) || 0, demo.activeChatCount - 1));
  const context = chatContext(chatIndex);
  const providerId = event.dataTransfer?.getData('application/x-viberaven-provider') || (demo.dragKind === 'provider' ? demo.dragProviderId : '');
  const releaseId = event.dataTransfer?.getData('application/x-viberaven-release') || (demo.dragKind === 'release' ? demo.dragReleaseId : '');
  if (isRecentChatDrop) {
    const recent = recentChats.find((chat) => chat.id === chatId);
    demo.activeRecentChatId = chatId;
    const restored = restoreRecentChat(recent);
    Object.assign(context, restored);
    demo.notice = recent ? recent.title + ' opened beside the active mission.' : 'Recent production chat opened beside the active mission.';
  }
  if (providerId) {
    demo.selectedProviderId = providerId;
    context.providerId = providerId;
    const provider = providers.find((item) => item.id === providerId);
    if (newChatTarget) demo.activeRecentChatId = null;
    if (chatIndex === 0) syncPrimaryContext();
    if (provider && provider.state === 'not_detected') {
      context.draft = 'Help me connect ' + provider.name + ' with context. What provider state, runtime behavior, or dashboard proof does this repo need?';
      demo.notice = provider.name + ' is missing — connect steps prefilled. Send when ready.';
    } else {
      demo.notice = provider ? provider.name + ' context attached to chat ' + String(chatIndex + 1) + '. Suggested actions updated for ' + (stackSlots[provider.id] || provider.area) + '.' : 'Provider context attached.';
    }
  }
  if (releaseId) {
    demo.selectedReleaseId = releaseId;
    context.releaseId = releaseId;
    const release = releases.find((item) => item.id === releaseId);
    if (newChatTarget) demo.activeRecentChatId = null;
    if (chatIndex === 0) syncPrimaryContext();
    demo.notice = release ? 'Version ' + release.label + ' attached to chat ' + String(chatIndex + 1) + '. Ask for compare, rollback, or provider changes.' : 'Version context attached.';
  }
  if (newChatTarget || isRecentChatDrop) demo.activeStudioTab = 'chat';
  demo.contextTrayOpen = false;
  demo.quickActionsOpen = false;
  demo.scopeMenuOpen = false;
  demo.dropActive = false;
  demo.dragKind = null;
  demo.dragProviderId = null;
  demo.dragReleaseId = null;
  demo.dragChatId = null;
  setDragUi(null);
  render();
});

app.addEventListener('dragend', () => {
  if (!demo.dragKind && !demo.dropActive) return;
  app.querySelectorAll('.is-being-dragged').forEach((item) => item.classList.remove('is-being-dragged'));
  demo.dragKind = null;
  demo.dragProviderId = null;
  demo.dragReleaseId = null;
  demo.dragChatId = null;
  demo.dropActive = false;
  setDragUi(null);
  render();
});

window.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && demo.addProviderOpen) {
    demo.addProviderOpen = false;
    render();
    return;
  }
  if (event.key === 'Escape' && demo.connectCardId) {
    demo.connectCardId = null;
    render();
    return;
  }
  if (event.key === 'Escape' && demo.chatsFlyoutOpen) {
    demo.chatsFlyoutOpen = false;
    render();
    return;
  }
  if (event.key === 'Escape' && !demo.activeModal && demo.activeStudioTab === 'architecture') {
    demo.activeStudioTab = 'chat';
    demo.notice = 'Back at the table.';
    render();
    return;
  }
  if (event.key === 'Escape' && demo.activeModal) {
    demo.activeModal = null;
    demo.notice = 'Panel closed. Continue from the launch flow.';
    render();
    return;
  }
  if (event.key === 'Escape' && (demo.quickActionsOpen || demo.contextTrayOpen || demo.scopeMenuOpen || demo.modelMenuOpen || demo.reasoningMenuOpen || demo.contextMenuOpen || demo.accessMenuOpen)) {
    closeComposerPopovers();
    render();
  }
});

app.addEventListener('scroll', (event) => {
  const target = event.target;
  if (target && target.classList && target.classList.contains('vr-chat-transcript')) {
    captureChatScroll(target);
  }
}, true);

loadRecentChats();
// Persistence: on refresh/reopen, restore the most recent chat so work is never lost.
try {
  const lastChat = recentChats[0];
  if (lastChat && Array.isArray(lastChat.messages) && lastChat.messages.length) {
    demo.activeRecentChatId = lastChat.id;
    demo.activeChatCount = 1;
    demo.chatContexts = [restoreRecentChat(lastChat)];
    syncDemoFromChatContext(demo.chatContexts[0]);
  }
} catch { /* restore is best-effort */ }
try {
  if (!window.localStorage.getItem('vrOnboarded') && !demo.activeRecentChatId && !currentState.empty && !demo.activeModal && window.location.search.indexOf('shot') < 0) {
    demo.activeModal = 'quickstart';
  } else if (
    !window.localStorage.getItem('vrPackOpened') && !currentState.empty && !demo.activeModal &&
    window.location.search.indexOf('shot') < 0 &&
    providers.some((provider) => provider.state !== 'not_detected')
  ) {
    window.localStorage.setItem('vrPackOpened', '1');
    demo.activeModal = 'discover';
  }
} catch { /* storage blocked */ }
render();
hydrateCliAgents();
loadGithubStats();
loadWorktree();

async function watchAutoScan() {
  if (!currentState.empty) return;
  const readStatus = async () => {
    const response = await fetch('/api/scan-status');
    if (!response.ok) throw new Error('scan-status ' + response.status);
    return response.json();
  };
  try {
    const status = await readStatus();
    if (status.state !== 'running') return;
    demo.notice = 'Mapping your product — running local production checks (offline, no login)…';
    render();
    const poll = window.setInterval(async () => {
      try {
        const next = await readStatus();
        if (next.state === 'done') {
          window.clearInterval(poll);
          window.location.reload();
        } else if (next.state === 'error') {
          window.clearInterval(poll);
          demo.notice = 'Local check failed: ' + (next.error || 'unknown error') + '. Run npx -y viberaven check in the terminal for details.';
          render();
        }
      } catch {
        window.clearInterval(poll);
      }
    }, 1500);
  } catch {
    // scan-status endpoint unavailable (older server); keep the manual flow
  }
}
watchAutoScan();
`;
